  // const colorMap = {

  //   "IceLattecherry": "#C86A6A",
  // "Espresso Cream": "#E7D7B8",
  // "Midnight Lilac": "#5C4B6B",
  //   "Espresso Mint": "#7A8C72",
  // "EspressoMatcha": "#8B8A5A",
  // "IceLattecherry": "#C86A6A",
  // "IceLatteMint": "#B8D4C2",
  // "Iced Matcha Latte": "#B6C99A",
  // "Latte Caramel": "#C68E52",
  // "Vanilla Latte": "#F3E5C3",
  // "Espresso": "#4B2E2B",
  // "Espresso Shot": "#2F1B14",
  // "Orange Zest": "#FF8C00",
  //   "Dark Roast": "#4A2C2A",
  // "Nitro Cold Brew": "#5A4A42",
  // "Rose White": "#F8F4F2",
  // "Silver Mocha": "#B8B3AA",
  // "Trippy": "#7B5FA7",
  // "Lavender": "#E6E6FA",
  // "Chocolate": "#7B3F00",
  // "Camel": "#C19A6B",
  //   "Dusty Blue": "#6E8FA3",
  //   "Espresso Kiwi Spin": "#5C4A3D",
  //   "Golden": "#D4AF37",
  //   "Iced Brew Twist": "#8B6F5A",
  //   "Iced Matcha": "#B7C99A",
  //   "Mauve Pink": "#D8A7B1",
  //   "Shadow Chrome": "#7A7F87",
  //   "Nude": "#E3C7B5",
  //   "Artic Cold Brew": "#A49A8A",
  //   "Blue-Mustard": "#6C7A2D",
  //   Beige: "#F5F5DC",
  //   Black: "#000000",
  //   Blue: "#0000FF",
  //   Brown: "#A52A2A",
  //   Burgundy: "#800020",
  //   Coral: "#FF7F50",
  //   Cream: "#FDFBD4",
  //   Green: "#008000",
  //   Grey: "#808080",
  //   Ivory: "#FFFFF0",
  //   Lime: "#00FF00",
  //   Maroon: "#800000",
  //   Mauve: "#E0B0FF",
  //   Mint: "#98FF98",
  //   Navy: "#000080",
  //   Olive: "#808000",
  //   Orange: "#FFA500",
  //   Peach: "#FFE5B4",
  //   Pink: "#FFC0CB",
  //   Pista: "#93C572",
  //   Purple: "#800080",
  //   Red: "#FF0000",
  //   Rust: "#B7410E",
  //   Teal: "#008080",
  //   Violet: "#8F00FF",
  //   White: "#FFFFFF",
  //   Wine: "#722F37",
  //   Yellow: "#FFFF00",
  //   Gold:   "#d4af37",
  //   "White Gold":"#e4e4e4",
  //   "Rose Gold" :"#c48a8a",
  //     "Dark Pink": "#E75480",
  //   "Dark Green": "#006400",
  //   Turquoise: "#40E0D0",
  //   "Light Blue": "#ADD8E6",
  //   "Light Pink": "#FFB6C1",
  //   "Burnt Orange": "#CC5500",
  //   "Magenta Pink": "#FF00AF",
  //   "Royal Blue": "#4169E1",
  //   "Off White": "#F8F0E3",
  
  //   // normalized keys
  //   "Multi Colour": "#CCCCCC",
  //   "OffWhite": "#F8F0E3",
  //   "Amazon Red": "#c2292c",
  //   "Artic White": "#FFFFFF",
  //   "Ash Mist": "#000000",
  //   "Baby Pink": "#FFC0CB",
  //   "Beige": "#EAD8AB",
  //   "Burgundy": "#b72846",
  //   "Cappuccino Brown": "#b6a689",
  //   "Carbon Black": "#2e2b2b",
  //   "Classic Black": "#000000",
  //   "Coral Red": "#F61F1F",
  //   "Crafty Pink": "#FFC0CB",
  //   "Curious Green": "#05AA3D",
  //   "Dove Grey": "#808080",
  //   "Electric Blue": "#005BD3",
  //   "Fern Mist": "#52a19b",
  //   "Krypton Blue": "#005BD3",
  //   "Lavender Mist": "#e4d8e6",
  //   "Light Blue": "#64aaff",
  //   "Magnetic Turquoise": "#40e0d0",
  //   "Mighty Black": "#000000",
  //   "Mint Frost": "#55a572",
  //   "Mocha Brown": "#433c30",
  //   "Mocha Frost": "#604527",
  //   "Mocha mist": "#7a6b56",
  //   "Monochrome Black": "#0d0d0d",
  //   "Monsoon Grey": "#808080",
  //   "Mustard Yellow": "#eac000",
  //   "Mystery Blue": "#13346e",
  //   "Noir": "#000000",
  //   "Passion Red": "#F61F1F",
  //   "Pastel Green": "#85a48b",
  //   "Pastel Lavender": "#d7b1ff",
  //   "pastel yellow": "#edf09a",
  //   "Pastel Yellow": "#FFE500",
  //   "Peach": "#ffb07c",
  //   "Pearl White": "#afaca3",
  //   "Pink": "#ff8fa3",
  //   "Quirky Grey": "#808080",
  //   "Rose Shadow": "#f0c4b9",
  //   "Royal Cherry": "#971a17",
  //   "Sage Mist": "#077f38",
  //   "Silver Lining": "#636361",
  //   "Sky Mist": "#6f8fb6",
  //   "Slate Grey": "#353736",
  //   "Stormy White": "#FFFFFF",
  //   "Tangy Purple": "#A54DCF",
  //   "Walnut Frost": "#b5a284",
  //   "White": "#FFFFFF",
  //   "WhiteOut": "#FFFFFF",
  //   "Olive Green": "#808000",
  //   "Lemon Green": "#9ACD32",
  //   "Tango Red": "#E63946",
  //   "Brown": "#A52A2A",
  //   "Mango Yellow": "#FFC324",
  //   "Maroon": "#800000",
  //   "Azure Blue": "#007FFF",
  //   "Earthy Tan": "#D2B48C",
  //   "Lavender Purple": "#967BB6",
  //   "Sea Green": "#2E8B57",
  //   "Black": "#000000",
  //   "Chocolate Brown": "#7B3F00",
  //   "Dark Grey": "#A9A9A9",
  //   "Jade Green": "#00A86B",
  //   "Mint Green": "#98FF98",
  //   "Sand": "#C2B280",
  //   "Black Sand": "#3B3B3B",
  //   "Canvas White": "#F8F4E3",
  //   "Carrot": "#ED9121",
  //   "Orange": "#FFA500",
  //   "Red Mist": "#C75D5D",
  //   "Tan": "#D2B48C"
  // };
  
  
  // function wizzySlugify(value) {
  //   return String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
  // }
  
  // function wizzyGetHandleFromAttributes(product) {
  //   if (product.handle) {
  //     return product.handle;
  //   }
  
  //   const attrs = product.attributes || [];
  //   const handleAttr = attrs.find(function (attr) {
  //     return attr.id === 'product_handle';
  //   });
  
  //   if (handleAttr && handleAttr.values && handleAttr.values[0] && handleAttr.values[0].value) {
  //     return handleAttr.values[0].value[0];
  //   }
  
  //   return '';
  // }
  
  // function wizzyGetTagsFromAttributes(product) {
  //   const attrs = product.attributes || [];
  //   const tagsAttr = attrs.find(function (attr) {
  //     return attr.id === 'product_tags';
  //   });
  
  //   if (!tagsAttr || !tagsAttr.values || !tagsAttr.values[0] || !tagsAttr.values[0].value) {
  //     return [];
  //   }
  
  //   const rawTags = tagsAttr.values[0].value[0];
  //   return String(rawTags)
  //     .split(',')
  //     .map(function (tag) {
  //       return tag.trim().toLowerCase();
  //     })
  //     .filter(Boolean);
  // }
  
  // function wizzyGetAttributeValue(product, attributeId) {
  //   const attrs = product.attributes || [];
  //   const match = attrs.find(function (attr) {
  //     return attr.id === attributeId;
  //   });
  
  //   if (!match || !match.values || !match.values[0] || !match.values[0].value) {
  //     return '';
  //   }
  
  //   return String(match.values[0].value[0] || '');
  // }
  
  // function wizzyProductHasNoSizeTag(product) {
  //   if (product.isNoSize === true) {
  //     return true;
  //   }
  
  //   const tags = wizzyGetTagsFromAttributes(product);
  
  //   if (tags.indexOf('nosize') !== -1) {
  //     return true;
  //   }
  
  //   if (tags.length) {
  //     return false;
  //   }
  
  //   const productType = wizzyGetAttributeValue(product, 'product_product_type').toLowerCase();
  //   return productType.indexOf('sock') !== -1;
  // }
  
  // function wizzyDeduplicateColorValues(colorValues, product) {
  //   if (!colorValues || !colorValues.length) {
  //     return [];
  //   }
  
  //   var grouped = {};
  //   var order = [];
  //   var currentColorValue = null;
  
  //   colorValues.forEach(function (entry) {
  //     var key = String(entry.value || '').trim().toLowerCase();
  //     if (!key) {
  //       return;
  //     }
  
  //     if (String(entry.variationId) === String(product.id)) {
  //       currentColorValue = key;
  //     }
  
  //     if (!grouped[key]) {
  //       grouped[key] = {
  //         value: entry.value,
  //         entries: []
  //       };
  //       order.push(key);
  //     }
  
  //     grouped[key].entries.push(entry);
  //   });
  
  //   return order.map(function (key) {
  //     var group = grouped[key];
  //     var entries = group.entries;
  //     var selectedEntry = null;
  //     var hasInStock = false;
  
  //     entries.forEach(function (entry) {
  //       if (entry.inStock !== false) {
  //         hasInStock = true;
  //         if (!selectedEntry) {
  //           selectedEntry = entry;
  //         }
  //       }
  //     });
  
  //     if (!selectedEntry) {
  //       selectedEntry = entries[0];
  //     }
  
  //     var color = {
  //       variationId: selectedEntry.variationId,
  //       inStock: hasInStock,
  //       value: group.value,
  //       image:
  //         selectedEntry.image ||
  //         selectedEntry.imageUrl ||
  //         selectedEntry.mainImage ||
  //         selectedEntry.variationImage ||
  //         selectedEntry.swatchImage ||
  //         null
  //     };
  
  //     if (currentColorValue) {
  //       color.isSelected = key === currentColorValue;
  //     } else {
  //       color.isSelected = String(color.variationId) === String(product.id);
  //     }
  
  //     return color;
  //   });
  // }
  
  // function wizzyPrepareSwatchesForTemplate(product) {
  //   product.handle = wizzyGetHandleFromAttributes(product) || product.handle || '';
  
  //   if (!product.swatches) {
  //     product.hasColorSwatches = false;
  //     return;
  //   }
  
  //   var swatchGroups = Array.isArray(product.swatches)
  //     ? product.swatches
  //     : Object.keys(product.swatches).map(function (key) {
  //         var group = product.swatches[key];
  //         group.key = group.key || key;
  //         return group;
  //       });
  
  //   product.swatches = swatchGroups.map(function (group) {
  //     if (group.key === 'colors' && group.values && group.values.length) {
  //       group.isColorGroup = true;
  //       group.handle = product.handle;
  //       group.productName = product.name || '';
  //       group.discountPercentage = product.discountPercentage;
  //       group.values = wizzyDeduplicateColorValues(group.values, product);
  //       group.values.forEach(function (value) {
  //         value.slug = wizzySlugify(value.value);
  
  //         if (!value.swatchValue) {
  //           var shopOrigin =
  //             window.Shopify && window.Shopify.shop
  //               ? 'https://' + window.Shopify.shop
  //               : window.location && window.location.origin
  //                 ? window.location.origin
  //                 : '';
  
  //           if (shopOrigin) {
  //             value.isVisualSwatch = true;
  //             value.isURLSwatch = true;
  //             value.swatchValue = shopOrigin + '/cdn/shop/files/' + value.slug + '_50x50.png';
  //           }
  //         }
  //       });
  //       group.showColorGrid = group.values.length > 1;
  //     }
  
  //     return group;
  //   });
  
  //   product.hasColorSwatches = product.swatches.some(function (group) {
  //     return group.isColorGroup && group.showColorGrid;
  //   });
  // }
  
  // var WIZZY_IMG_CACHE_STORAGE_KEY = 'wizzy-variant-image-cache-v1';
  // var WIZZY_IMG_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
  // var WIZZY_IMG_CACHE_MAX_ENTRIES = 300;
  // var wizzyImgCacheSaveTimer = null;
  
  // function wizzyGetCachedVariantImageUrls(cacheKey) {
  //   var entry = window.wizzyVariantImageCache[String(cacheKey)];
  
  //   if (!entry) {
  //     return null;
  //   }
  
  //   if (Array.isArray(entry)) {
  //     return entry.length ? entry : null;
  //   }
  
  //   if (entry.urls && entry.urls.length) {
  //     return entry.urls;
  //   }
  
  //   return null;
  // }
  
  // function wizzyLoadImageCacheFromStorage() {
  //   try {
  //     var raw = sessionStorage.getItem(WIZZY_IMG_CACHE_STORAGE_KEY);
  
  //     if (!raw) {
  //       return {};
  //     }
  
  //     var parsed = JSON.parse(raw);
  //     var entries = parsed && parsed.entries ? parsed.entries : parsed;
  //     var now = Date.now();
  //     var hydrated = {};
  
  //     if (!entries || typeof entries !== 'object') {
  //       return {};
  //     }
  
  //     Object.keys(entries).forEach(function (key) {
  //       if (key.indexOf('__pending') !== -1) {
  //         return;
  //       }
  
  //       var item = entries[key];
  //       var urls = null;
  //       var ts = 0;
  
  //       if (Array.isArray(item)) {
  //         urls = item;
  //         ts = now;
  //       } else if (item && Array.isArray(item.urls)) {
  //         urls = item.urls;
  //         ts = item.ts || 0;
  //       }
  
  //       if (!urls || !urls.length) {
  //         return;
  //       }
  
  //       if (ts && now - ts > WIZZY_IMG_CACHE_TTL_MS) {
  //         return;
  //       }
  
  //       hydrated[key] = {
  //         urls: urls,
  //         ts: ts || now
  //       };
  //     });
  
  //     return hydrated;
  //   } catch (error) {
  //     return {};
  //   }
  // }
  
  // function wizzyPruneImageCacheEntries(entries) {
  //   var keys = Object.keys(entries);
  
  //   if (keys.length <= WIZZY_IMG_CACHE_MAX_ENTRIES) {
  //     return entries;
  //   }
  
  //   keys.sort(function (a, b) {
  //     return (entries[a].ts || 0) - (entries[b].ts || 0);
  //   });
  
  //   var pruned = {};
  //   keys.slice(keys.length - WIZZY_IMG_CACHE_MAX_ENTRIES).forEach(function (key) {
  //     pruned[key] = entries[key];
  //   });
  
  //   return pruned;
  // }
  
  // function wizzySaveImageCacheToStorage() {
  //   try {
  //     var entries = {};
  
  //     Object.keys(window.wizzyVariantImageCache).forEach(function (key) {
  //       if (key.indexOf('__pending') !== -1) {
  //         return;
  //       }
  
  //       var urls = wizzyGetCachedVariantImageUrls(key);
  
  //       if (!urls || !urls.length) {
  //         return;
  //       }
  
  //       var existing = window.wizzyVariantImageCache[key];
  //       entries[key] = {
  //         urls: urls,
  //         ts: existing && existing.ts ? existing.ts : Date.now()
  //       };
  //     });
  
  //     entries = wizzyPruneImageCacheEntries(entries);
  
  //     sessionStorage.setItem(
  //       WIZZY_IMG_CACHE_STORAGE_KEY,
  //       JSON.stringify({
  //         v: 1,
  //         entries: entries
  //       })
  //     );
  
  //     Object.keys(window.wizzyVariantImageCache).forEach(function (key) {
  //       if (key.indexOf('__pending') !== -1) {
  //         return;
  //       }
  
  //       if (!entries[key]) {
  //         delete window.wizzyVariantImageCache[key];
  //       }
  //     });
  
  //     Object.keys(entries).forEach(function (key) {
  //       window.wizzyVariantImageCache[key] = entries[key];
  //     });
  //   } catch (error) {
  //     // Quota or private mode — keep in-memory cache only.
  //   }
  // }
  
  // function wizzyScheduleImageCacheSave() {
  //   if (wizzyImgCacheSaveTimer) {
  //     clearTimeout(wizzyImgCacheSaveTimer);
  //   }
  
  //   wizzyImgCacheSaveTimer = setTimeout(function () {
  //     wizzyImgCacheSaveTimer = null;
  //     wizzySaveImageCacheToStorage();
  //   }, 120);
  // }
  
  // function wizzySetVariantImageCache(cacheKey, urls) {
  //   if (!cacheKey || !urls || !urls.length) {
  //     return;
  //   }
  
  //   window.wizzyVariantImageCache[String(cacheKey)] = {
  //     urls: urls.slice(),
  //     ts: Date.now()
  //   };
  //   wizzyScheduleImageCacheSave();
  // }
  
  // window.wizzyVariantImageCache = Object.assign(
  //   {},
  //   wizzyLoadImageCacheFromStorage(),
  //   window.wizzyVariantImageCache || {}
  // );
  
  // function wizzyCollectProducts(data) {
  //   if (!data) {
  //     return [];
  //   }
  
  //   if (Array.isArray(data)) {
  //     return data;
  //   }
  
  //   if (data.id && (data.swatches || data.name)) {
  //     return [data];
  //   }
  
  //   if (data.products && data.products.length) {
  //     return data.products;
  //   }
  
  //   if (data.search && data.search.products && data.search.products.length) {
  //     return data.search.products;
  //   }
  
  //   if (data.response && data.response.products && data.response.products.length) {
  //     return data.response.products;
  //   }
  
  //   if (data.results && data.results.products && data.results.products.length) {
  //     return data.results.products;
  //   }
  
  //   return [];
  // }
  
  // function wizzyParseCardViewImageUrls(htmlText) {
  //   var html = new DOMParser().parseFromString(htmlText, 'text/html');
  //   var imgs = html.querySelectorAll('.product-images.grid-product__link img');
  //   var urls = [];
  
  //   imgs.forEach(function (img) {
  //     var src = img.getAttribute('src') || img.getAttribute('data-src');
  
  //     if (src) {
  //       urls.push(src);
  //     }
  //   });
  
  //   return urls;
  // }
  
  // window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
  // function wizzyHandleize(label) {
  //   return String(label || '')
  //     .toLowerCase()
  //     .trim()
  //     .replace(/['"]/g, '')
  //     .replace(/[^a-z0-9]+/g, '-')
  //     .replace(/^-+|-+$/g, '');
  // }
  
  // function wizzyGetAltFromImageUrl(imageUrl) {
  //   if (!imageUrl || typeof imageUrl !== 'string') {
  //     return '';
  //   }
  
  //   try {
  //     var url = new URL(imageUrl, window.location.origin);
  //     var alt = url.searchParams.get('alt') || '';
  //     return decodeURIComponent(alt).toLowerCase().trim();
  //   } catch (error) {
  //     var match = imageUrl.match(/[?&]alt=([^&]*)/i);
  //     if (!match) {
  //       return '';
  //     }
  
  //     try {
  //       return decodeURIComponent(match[1]).toLowerCase().trim();
  //     } catch (decodeError) {
  //       return String(match[1] || '').toLowerCase().trim();
  //     }
  //   }
  // }
  
  // function wizzyStripAltFromImageUrl(imageUrl) {
  //   if (!imageUrl || typeof imageUrl !== 'string') {
  //     return '';
  //   }
  
  //   try {
  //     var url = new URL(imageUrl, window.location.origin);
  //     url.searchParams.delete('alt');
  //     return url.toString();
  //   } catch (error) {
  //     return imageUrl
  //       .replace(/([?&])alt=[^&]*/i, '$1')
  //       .replace(/\?&/, '?')
  //       .replace(/[?&]$/, '');
  //   }
  // }
  
  // function wizzyImageAltMatchesColor(alt, colorHandle) {
  //   if (!alt || !colorHandle) {
  //     return false;
  //   }
  
  //   var key = String(colorHandle).toLowerCase();
  //   var clKey = 'cl-' + key;
  //   var normalizedAlt = String(alt).toLowerCase();
  
  //   return (
  //     normalizedAlt === key ||
  //     normalizedAlt.indexOf(key) !== -1 ||
  //     normalizedAlt.indexOf(clKey) !== -1
  //   );
  // }
  
  // function wizzyGetColorSwatchGroups(product) {
  //   if (!product || !product.swatches) {
  //     return [];
  //   }
  
  //   return Array.isArray(product.swatches)
  //     ? product.swatches
  //     : Object.keys(product.swatches).map(function (key) {
  //         return product.swatches[key];
  //       });
  // }
  
  // function wizzyGetSelectedColorEntry(product) {
  //   var groups = wizzyGetColorSwatchGroups(product);
  
  //   for (var i = 0; i < groups.length; i++) {
  //     var group = groups[i];
  
  //     if (group.key !== 'colors' || !group.values || !group.values.length) {
  //       continue;
  //     }
  
  //     for (var j = 0; j < group.values.length; j++) {
  //       if (group.values[j].isSelected) {
  //         return group.values[j];
  //       }
  //     }
  //   }
  
  //   return null;
  // }
  
  // function wizzyGetSelectedColorLabel(product) {
  //   var selected = wizzyGetSelectedColorEntry(product);
  
  //   if (!selected) {
  //     return '';
  //   }
  
  //   return selected.value || selected.label || selected.slug || '';
  // }
  
  // function wizzyNormalizeImageList(images) {
  //   if (!images) {
  //     return [];
  //   }
  
  //   if (!Array.isArray(images)) {
  //     return [String(images)];
  //   }
  
  //   return images
  //     .map(function (item) {
  //       if (!item) {
  //         return '';
  //       }
  
  //       if (typeof item === 'string') {
  //         return item;
  //       }
  
  //       return item.url || item.src || item.image || '';
  //     })
  //     .filter(Boolean);
  // }
  
  // function wizzyFilterImagesByColorAlt(images, colorLabel) {
  //   return wizzyGetOrderedColorImages(images, colorLabel);
  // }
  
  // function wizzyGetOrderedColorImages(images, colorLabel) {
  //   var colorHandle = wizzyHandleize(colorLabel);
  //   var sourceImages = wizzyNormalizeImageList(images);
  //   var entries = [];
  
  //   if (!colorHandle || !sourceImages.length) {
  //     return [];
  //   }
  
  //   sourceImages.forEach(function (imageUrl) {
  //     var alt = wizzyGetAltFromImageUrl(imageUrl);
  
  //     if (!wizzyImageAltMatchesColor(alt, colorHandle)) {
  //       return;
  //     }
  
  //     entries.push({
  //       cleaned: wizzyStripAltFromImageUrl(imageUrl),
  //       alt: alt
  //     });
  //   });
  
  //   if (!entries.length) {
  //     return [];
  //   }
  
  //   return wizzyOrderEntriesWithClHero(entries, colorHandle).map(function (entry) {
  //     return entry.cleaned;
  //   });
  // }
  
  // function wizzyOrderEntriesWithClHero(entries, colorHandle) {
  //   if (!entries || !entries.length) {
  //     return [];
  //   }
  
  //   var clKey = 'cl-' + String(colorHandle || '').toLowerCase();
  //   var heroIndex = -1;
  
  //   for (var i = 0; i < entries.length; i++) {
  //     if (entries[i].alt && entries[i].alt.indexOf(clKey) !== -1) {
  //       heroIndex = i;
  //       break;
  //     }
  //   }
  
  //   if (heroIndex <= 0) {
  //     return entries.slice();
  //   }
  
  //   var ordered = entries.slice();
  //   var hero = ordered.splice(heroIndex, 1)[0];
  //   ordered.unshift(hero);
  //   return ordered;
  // }
  
  // function wizzyResolveProductImagesFromAlt(product, colorLabel) {
  //   var allImages = wizzyNormalizeImageList(
  //     product.wizzyAllImages && product.wizzyAllImages.length
  //       ? product.wizzyAllImages
  //       : product.images
  //   );
  //   var selectedColor = colorLabel || wizzyGetSelectedColorLabel(product);
  //   var filtered = wizzyGetOrderedColorImages(allImages, selectedColor);
  
  //   if (filtered.length) {
  //     return {
  //       images: filtered,
  //       mainImage: filtered[0],
  //       source: 'alt'
  //     };
  //   }
  
  //   var swatchImage = wizzyGetVariantImageFromSwatches(product);
  
  //   if (swatchImage) {
  //     return {
  //       images: [swatchImage],
  //       mainImage: swatchImage,
  //       source: 'swatch'
  //     };
  //   }
  
  //   if (product.mainImage) {
  //     var cleanedMain = wizzyStripAltFromImageUrl(product.mainImage) || product.mainImage;
  //     return {
  //       images: [cleanedMain],
  //       mainImage: cleanedMain,
  //       source: 'mainImage'
  //     };
  //   }
  
  //   if (allImages.length) {
  //     var cleaned = allImages.map(wizzyStripAltFromImageUrl).filter(Boolean);
  //     return {
  //       images: cleaned.slice(0, 1),
  //       mainImage: cleaned[0] || '',
  //       source: 'first'
  //     };
  //   }
  
  //   return {
  //     images: [],
  //     mainImage: '',
  //     source: 'empty'
  //   };
  // }
  
  // function wizzyStoreProductAllImages(product) {
  //   if (!product) {
  //     return;
  //   }
  
  //   window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
  //   var allImages = wizzyNormalizeImageList(product.wizzyAllImages || product.images);
  
  //   if (!allImages.length) {
  //     return;
  //   }
  
  //   if (product.id != null) {
  //     window.wizzyProductAllImagesById[String(product.id)] = allImages.slice();
  //   }
  
  //   if (product.groupId != null) {
  //     window.wizzyProductAllImagesById[String(product.groupId)] = allImages.slice();
  //   }
  
  //   if (product.singleVarientGroupId != null) {
  //     window.wizzyProductAllImagesById[String(product.singleVarientGroupId)] = allImages.slice();
  //   }
  // }
  
  // function wizzyGetStoredProductAllImages(gridProduct) {
  //   if (!gridProduct) {
  //     return [];
  //   }
  
  //   window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
  //   var keys = [
  //     gridProduct.getAttribute('data-variant-id'),
  //     gridProduct.getAttribute('data-id'),
  //     gridProduct.getAttribute('data-product-id'),
  //     gridProduct.getAttribute('data-groupId'),
  //     gridProduct.getAttribute('data-groupid')
  //   ];
  
  //   for (var i = 0; i < keys.length; i++) {
  //     if (keys[i] && window.wizzyProductAllImagesById[String(keys[i])]) {
  //       return window.wizzyProductAllImagesById[String(keys[i])].slice();
  //     }
  //   }
  
  //   return [];
  // }
  
  // window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
  
  // function wizzyStoreProductGallery(keysOrProduct, galleryUrls) {
  //   if (!galleryUrls || !galleryUrls.length) {
  //     return;
  //   }
  
  //   window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
  //   var urls = galleryUrls.slice();
  //   var keys = [];
  
  //   if (keysOrProduct && typeof keysOrProduct === 'object' && !Array.isArray(keysOrProduct)) {
  //     if (keysOrProduct.id != null) keys.push(String(keysOrProduct.id));
  //     if (keysOrProduct.groupId != null) keys.push(String(keysOrProduct.groupId));
  //     if (keysOrProduct.singleVarientGroupId != null) {
  //       keys.push(String(keysOrProduct.singleVarientGroupId));
  //     }
  //   } else if (Array.isArray(keysOrProduct)) {
  //     keys = keysOrProduct.filter(Boolean).map(String);
  //   } else if (keysOrProduct != null) {
  //     keys = [String(keysOrProduct)];
  //   }
  
  //   keys.forEach(function (key) {
  //     window.wizzyProductGalleryById[key] = urls;
  //   });
  // }
  
  // function wizzyGetStoredProductGallery(gridProduct) {
  //   if (!gridProduct) {
  //     return [];
  //   }
  
  //   window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
  
  //   var keys = [
  //     gridProduct.getAttribute('data-variant-id'),
  //     gridProduct.getAttribute('data-id'),
  //     gridProduct.getAttribute('data-product-id'),
  //     gridProduct.getAttribute('data-groupId'),
  //     gridProduct.getAttribute('data-groupid')
  //   ];
  
  //   for (var i = 0; i < keys.length; i++) {
  //     if (keys[i] && window.wizzyProductGalleryById[String(keys[i])]) {
  //       return window.wizzyProductGalleryById[String(keys[i])].slice();
  //     }
  //   }
  
  //   return [];
  // }
  
  // function wizzyBuildCardImageSlide(url, isHero) {
  //   var imageElement = document.createElement('image-element');
  //   imageElement.setAttribute('data-aos', 'image-fade-in');
  //   imageElement.setAttribute('data-aos-offset', '150');
  //   imageElement.className = 'aos-init aos-animate wizzy-product-card-slide';
  
  //   var img = document.createElement('img');
  //   img.src = url;
  //   img.loading = isHero ? 'eager' : 'lazy';
  //   img.className = 'product grid__image-contain prodGrid01 image-element';
  //   img.setAttribute('sizes', '(max-width: 800px) 200px, 100vw');
  //   imageElement.appendChild(img);
  //   return imageElement;
  // }
  
  // function wizzyUpdateProductCardImagesFromUrls(productContent, urls, options) {
  //   if (!productContent || !urls || !urls.length) {
  //     return;
  //   }
  
  //   var opts = options || {};
  //   var heroOnly = !!opts.heroOnly;
  //   var renderUrls = heroOnly ? [urls[0]] : urls.slice();
  
  //   var sliderWrap =
  //     productContent.querySelector('.grid-product__image-mask .custom-image-element-wrap') ||
  //     productContent.querySelector('.custom-image-element-wrap');
  
  //   if (!sliderWrap) {
  //     return;
  //   }
  
  //   wizzyUnslickImageWrap(sliderWrap);
  //   sliderWrap.innerHTML = '';
  //   sliderWrap.setAttribute('data-wizzy-gallery-expanded', heroOnly ? 'false' : 'true');
  
  //   renderUrls.forEach(function (url, index) {
  //     sliderWrap.appendChild(wizzyBuildCardImageSlide(url, index === 0));
  //   });
  
  //   wizzyTagCardViewSlides(sliderWrap);
  
  //   if (!heroOnly && renderUrls.length > 1) {
  //     wizzyReinitProductImageSlider(sliderWrap);
  //   }
  // }
  
  // function wizzyExpandProductCardGallery(gridProduct, startIndex) {
  //   if (!gridProduct) {
  //     return false;
  //   }
  
  //   var productContent = gridProduct.querySelector('.grid-product__content');
  //   var sliderWrap =
  //     (productContent &&
  //       productContent.querySelector('.grid-product__image-mask .custom-image-element-wrap')) ||
  //     (productContent && productContent.querySelector('.custom-image-element-wrap'));
  
  //   if (!sliderWrap || sliderWrap.getAttribute('data-wizzy-gallery-expanded') === 'true') {
  //     return false;
  //   }
  
  //   var gallery = wizzyGetStoredProductGallery(gridProduct);
  
  //   if (gallery.length < 2) {
  //     return false;
  //   }
  
  //   wizzyUpdateProductCardImagesFromUrls(productContent, gallery, { heroOnly: false });
  
  //   if (window.jQuery && jQuery(sliderWrap).hasClass('slick-initialized') && startIndex > 0) {
  //     try {
  //       jQuery(sliderWrap).slick('slickGoTo', startIndex, true);
  //     } catch (error) {}
  //   }
  
  //   return true;
  // }
  
  // function wizzyBindProductCardGalleryOnDemand(gridProduct) {
  //   if (!gridProduct || gridProduct.dataset.wizzyGalleryBound === 'true') {
  //     return;
  //   }
  
  //   var gallery = wizzyGetStoredProductGallery(gridProduct);
  
  //   if (gallery.length < 2) {
  //     return;
  //   }
  
  //   gridProduct.dataset.wizzyGalleryBound = 'true';
  //   gridProduct.setAttribute('data-wizzy-has-gallery', 'true');
  
  //   var imageArea =
  //     gridProduct.querySelector('.grid-product__image-mask') ||
  //     gridProduct.querySelector('.custom-image-element-wrap');
  
  //   if (!imageArea) {
  //     return;
  //   }
  
  //   var pointerStartX = 0;
  //   var pointerStartY = 0;
  //   var swiping = false;
  //   var pointerActive = false;
  //   var suppressClick = false;
  
  //   function onPointerStart(clientX, clientY) {
  //     pointerStartX = clientX;
  //     pointerStartY = clientY;
  //     swiping = false;
  //     pointerActive = true;
  //   }
  
  //   function onPointerMove(clientX, clientY, event) {
  //     if (!pointerActive) {
  //       return;
  //     }
  
  //     var dx = clientX - pointerStartX;
  //     var dy = clientY - pointerStartY;
  
  //     if (Math.abs(dx) < 24 || Math.abs(dx) < Math.abs(dy)) {
  //       return;
  //     }
  
  //     swiping = true;
  //     suppressClick = true;
  
  //     if (wizzyExpandProductCardGallery(gridProduct, dx < 0 ? 1 : 0)) {
  //       if (event && event.preventDefault) {
  //         event.preventDefault();
  //       }
  //     }
  //   }
  
  //   imageArea.addEventListener(
  //     'touchstart',
  //     function (event) {
  //       if (!event.touches || !event.touches.length) {
  //         return;
  //       }
  
  //       onPointerStart(event.touches[0].clientX, event.touches[0].clientY);
  //     },
  //     { passive: true }
  //   );
  
  //   imageArea.addEventListener(
  //     'touchmove',
  //     function (event) {
  //       if (!event.touches || !event.touches.length) {
  //         return;
  //       }
  
  //       onPointerMove(event.touches[0].clientX, event.touches[0].clientY, event);
  //     },
  //     { passive: false }
  //   );
  
  //   imageArea.addEventListener('mousedown', function (event) {
  //     if (event.button !== 0) {
  //       return;
  //     }
  
  //     onPointerStart(event.clientX, event.clientY);
  //   });
  
  //   imageArea.addEventListener('mousemove', function (event) {
  //     if (!pointerActive) {
  //       return;
  //     }
  
  //     onPointerMove(event.clientX, event.clientY, event);
  //   });
  
  //   function endPointer() {
  //     pointerActive = false;
  //     swiping = false;
  //   }
  
  //   imageArea.addEventListener('mouseup', endPointer);
  //   imageArea.addEventListener('mouseleave', endPointer);
  
  //   imageArea.addEventListener('click', function (event) {
  //     if (suppressClick) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //       suppressClick = false;
  //     }
  //   });
  // }
  
  // function wizzyInitProductCardGalleriesOnDemand(root) {
  //   var scope = root && root.querySelectorAll ? root : document;
  //   var cards = scope.querySelectorAll(
  //     '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
  //   );
  
  //   Array.prototype.forEach.call(cards, function (card) {
  //     wizzyBindProductCardGalleryOnDemand(card);
  //   });
  // }
  
  // function wizzyPrefetchVariantImage(product) {
  //   return Promise.resolve();
  // }
  
  // function wizzyPrefetchVariantImages(products) {
  //   return Promise.resolve();
  // }
  
  // function wizzyApplyCachedVariantImages(product) {
  //   if (!product || product.id == null) {
  //     return;
  //   }
  
  //   var urls = wizzyGetCachedVariantImageUrls(String(product.id));
  
  //   if (!urls || !urls.length) {
  //     return;
  //   }
  
  //   product.mainImage = urls[0];
  //   product.images = urls.slice();
  //   product.imagesReady = true;
  //   product.wizzyImagesPrefetched = true;
  // }
  
  // function wizzyGetVariantImageFromSwatches(product) {
  //   if (!product.swatches) {
  //     return '';
  //   }
  
  //   var groups = Array.isArray(product.swatches)
  //     ? product.swatches
  //     : Object.keys(product.swatches).map(function (key) {
  //         return product.swatches[key];
  //       });
  
  //   for (var i = 0; i < groups.length; i++) {
  //     var group = groups[i];
  
  //     if (group.key !== 'colors' || !group.values || !group.values.length) {
  //       continue;
  //     }
  
  //     for (var j = 0; j < group.values.length; j++) {
  //       var value = group.values[j];
  
  //       if (value.isSelected && value.image) {
  //         return value.image;
  //       }
  //     }
  //   }
  
  //   return '';
  // }
  
  // function wizzyNormalizeVariantImages(product) {
  //   if (!product) {
  //     return;
  //   }
  
  //   if (!product.wizzyAllImages || !product.wizzyAllImages.length) {
  //     product.wizzyAllImages = wizzyNormalizeImageList(product.images);
  //   }
  
  //   wizzyStoreProductAllImages(product);
  
  //   var resolved = wizzyResolveProductImagesFromAlt(
  //     product,
  //     wizzyGetSelectedColorLabel(product)
  //   );
  
  //   if (resolved.images && resolved.images.length) {
  //     product.wizzyGalleryImages = resolved.images.slice();
  //     product.mainImage = resolved.mainImage || resolved.images[0];
  //     // First paint: hero only — remaining images load on swipe
  //     product.images = [product.mainImage];
  //     product.hasGalleryMore = resolved.images.length > 1;
  //     wizzyStoreProductGallery(product, resolved.images);
  //   } else if (product.mainImage) {
  //     product.images = [product.mainImage];
  //     product.wizzyGalleryImages = [product.mainImage];
  //     product.hasGalleryMore = false;
  //     wizzyStoreProductGallery(product, product.images);
  //   } else {
  //     product.wizzyGalleryImages = [];
  //     product.hasGalleryMore = false;
  //   }
  
  //   product.imagesReady = true;
  // }
  
  // function wizzyEnrichProduct(product) {
  //   wizzyPrepareSwatchesForTemplate(product);
  
  //   if (!product.cardSizes || !product.cardSizes.length) {
  //     var sizeValues = product.sizes || [];
  
  //     if (!sizeValues.length) {
  //       var sizeSwatches =
  //         (product.swatches && product.swatches.sizes) ||
  //         (product.swatch && product.swatch.sizes);
  
  //       if (sizeSwatches && sizeSwatches.values && sizeSwatches.values.length) {
  //         sizeValues = sizeSwatches.values;
  //       } else if (Array.isArray(sizeSwatches) && sizeSwatches.length) {
  //         sizeValues = sizeSwatches;
  //       }
  //     }
  
  //     if (sizeValues.length) {
  //       product.cardSizes = sizeValues.map(function (size) {
  //         return {
  //           label: size.value,
  //           variantId: size.variationId,
  //           inStock: size.inStock
  //         };
  //       });
  //     } else {
  //       product.hasNoSize = true;
  //     }
  //   }
  
  //   if (product.cardSizes && product.cardSizes.length) {
  //     product.cardSizes = product.cardSizes.map(function (size) {
  //       return {
  //         label: size.label || size.value,
  //         variantId: size.variantId || size.variationId,
  //         inStock: size.inStock !== false
  //       };
  //     });
  //   }
  
  //   product.isNoSize = wizzyProductHasNoSizeTag(product);
  //   product.hasCardSizes = !product.isNoSize;
  
  //   if (!product.isNoSize && (!product.cardSizes || !product.cardSizes.length)) {
  //     product.needsCardSizeFetch = true;
  //   }
  
  //   if (!product.faqText && product.subTitle) {
  //     product.faqText = product.subTitle;
  //   }
  
  //   if (!product.faqText) {
  //     product.faqText =
  //       wizzyGetAttributeValue(product, 'custom_faq_text') ||
  //       wizzyGetAttributeValue(product, 'product_custom_faq_text') ||
  //       wizzyGetAttributeValue(product, 'faq_text') ||
  //       wizzyGetAttributeValue(product, 'product_faq_text') ||
  //       '';
  //   }
  
  //   if (product.faqText) {
  //     product.hasFaqText = true;
  //   }
  
  //   if (product.avgRatings != null && product.reviewRating == null) {
  //     product.reviewRating = product.avgRatings;
  //   }
  
  //   if (product.totalReviews != null && product.reviewCount == null) {
  //     product.reviewCount = product.totalReviews;
  //   }
  
  //   if (product.reviewRating == null) {
  //     product.reviewRating =
  //       wizzyGetAttributeValue(product, 'avgRatings') ||
  //       wizzyGetAttributeValue(product, 'average_rating') ||
  //       wizzyGetAttributeValue(product, 'product_avg_rating') ||
  //       wizzyGetAttributeValue(product, 'reviews_average') ||
  //       product.averageRating ||
  //       product.rating ||
  //       null;
  //   }
  
  //   if (product.reviewCount == null) {
  //     product.reviewCount =
  //       wizzyGetAttributeValue(product, 'totalReviews') ||
  //       wizzyGetAttributeValue(product, 'reviews_count') ||
  //       wizzyGetAttributeValue(product, 'product_reviews_count') ||
  //       wizzyGetAttributeValue(product, 'number_of_reviews') ||
  //       product.reviewsCount ||
  //       product.review_count ||
  //       null;
  //   }
  
  //   var ratingValue = parseFloat(
  //     product.reviewRating != null ? product.reviewRating : product.avgRatings
  //   );
  //   var reviewCountValue = parseInt(
  //     product.reviewCount != null ? product.reviewCount : product.totalReviews,
  //     10
  //   );
  
  //   if (!isNaN(ratingValue) && !isNaN(reviewCountValue) && reviewCountValue > 0 && ratingValue > 0) {
  //     product.hasReviews = true;
  //     product.reviewRating = ratingValue;
  //     product.reviewCount = reviewCountValue;
  //     product.reviewRatingDisplay = ratingValue.toFixed(1);
  //   } else {
  //     product.hasReviews = false;
  //   }
  
  //   wizzyNormalizeVariantImages(product);
  
  //   return product;
  // }
  
  // function wizzyTransformProducts(data) {
  //   if (!data) {
  //     return data;
  //   }
  
  //   if (Array.isArray(data)) {
  //     data.forEach(wizzyEnrichProduct);
  //     return data;
  //   }
  
  //   if (data.id && (data.swatches || data.name)) {
  //     wizzyEnrichProduct(data);
  //     return data;
  //   }
  
  //   if (data.products && data.products.length) {
  //     data.products.forEach(wizzyEnrichProduct);
  //   }
  
  //   if (data.search && data.search.products && data.search.products.length) {
  //     data.search.products.forEach(wizzyEnrichProduct);
  //   }
  
  //   if (data.response && data.response.products && data.response.products.length) {
  //     data.response.products.forEach(wizzyEnrichProduct);
  //   }
  
  //   if (data.results && data.results.products && data.results.products.length) {
  //     data.results.products.forEach(wizzyEnrichProduct);
  //   }
  
  //   return data;
  // }
  
  // function wizzyUpdateProductLinks(productContent, targetId, productUrl) {
  //   if (!productContent) {
  //     return;
  //   }
  
  //   productContent.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
  //     const href = link.getAttribute('href') || '';
  
  //     if (href.indexOf('?variant=') !== -1) {
  //       link.setAttribute('href', href.replace(/(variant=)[^&]+/, '$1' + targetId));
  //     } else if (productUrl) {
  //       link.setAttribute('href', productUrl);
  //     }
  //   });
  // }
  
  // var WIZZY_PRODUCT_SLIDER_SELECTOR =
  //   '.wizzy-search-results-list .grid-product, .wizzy-search-results .grid-product, .wizzy-search-wrapper .grid-product';
  
  // function wizzyCountImageSlides(sliderWrap) {
  //   if (!sliderWrap) {
  //     return 0;
  //   }
  
  //   var directSlides = sliderWrap.querySelectorAll('.wizzy-product-card-slide');
  
  //   if (directSlides.length) {
  //     return directSlides.length;
  //   }
  
  //   var imageElements = [];
  //   for (var i = 0; i < sliderWrap.children.length; i++) {
  //     var child = sliderWrap.children[i];
  //     if (
  //       child.tagName &&
  //       (child.tagName.toLowerCase() === 'image-element' || child.tagName.toLowerCase() === 'img')
  //     ) {
  //       imageElements.push(child);
  //     }
  //   }
  
  //   return imageElements.length;
  // }
  
  // function wizzyUnslickImageWrap(sliderWrap) {
  //   if (!sliderWrap || !window.jQuery) {
  //     return;
  //   }
  
  //   var $wrap = jQuery(sliderWrap);
  
  //   if ($wrap.hasClass('slick-initialized')) {
  //     $wrap.slick('unslick');
  //   }
  // }
  
  // function wizzyInitProductImageSliderWrap(sliderWrap) {
  //   if (!sliderWrap || !window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
  //     return;
  //   }
  
  //   var $wrap = jQuery(sliderWrap);
  
  //   if (!$wrap.hasClass('custom-image-element-wrap')) {
  //     $wrap = $wrap.find('.custom-image-element-wrap').first();
  //   }
  
  //   if (!$wrap.length) {
  //     return;
  //   }
  
  //   $wrap.addClass('wizzy-product-card-slider');
  //   wizzyUnslickImageWrap($wrap[0]);
  
  //   var slideCount = wizzyCountImageSlides($wrap[0]);
  
  //   if (slideCount > 1) {
  //     $wrap.slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       dots: true,
  //       arrows: false,
  //       infinite: false,
  //       autoplay: false,
  //       autoplaySpeed: 3000,
  //       draggable: true,
  //       swipe: true,
  //       touchMove: true,
  //       adaptiveHeight: false
  //     });
  //   }
  // }
  
  // function wizzyInitProductImageSlidersIn(root) {
  //   var scope = root && root.querySelectorAll ? root : document;
  //   var cards = scope === document ? scope.querySelectorAll(WIZZY_PRODUCT_SLIDER_SELECTOR) : [scope];
  
  //   Array.prototype.forEach.call(cards, function (card) {
  //     card.querySelectorAll('.custom-image-element-wrap').forEach(function (sliderWrap) {
  //       wizzyInitProductImageSliderWrap(sliderWrap);
  //     });
  //   });
  // }
  
  // function wizzyReinitProductImageSlider(imageWrapper) {
  //   if (!imageWrapper) {
  //     return;
  //   }
  
  //   if (imageWrapper.classList && imageWrapper.classList.contains('custom-image-element-wrap')) {
  //     wizzyInitProductImageSliderWrap(imageWrapper);
  //     return;
  //   }
  
  //   imageWrapper.querySelectorAll('.custom-image-element-wrap').forEach(function (sliderWrap) {
  //     wizzyInitProductImageSliderWrap(sliderWrap);
  //   });
  // }
  
  // function wizzyApplyColorSwatchFetchResponse(target, html, productContent, gridProduct) {
  //   if (!target || !html || !productContent) {
  //     return;
  //   }
  
  //   const targetId = target.dataset.variantId;
  //   const targetValue = (target.getAttribute('data-value') || '').toLowerCase();
  //   const soldOutTagName = target.dataset.soldoutName || 'Sold Out';
  //   const savedAmount = target.dataset.savedAmount;
  //   const tagMetafieldValue = target.dataset.variantMetafieldTagValue;
  //   const soldOutLabelHTML = '<div class="grid-product__tag grid-product__tag--sold-out">' + soldOutTagName + '</div>';
  
  //   const activeColorSwatchContainer = target.closest('.collection-product-color-grid');
  
  //   if (activeColorSwatchContainer && targetId) {
  //     const activeColorSwatch = activeColorSwatchContainer.querySelector("a[data-variant-id='" + targetId + "']");
  
  //     if (activeColorSwatch) {
  //       activeColorSwatch.classList.add('product-color-swatch--active');
  //     }
  //   }
  
  //   const oldProductGridImageContainer = productContent.querySelector('.grid-product__image-mask .grid__image-ratio')
  //     || productContent.querySelector('.grid__image-ratio');
  //   const oldSizeVariants = productContent.querySelector('.variant-wrapper');
  //   const newSizeVariants = html.querySelector('.variant-wrapper');
  //   const hasAvailableSize = wizzyApplySizeAvailabilityToWrapper(
  //     newSizeVariants,
  //     html,
  //     targetValue
  //   );
  //   let isVariantSoldOut = hasAvailableSize;
  
  //   productContent.querySelectorAll('.cs-tag-container').forEach(function (tagContainer) {
  //     tagContainer.style.display = tagMetafieldValue ? 'block' : 'none';
  //   });
  
  //   if (newSizeVariants && oldSizeVariants) {
  //     oldSizeVariants.innerHTML = newSizeVariants.innerHTML;
  //   }
  
  //   const addToCartBtn = productContent.querySelector('.addtocartbtn');
  //   const btnText = productContent.querySelector('.btn-custom.select-switchs');
  //   const colorSwitch = gridProduct ? gridProduct.querySelector('.color-switch') : null;
  //   const isPanelOpen = colorSwitch && colorSwitch.classList.contains('switch-height');
  
  //   if (!isVariantSoldOut) {
  //     let soldOutLabel = productContent.querySelector('.grid-product__tag--sold-out');
  
  //     if (!soldOutLabel) {
  //       productContent.insertAdjacentHTML('afterbegin', soldOutLabelHTML);
  //     }
  
  //     const savedAmountLabel = productContent.querySelector('#perc-c');
  //     if (savedAmountLabel) {
  //       savedAmountLabel.classList.add('d-none');
  //     }
  
  //     if (addToCartBtn) {
  //       addToCartBtn.classList.add('notifymebtn');
  //     }
  
  //     if (btnText) {
  //       btnText.classList.add('notifyme--btn');
  //       btnText.textContent = 'Notify Me';
  //     }
  
  //     if (oldProductGridImageContainer) {
  //       oldProductGridImageContainer.style.opacity = '0.5';
  //     }
  //   } else {
  //     const soldOutLabel = productContent.querySelector('.grid-product__tag--sold-out');
  
  //     if (soldOutLabel) {
  //       soldOutLabel.remove();
  //     }
  
  //     if (addToCartBtn) {
  //       addToCartBtn.classList.remove('notifymebtn');
  //     }
  
  //     if (btnText) {
  //       btnText.classList.remove('notifyme--btn');
  //       btnText.innerHTML = 'Quick Add <span class="quick-add-icon"><span class="icon-plus" style="' + (isPanelOpen ? 'display: none;' : '') + '"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="24" height="24" fill="none"></rect><path d="M12 6V18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 12H18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path></g></svg></span><span class="icon-minus" style="' + (isPanelOpen ? 'display: block;' : 'display: none;') + '"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="24" height="24" fill="none"></rect><path d="M6 12H18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path></g></svg></span></span>';
  //     }
  
  //     const savedAmountLabel = productContent.querySelector('#perc-c');
  
  //     if (savedAmount && savedAmountLabel) {
  //       savedAmountLabel.classList.remove('d-none');
  //     }
  
  //     if (oldProductGridImageContainer) {
  //       oldProductGridImageContainer.style.opacity = '1';
  //     }
  //   }
  
  //   wizzyUpdateProductCardImages(productContent, html);
  //   productContent.dataset.wizzyImagesSynced = 'true';
  
  //   if (gridProduct) {
  //     var variantId = wizzyGetVariantIdFromGridProduct(gridProduct);
  //     var imageUrls = wizzyExtractImageUrlsFromCardHtml(html);
  
  //     if (variantId && imageUrls.length) {
  //       wizzySetVariantImageCache(variantId, imageUrls);
  //     }
  
  //     wizzyMarkVariantImageReady(gridProduct);
  //   }
  // }
  
  // function wizzyResponseHasVisibleImages(responseProductImages) {
  //   return Array.prototype.some.call(responseProductImages, function (anchor) {
  //     var wrap = anchor.querySelector('.custom-image-element-wrap');
  
  //     if (!wrap) {
  //       return false;
  //     }
  
  //     return wizzyCountImageSlides(wrap) > 0;
  //   });
  // }
  
  // function wizzyTagCardViewSlides(root) {
  //   if (!root) {
  //     return;
  //   }
  
  //   root.querySelectorAll('.custom-image-element-wrap image-element, .custom-image-element-wrap .image-element').forEach(
  //     function (slide) {
  //       slide.classList.add('wizzy-product-card-slide');
  //     }
  //   );
  // }
  
  // function wizzyExtractImageUrlsFromCardHtml(html) {
  //   if (!html) {
  //     return [];
  //   }
  
  //   var imgs = html.querySelectorAll('.product-images.grid-product__link img');
  //   var urls = [];
  
  //   imgs.forEach(function (img) {
  //     var src = img.getAttribute('src') || img.getAttribute('data-src');
  
  //     if (src) {
  //       urls.push(src);
  //     }
  //   });
  
  //   return urls;
  // }
  
  // function wizzyUpdateProductCardImages(productContent, html) {
  //   if (!productContent || !html) {
  //     return;
  //   }
  
  //   const imageWrapper =
  //     productContent.querySelector('.grid-product__image-mask .custom_slider-mobile-image-element') ||
  //     productContent.querySelector('.grid-product__image-mask .grid-product__link-wrapper .grid-product__link');
  //   const imageLink = productContent.querySelector('a.product-images.grid-product__link');
  //   const responseProductImages = html.querySelectorAll('.product-images.grid-product__link');
  
  //   if (!responseProductImages.length || !wizzyResponseHasVisibleImages(responseProductImages)) {
  //     return;
  //   }
  
  //   if (imageWrapper) {
  //     imageWrapper.querySelectorAll('.custom-image-element-wrap').forEach(wizzyUnslickImageWrap);
  
  //     imageWrapper.innerHTML = '';
  
  //     responseProductImages.forEach(function (img) {
  //       imageWrapper.appendChild(img.cloneNode(true));
  //     });
  
  //     wizzyTagCardViewSlides(imageWrapper);
  //     wizzyReinitProductImageSlider(imageWrapper);
  //     return;
  //   }
  
  //   if (imageLink) {
  //     imageLink.querySelectorAll('.custom-image-element-wrap').forEach(wizzyUnslickImageWrap);
  //     imageLink.outerHTML = responseProductImages[0].outerHTML;
  
  //     const updatedImageLink = productContent.querySelector('a.product-images.grid-product__link');
  
  //     if (updatedImageLink) {
  //       wizzyTagCardViewSlides(updatedImageLink);
  //       wizzyReinitProductImageSlider(updatedImageLink.parentElement || updatedImageLink);
  //     }
  //   }
  // }
  
  // function wizzyGetVariantCardFetchUrl(gridProduct, activeSwatch) {
  //   if (activeSwatch) {
  //     const productUrl = activeSwatch.getAttribute('data-url');
  
  //     if (productUrl) {
  //       return productUrl.indexOf('?') !== -1 ? productUrl + '&view=card' : productUrl + '?view=card';
  //     }
  //   }
  
  //   const variantId = gridProduct.getAttribute('data-variant-id');
  //   const handle = gridProduct.getAttribute('data-product-handle');
  
  //   if (variantId && handle) {
  //     return '/products/' + handle + '?variant=' + variantId + '&view=card';
  //   }
  
  //   return wizzyGetCardFetchUrl(gridProduct);
  // }
  
  // function wizzyMarkVariantImageReady(gridProduct) {
  //   if (gridProduct) {
  //     gridProduct.setAttribute('data-images-ready', 'true');
  //   }
  // }
  
  // function wizzySyncInitialVariantImages(gridProduct) {
  //   const content = gridProduct.querySelector('.grid-product__content');
  
  //   if (content) {
  //     content.dataset.wizzyImagesSynced = 'true';
  //     wizzyReinitProductImageSlider(content);
  //   }
  
  //   gridProduct.setAttribute('data-wizzy-images-prefetched', 'true');
  //   wizzyMarkVariantImageReady(gridProduct);
  //   return Promise.resolve();
  // }
  
  // function wizzyInitInitialVariantImages() {
  //   const cards = document.querySelectorAll(
  //     '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
  //   );
  
  //   return Promise.all(Array.from(cards).map(wizzySyncInitialVariantImages)).then(function () {
  //     wizzyRefreshProductCardSliders();
  //   });
  // }
  
  // function wizzyGetCardFetchUrl(gridProduct) {
  //   return '';
  //   const link = gridProduct.querySelector('a.grid-product__link[href]');
  
  //   if (!link) {
  //     return '';
  //   }
  
  //   const href = link.getAttribute('href') || '';
  
  //   if (!href) {
  //     return '';
  //   }
  
  //   return href.indexOf('?') !== -1 ? href + '&view=card' : href + '?view=card';
  // }
  
  // function wizzyGetVariantIdFromGridProduct(gridProduct) {
  //   if (!gridProduct) {
  //     return '';
  //   }
  
  //   const dataVariantId = gridProduct.getAttribute('data-variant-id');
  
  //   if (dataVariantId) {
  //     return String(dataVariantId);
  //   }
  
  //   const link =
  //     gridProduct.querySelector('a.grid-product__link[href*="variant="]') ||
  //     gridProduct.querySelector('a[href*="/products/"][href*="variant="]');
  
  //   if (!link) {
  //     return '';
  //   }
  
  //   const match = (link.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
  //   return match ? match[1] : '';
  // }
  
  // function wizzyResolveCardColorSlug(gridProduct, htmlDoc) {
  //   if (gridProduct) {
  //     const activeSwatch = gridProduct.querySelector(
  //       'a.product-color-swatch--active[data-value], a.color-swatch--with-image.product-color-swatch--active[data-value]'
  //     );
  
  //     if (activeSwatch) {
  //       const swatchValue = (activeSwatch.getAttribute('data-value') || '').toLowerCase().trim();
  
  //       if (swatchValue) {
  //         return swatchValue;
  //       }
  //     }
  //   }
  
  //   const variantId = wizzyGetVariantIdFromGridProduct(gridProduct);
  
  //   if (variantId && htmlDoc) {
  //     const matchedOption = htmlDoc.querySelector(
  //       '#variant-select option[value="' + variantId + '"]'
  //     );
  
  //     if (matchedOption) {
  //       const colorFromVariant = (matchedOption.getAttribute('data-color-option') || '')
  //         .toLowerCase()
  //         .trim();
  
  //       if (colorFromVariant) {
  //         return colorFromVariant;
  //       }
  //     }
  //   }
  
  //   if (htmlDoc) {
  //     const firstColorOption = htmlDoc.querySelector('#variant-select option[data-color-option]');
  
  //     if (firstColorOption) {
  //       return (firstColorOption.getAttribute('data-color-option') || '').toLowerCase().trim();
  //     }
  //   }
  
  //   return '';
  // }
  
  // function wizzyApplySizeAvailabilityToWrapper(variantWrapper, htmlDoc, colorSlug) {
  //   if (!variantWrapper || !htmlDoc || !colorSlug) {
  //     return false;
  //   }
  
  //   const colorOptions = htmlDoc.querySelectorAll(
  //     '#variant-select option[data-color-option="' + colorSlug + '"]'
  //   );
  
  //   if (!colorOptions.length) {
  //     return false;
  //   }
  
  //   let hasAvailableSize = false;
  
  //   for (let i = 0; i < colorOptions.length; i++) {
  //     const option = colorOptions[i];
  //     const sizeOption = option.getAttribute('data-size-option');
  //     const sizeAvailable = option.getAttribute('data-size-available');
  //     const variantId = option.getAttribute('value') || option.getAttribute('data-variant-id');
  
  //     if (!sizeOption) {
  //       continue;
  //     }
  
  //     const input =
  //       variantWrapper.querySelector('input[value="' + sizeOption + '"]') ||
  //       variantWrapper.querySelector('input[data-input-value="' + sizeOption + '"]');
  //     const label = variantWrapper.querySelector('label[data-label-value="' + sizeOption + '"]');
  
  //     if (sizeAvailable === 'true') {
  //       if (input) {
  //         input.classList.remove('disabled');
  //       }
  
  //       if (label) {
  //         label.classList.remove('disabled');
  //       }
  
  //       hasAvailableSize = true;
  //     } else if (sizeAvailable === 'false') {
  //       if (input) {
  //         input.classList.add('disabled');
  //       }
  
  //       if (label) {
  //         label.classList.add('disabled');
  //       }
  //     }
  
  //     if (variantId) {
  //       if (input) {
  //         input.setAttribute('data-id', variantId);
  //       }
  
  //       if (label) {
  //         label.setAttribute('data-id', variantId);
  //         label.setAttribute('data-variant-id', variantId);
  //       }
  //     }
  //   }
  
  //   return hasAvailableSize;
  // }
  
  // function wizzyLoadSizedProductCard(gridProduct) {
  //   const content = gridProduct.querySelector('.grid-product__content');
  
  //   if (!content || content.dataset.wizzySizesLoaded === 'true') {
  //     return Promise.resolve();
  //   }
  
  //   const activeSwatch = gridProduct.querySelector(
  //     'a.product-color-swatch--active, a.color-swatch--with-image.product-color-swatch--active'
  //   );
  //   const fetchUrl =
  //     wizzyGetVariantCardFetchUrl(gridProduct, activeSwatch) || wizzyGetCardFetchUrl(gridProduct);
  
  //   if (!fetchUrl) {
  //     return Promise.resolve();
  //   }
  
  //   return fetch(fetchUrl)
  //     .then(function (response) {
  //       return response.text();
  //     })
  //     .then(function (htmlText) {
  //       const html = new DOMParser().parseFromString(htmlText, 'text/html');
  //       const newVariantWrapper = html.querySelector('.variant-wrapper');
  //       const oldVariantWrapper = content.querySelector('.variant-wrapper');
  
  //       if (newVariantWrapper && oldVariantWrapper) {
  //         const colorSlug = wizzyResolveCardColorSlug(gridProduct, html);
  //         wizzyApplySizeAvailabilityToWrapper(newVariantWrapper, html, colorSlug);
  //         oldVariantWrapper.innerHTML = newVariantWrapper.innerHTML;
  //       }
  
  //       content.dataset.wizzySizesLoaded = 'true';
  //     })
  //     .catch(function () {});
  // }
  
  // function wizzyInitSizedProductCards() {
  //   const cards = document.querySelectorAll(
  //     '.wizzy-search-results-list .grid-product .select-switchs, .wizzy-search-wrapper .grid-product .select-switchs'
  //   );
  
  //   cards.forEach(function (button) {
  //     const gridProduct = button.closest('.grid-product');
  
  //     if (!gridProduct) {
  //       return;
  //     }
  
  //     wizzyLoadSizedProductCard(gridProduct);
  //   });
  // }
  
  // function wizzyFillReviewFromBadge(container) {
  //   if (!container) {
  //     return false;
  //   }
  
  //   var ratingEl = container.querySelector('.nector-review-rating');
  //   var countEl = container.querySelector('.nector-review-count');
  
  //   if (ratingEl && ratingEl.textContent.trim() && countEl && countEl.textContent.trim()) {
  //     container.style.display = 'block';
  //     container.dataset.jdgmInit = 'true';
  //     return true;
  //   }
  
  //   var productCard = container.closest(
  //     '[data-product-id], .grid-product, .product-grid-item, .grid__item, .card-wrapper'
  //   );
  
  //   if (!productCard) {
  //     return false;
  //   }
  
  //   var badge = productCard.querySelector('.jdgm-prev-badge');
  
  //   if (!badge) {
  //     return false;
  //   }
  
  //   var rating = parseFloat(
  //     badge.getAttribute('data-average-rating') || badge.dataset.averageRating || 0
  //   );
  //   var count = parseInt(
  //     badge.getAttribute('data-number-of-reviews') || badge.dataset.numberOfReviews || 0,
  //     10
  //   );
  
  //   if (!(count > 0) || isNaN(rating) || rating <= 0) {
  //     container.style.display = 'none';
  //     container.dataset.jdgmInit = 'true';
  //     return false;
  //   }
  
  //   if (ratingEl) {
  //     ratingEl.textContent = rating.toFixed(1);
  //   }
  
  //   if (countEl) {
  //     countEl.textContent = String(count);
  //   }
  
  //   container.style.display = 'block';
  //   container.dataset.jdgmInit = 'true';
  //   return true;
  // }
  
  // function wizzyInjectJudgeMeBadge(titleEl, htmlDoc) {
  //   if (!titleEl || !htmlDoc || titleEl.querySelector('.jdgm-prev-badge')) {
  //     return !!titleEl.querySelector('.jdgm-prev-badge');
  //   }
  
  //   var cardBadgeWrap = htmlDoc.querySelector('.jdgm-badge-source');
  //   var cardBadge = htmlDoc.querySelector('.jdgm-prev-badge');
  
  //   if (!cardBadgeWrap && !cardBadge) {
  //     return false;
  //   }
  
  //   var badgeTarget = titleEl.querySelector('.jdgm-badge-source');
  
  //   if (cardBadgeWrap) {
  //     if (badgeTarget) {
  //       badgeTarget.innerHTML = cardBadgeWrap.innerHTML;
  //     } else {
  //       titleEl.insertAdjacentHTML('beforeend', cardBadgeWrap.outerHTML);
  //     }
  //   } else if (cardBadge) {
  //     if (badgeTarget) {
  //       badgeTarget.innerHTML = cardBadge.outerHTML;
  //     } else {
  //       titleEl.insertAdjacentHTML(
  //         'beforeend',
  //         '<div class="jdgm-badge-source" style="display:none;">' + cardBadge.outerHTML + '</div>'
  //       );
  //     }
  //   }
  
  //   return !!titleEl.querySelector('.jdgm-prev-badge');
  // }
  
  // function wizzyEnrichProductCardMeta(gridProduct) {
  //   const content = gridProduct.querySelector('.grid-product__content');
  //   const meta = content ? content.querySelector('.grid-product__meta') : null;
  
  //   if (!content || !meta || content.dataset.wizzyMetaLoaded === 'true') {
  //     return Promise.resolve();
  //   }
  
  //   window.wizzyMetaPromises = window.wizzyMetaPromises || new WeakMap();
  
  //   if (content.dataset.wizzyMetaLoading === 'true') {
  //     return window.wizzyMetaPromises.get(content) || Promise.resolve();
  //   }
  
  //   const faqEl = meta.querySelector('.wizzy-faq-text');
  //   const reviewsEl = meta.querySelector('.judgeme-custom-reviews');
  //   const ratingEl = reviewsEl ? reviewsEl.querySelector('.nector-review-rating') : null;
  //   const needsFaq = !faqEl || !faqEl.textContent.trim();
  //   const needsReviews = !ratingEl || !ratingEl.textContent.trim();
  
  //   if (!needsFaq && !needsReviews) {
  //     if (reviewsEl) {
  //       wizzyFillReviewFromBadge(reviewsEl);
  //     }
  //     content.dataset.wizzyMetaLoaded = 'true';
  //     return Promise.resolve();
  //   }
  
  //   if (needsReviews && reviewsEl && wizzyFillReviewFromBadge(reviewsEl)) {
  //     if (!needsFaq) {
  //       content.dataset.wizzyMetaLoaded = 'true';
  //       return Promise.resolve();
  //     }
  //   }
  
  //   const fetchUrl = wizzyGetCardFetchUrl(gridProduct);
  
  //   if (!fetchUrl) {
  //     if (reviewsEl) {
  //       wizzyFillReviewFromBadge(reviewsEl);
  //     }
  //     content.dataset.wizzyMetaLoaded = 'true';
  //     return Promise.resolve();
  //   }
  
  //   content.dataset.wizzyMetaLoading = 'true';
  
  //   const request = fetch(fetchUrl)
  //     .then(function (response) {
  //       return response.text();
  //     })
  //     .then(function (htmlText) {
  //       const html = new DOMParser().parseFromString(htmlText, 'text/html');
  //       const titleEl = meta.querySelector('.grid-product__title');
  //       const liveReviewsEl = meta.querySelector('.judgeme-custom-reviews');
  
  //       if (needsFaq && faqEl) {
  //         const cardFaq = html.querySelector('.faq-text');
  
  //         if (cardFaq && cardFaq.textContent.trim()) {
  //           faqEl.textContent = cardFaq.textContent.trim();
  //         }
  //       }
  
  //       // Only inject Judge.me badge data. Never replace the Wizzy review
  //       // container with the empty product-card widget (that shows icons without numbers).
  //       if (needsReviews && titleEl) {
  //         wizzyInjectJudgeMeBadge(titleEl, html);
  
  //         if (liveReviewsEl) {
  //           wizzyFillReviewFromBadge(liveReviewsEl);
  //         }
  //       }
  
  //       content.dataset.wizzyMetaLoaded = 'true';
  //       delete content.dataset.wizzyMetaLoading;
  //       window.wizzyMetaPromises.delete(content);
  //     })
  //     .catch(function () {
  //       if (reviewsEl) {
  //         wizzyFillReviewFromBadge(reviewsEl);
  //       }
  //       content.dataset.wizzyMetaLoaded = 'true';
  //       delete content.dataset.wizzyMetaLoading;
  //       window.wizzyMetaPromises.delete(content);
  //     });
  
  //   window.wizzyMetaPromises.set(content, request);
  //   return request;
  // }
  
  // function wizzyInitProductCardMeta() {
  //   const cards = document.querySelectorAll(
  //     '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
  //   );
  //   const requests = Array.from(cards).map(wizzyEnrichProductCardMeta);
  
  //   return Promise.all(requests).then(function () {
  //     const scope =
  //       document.querySelector('.wizzy-search-results-list') ||
  //       document.querySelector('.wizzy-search-wrapper');
  
  //     if (!scope) {
  //       return;
  //     }
  
  //     scope.querySelectorAll('.judgeme-custom-reviews').forEach(function (container) {
  //       wizzyFillReviewFromBadge(container);
  //     });
  
  //     if (typeof initJudgeMeRatings === 'function') {
  //       initJudgeMeRatings(scope);
  //     }
  //   });
  // }
  
  // function wizzyRevealProductRatings(scope) {
  //   var root =
  //     scope ||
  //     document.querySelector('.wizzy-search-results-list') ||
  //     document.querySelector('.wizzy-search-wrapper') ||
  //     document;
  
  //   root.querySelectorAll('.judgeme-custom-reviews').forEach(function (container) {
  //     wizzyFillReviewFromBadge(container);
  //   });
  
  //   if (typeof initJudgeMeRatings === 'function') {
  //     initJudgeMeRatings(root);
  //   }
  // }
  
  // function wizzyUpgradeDirectAddCards() {
  //   const cards = document.querySelectorAll(
  //     '.wizzy-search-results-list .grid-product .withoutSIzeVariants, .wizzy-search-wrapper .grid-product .withoutSIzeVariants'
  //   );
  //   const requests = [];
  
  //   cards.forEach(function (button) {
  //     const gridProduct = button.closest('.grid-product');
  //     const content = gridProduct ? gridProduct.querySelector('.grid-product__content') : null;
  
  //     if (!gridProduct || !content || gridProduct.dataset.wizzyAtcChecked === 'true') {
  //       return;
  //     }
  
  //     gridProduct.dataset.wizzyAtcChecked = 'true';
  
  //     const fetchUrl = wizzyGetCardFetchUrl(gridProduct);
  
  //     if (!fetchUrl) {
  //       return;
  //     }
  
  //     requests.push(
  //       fetch(fetchUrl)
  //         .then(function (response) {
  //           return response.text();
  //         })
  //         .then(function (htmlText) {
  //           const html = new DOMParser().parseFromString(htmlText, 'text/html');
  //           const hasSizeLabels = html.querySelector('.cstm_collection_add');
  
  //           if (!hasSizeLabels) {
  //             return;
  //           }
  
  //           const newAddBtn = html.querySelector('.addtocartbtn');
  //           const newColorSwitch = html.querySelector('.color-switch');
  //           const oldAddBtn = content.querySelector('.addtocartbtn');
  //           const oldColorSwitch = content.querySelector('.color-switch');
  
  //           if (newAddBtn && oldAddBtn) {
  //             oldAddBtn.replaceWith(newAddBtn.cloneNode(true));
  //           }
  
  //           if (newColorSwitch) {
  //             if (oldColorSwitch) {
  //               oldColorSwitch.replaceWith(newColorSwitch.cloneNode(true));
  //             } else {
  //               content.appendChild(newColorSwitch.cloneNode(true));
  //             }
  //           }
  
  //           content.dataset.wizzySizesLoaded = 'true';
  //         })
  //         .catch(function () {})
  //     );
  //   });
  
  //   return Promise.all(requests);
  // }
  
  // var WIZZY_TILE_VIEW_STORAGE_KEY = 'wizzy-custom-tile-view-level';
  
  // function wizzyRefreshProductCardSliders() {
  //   if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
  //     return;
  //   }
  
  //   setTimeout(function () {
  //     wizzyInitProductImageSlidersIn(document);
  
  //     jQuery(
  //       '.wizzy-search-results-list .wizzy-product-card-slider, .wizzy-search-results .wizzy-product-card-slider, .wizzy-search-wrapper .wizzy-product-card-slider'
  //     ).each(function () {
  //       if (jQuery(this).hasClass('slick-initialized')) {
  //         jQuery(this).slick('setPosition');
  //       }
  //     });
  //   }, 50);
  // }
  
  // function wizzySetTileViewLevel(level, options) {
  //   options = options || {};
  //   const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  
  //   if (!wrapper || level == null) {
  //     return;
  //   }
  
  //   const levelStr = String(level);
  //   wrapper.setAttribute('wizzy-tile-view-level', levelStr);
  
  //   try {
  //     localStorage.setItem(WIZZY_TILE_VIEW_STORAGE_KEY, levelStr);
  //   } catch (error) {}
  
  //   if (options.updateActiveIcon !== false) {
  //     const activeIcon =
  //       options.activeIcon ||
  //       document.querySelector('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
  //     wizzySetActiveGridView(activeIcon);
  //   }
  
  //   wizzyRefreshProductCardSliders();
  // }
  
  // function wizzyRestoreTileViewLevel() {
  //   const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  
  //   if (!wrapper) {
  //     return;
  //   }
  
  //   let level = null;
  
  //   try {
  //     level = localStorage.getItem(WIZZY_TILE_VIEW_STORAGE_KEY);
  //   } catch (error) {}
  
  //   if (!level) {
  //     level = wrapper.getAttribute('wizzy-tile-view-level') || '1';
  //   }
  
  //   wizzySetTileViewLevel(level, { updateActiveIcon: true });
  // }
  
  // function wizzySyncMobileFilterLabel() {
  //   document.querySelectorAll('.wizzy-search-wrapper .wz-active-filters-mobile-count').forEach(function (countEl) {
  //     var raw = countEl.textContent.trim().replace(/[()]/g, '').trim();
  
  //     if (raw && raw !== '0') {
  //       countEl.textContent = ' (' + raw + ')';
  //     } else {
  //       countEl.textContent = '';
  //     }
  //   });
  // }
  
  // function wizzySyncApplyFilterButtonState() {
  //   var applyButtons = document.querySelectorAll(
  //     '.wizzy-search-wrapper .wizzy-apply-all-button, .wizzy-search-wrapper .wizzy-riyaasat-apply-filter'
  //   );
  
  //   if (!applyButtons.length) {
  //     return;
  //   }
  
  //   var hasSelection = false;
  
  //   if (wizzyIsSlpPage()) {
  //     var applied = wizzySlpGetAppliedFilterIds();
  //     var pending = wizzySlpGetPendingFilterIds();
  //     hasSelection =
  //       pending.size > 0 ||
  //       wizzySlpGetFacetItemsToToggle(applied, pending).length > 0 ||
  //       !!window.wizzySlpHasPendingChanges;
  //   } else {
  //     hasSelection = !!document.querySelector(
  //       '.wizzy-search-filters-left .wizzy-facet-list-item input[type="checkbox"]:checked'
  //     );
  //   }
  
  //   applyButtons.forEach(function (btn) {
  //     btn.classList.toggle('wizzy-apply-filter--active', hasSelection);
  //   });
  // }
  
  // function wizzySetActiveGridView(activeIcon) {
  //   const toggleIcon =
  //     activeIcon || document.querySelector('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
  
  //   if (toggleIcon) {
  //     toggleIcon.classList.add('active');
  //   }
  // }
  
  // function wizzyFormatPriceValue(value) {
  //   if (value == null || value === '') {
  //     return '';
  //   }
  
  //   var str = String(value).trim();
  
  //   if (str.indexOf('₹') !== -1) {
  //     return str;
  //   }
  
  //   var num = parseFloat(str.replace(/,/g, ''));
  
  //   if (isNaN(num)) {
  //     return str;
  //   }
  
  //   return (
  //     '₹' +
  //     num.toLocaleString('en-IN', {
  //       minimumFractionDigits: 0,
  //       maximumFractionDigits: 2,
  //     })
  //   );
  // }
  
  // function wizzyGetPriceSliderValues(slider) {
  //   if (!slider) {
  //     return { min: '', max: '' };
  //   }
  
  //   if (slider.noUiSlider) {
  //     var values = slider.noUiSlider.get();
  
  //     return {
  //       min: wizzyFormatPriceValue(values[0]),
  //       max: wizzyFormatPriceValue(values[1]),
  //     };
  //   }
  
  //   var tooltips = slider.querySelectorAll('.noUi-tooltip');
  
  //   if (tooltips.length >= 2) {
  //     return {
  //       min: wizzyFormatPriceValue(tooltips[0].textContent),
  //       max: wizzyFormatPriceValue(tooltips[1].textContent),
  //     };
  //   }
  
  //   var handles = slider.querySelectorAll('.noUi-handle');
  
  //   if (handles.length >= 2) {
  //     return {
  //       min: wizzyFormatPriceValue(handles[0].getAttribute('aria-valuenow')),
  //       max: wizzyFormatPriceValue(handles[1].getAttribute('aria-valuenow')),
  //     };
  //   }
  
  //   return { min: '', max: '' };
  // }
  
  // function wizzySyncPriceRangeFields(body) {
  //   var slider = body.querySelector('.noUi-target');
  
  //   if (!slider) {
  //     return;
  //   }
  
  //   var values = wizzyGetPriceSliderValues(slider);
  //   var minInput = body.querySelector('.wizzy-price-range-input-min');
  //   var maxInput = body.querySelector('.wizzy-price-range-input-max');
  //   var bottomMin = body.querySelector('.wizzy-price-range-bottom-min');
  //   var bottomMax = body.querySelector('.wizzy-price-range-bottom-max');
  
  //   if (minInput) {
  //     minInput.value = values.min;
  //   }
  
  //   if (maxInput) {
  //     maxInput.value = values.max;
  //   }
  
  //   if (bottomMin) {
  //     bottomMin.textContent = values.min;
  //   }
  
  //   if (bottomMax) {
  //     bottomMax.textContent = values.max;
  //   }
  // }
  
  // function wizzyEnhancePriceFilterUI() {
  //   if (window.innerWidth > 768) {
  //     return;
  //   }
  
  //   document
  //     .querySelectorAll('.wizzy-search-filters-left.wizzy-v2 .facet-body-sellingPrice')
  //     .forEach(function (body) {
  //       var rangeItem = body.querySelector('.facet-range-item');
  //       var slider = body.querySelector('.noUi-target');
  
  //       if (!rangeItem || !slider) {
  //         return;
  //       }
  
  //       if (!body.querySelector('.wizzy-price-range-ui')) {
  //         var ui = document.createElement('div');
  //         ui.className = 'wizzy-price-range-ui';
  
  //         ui.innerHTML =
  //           '<div class="wizzy-price-range-header">Select Price Range</div>' +
  //           '<div class="wizzy-price-range-fields">' +
  //           '<label class="wizzy-price-range-field wizzy-price-range-field--min">' +
  //           '<span class="wizzy-price-range-field__label">Min</span>' +
  //           '<input type="text" class="wizzy-price-range-field__input wizzy-price-range-input-min" readonly />' +
  //           '</label>' +
  //           '<label class="wizzy-price-range-field wizzy-price-range-field--max">' +
  //           '<span class="wizzy-price-range-field__label">Max</span>' +
  //           '<input type="text" class="wizzy-price-range-field__input wizzy-price-range-input-max" readonly />' +
  //           '</label>' +
  //           '</div>' +
  //           '<div class="wizzy-price-range-slider-wrap"></div>' +
  //           '<div class="wizzy-price-range-bottom-values">' +
  //           '<span class="wizzy-price-range-bottom-min"></span>' +
  //           '<span class="wizzy-price-range-bottom-max"></span>' +
  //           '</div>';
  
  //         var sliderWrap = ui.querySelector('.wizzy-price-range-slider-wrap');
  //         var sliderParent = slider.parentNode;
  
  //         rangeItem.insertBefore(ui, rangeItem.firstChild);
  
  //         if (sliderParent === rangeItem) {
  //           sliderWrap.appendChild(slider);
  //         } else {
  //           sliderWrap.appendChild(sliderParent);
  //         }
  //       }
  
  //       wizzySyncPriceRangeFields(body);
  
  //       if (slider.noUiSlider && !slider.dataset.wizzyPriceBound) {
  //         slider.dataset.wizzyPriceBound = 'true';
  //         slider.noUiSlider.on('update', function () {
  //           wizzySyncPriceRangeFields(body);
  //         });
  //       } else if (!body.dataset.wizzyPriceObserverBound) {
  //         body.dataset.wizzyPriceObserverBound = 'true';
  //         var observer = new MutationObserver(function () {
  //           wizzySyncPriceRangeFields(body);
  //         });
  //         observer.observe(slider, {
  //           childList: true,
  //           subtree: true,
  //           characterData: true,
  //           attributes: true,
  //           attributeFilter: ['aria-valuenow'],
  //         });
  //       }
  //     });
  // }
  
  // function wizzyInitFacetSectionSearch(scopeEl) {
  //   var root = scopeEl || document;
  //   root.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
  //     var input = block.querySelector('input.facet-head-search-input');
  //     var list = block.querySelector('ul.wizzy-facet-list');
  //     if (!input || !list) return;
  
  //     if (input.__wzBound) return;
  //     input.__wzBound = true;
  
  //     var iconLink = block.querySelector('.facet-search-wrapper .facet-head-search a.facet-head-search-icon');
  //     if (iconLink && !iconLink.__wzBound) {
  //       iconLink.__wzBound = true;
  //       iconLink.addEventListener('click', function (e) {
  //         try {
  //           e.preventDefault();
  //           e.stopPropagation();
  //         } catch (e0) {}
  //         try {
  //           input.focus();
  //         } catch (e1) {}
  //       });
  //     }
  
  //     var onInput = function () {
  //       var q = (input.value || '').trim().toLowerCase();
  //       var items = list.querySelectorAll('.wizzy-facet-list-item');
  //       items.forEach(function (li) {
  //         var term = (li.getAttribute('data-term') || li.textContent || '').toLowerCase();
  //         var match = !q || term.indexOf(q) !== -1;
  //         li.style.display = match ? '' : 'none';
  //       });
  //     };
  
  //     input.addEventListener('input', onInput);
  //   });
  // }
  
  // function wizzyInitMobileFilterBar() {
  //   if (window.wizzyMobileFilterBarBound) {
  //     return;
  //   }
  
  //   window.wizzyMobileFilterBarBound = true;
  
  //   document.addEventListener('click', function (event) {
  //     const drawerCloseBtn = event.target.closest('.wizzy-search-wrapper .wizzy-mobile-filter-drawer-close');
  
  //     if (drawerCloseBtn) {
  //       event.preventDefault();
  //       const wrapper = drawerCloseBtn.closest('.wizzy-search-filters-left');
  //       const closeTrigger =
  //         (wrapper && wrapper.querySelector('.wizzy-filters-close-btn')) ||
  //         (wrapper && wrapper.querySelector('.wizzy-filters-close-button')) ||
  //         document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-btn');
  
  //       if (closeTrigger) {
  //         closeTrigger.click();
  //       }
  
  //       return;
  //     }
  
  //     const filterOpenBtn = event.target.closest('.wizzy-search-wrapper .wizzy-filters-mobile-entry');
  
  //     if (filterOpenBtn) {
  //       setTimeout(function () {
  //         // wizzyInitFacetSectionSearch();
  //         wizzyEnhancePriceFilterUI();
  //         wizzySlpSyncPendingFromApplied();
  //         wizzySyncApplyFilterButtonState();
  //       }, 150);
  //     }
  
  //     const facetHead = event.target.closest('.wizzy-search-filters-left.wizzy-v2 .wizzy-facet-head');
  
  //     // if (facetHead) {
  //     //   setTimeout(wizzyInitFacetSectionSearch, 80);
  //     // }
  
  //     const tileViewToggle = event.target.closest('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
  
  //     if (tileViewToggle) {
  //       event.preventDefault();
  //       const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  //       const currentLevel = wrapper ? wrapper.getAttribute('wizzy-tile-view-level') : '2';
  //       const newLevel = currentLevel === '1' ? '2' : '1';
  
  //       wizzySetTileViewLevel(newLevel, { activeIcon: tileViewToggle });
  //       return;
  //     }
  //   });
  // }
  
  // function wizzyInitQuickAddToggle() {
  //   if (window.wizzyQuickAddToggleBound) return;
  //   window.wizzyQuickAddToggleBound = true;
  
  //   document.addEventListener('click', function (event) {
  //     const button = event.target.closest(
  //       '.wizzy-search-results-list .btn-custom.select-switchs, .wizzy-search-wrapper .btn-custom.select-switchs'
  //     );
  //     if (!button) return;
  
  //     const gridProduct = button.closest('.grid-product');
  //     const colorSwitch = gridProduct ? gridProduct.querySelector('.color-switch') : null;
  //     if (!gridProduct) return;
  
  //     // ── NEW: check if this product has any size options ──────────────────
  //     const hasSizes = colorSwitch &&
  //       colorSwitch.querySelectorAll('.cstm_collection_add').length > 0;
  
  //     if (!hasSizes) {
  //       // No sizes — add to cart directly using the variant on the card
  //       event.stopImmediatePropagation();
  //       const variantId = gridProduct.getAttribute('data-variant-id');
  //       if (!variantId) return;
  
  //       fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ id: variantId, quantity: 1 })
  //       })
  //         .then(function (res) { return res.json(); })
  //         .then(function () {
  //           // Trigger whatever cart-open / mini-cart event your theme uses, e.g.:
  //           document.dispatchEvent(new CustomEvent('cart:updated'));
  //           // Or if your theme uses jQuery:
  //           // jQuery(document.body).trigger('added.wb.product', [variantId]);
  //         })
  //         .catch(function (err) { console.error('Wizzy direct ATC error:', err); });
  
  //       return; // ← don't open the drawer
  //     }
  //     // ── END NEW ──────────────────────────────────────────────────────────
  
  //     const activeSwatch = gridProduct.querySelector('a.product-color-swatch--active');
  //     const content = gridProduct.querySelector('.grid-product__content');
  
  //     function wizzyToggleQuickAddPanel() {
  //       colorSwitch.classList.toggle('switch-height');
  //       button.classList.toggle('switch-height');
  //       const iconPlus = button.querySelector('.icon-plus');
  //       const iconMinus = button.querySelector('.icon-minus');
  //       if (iconPlus) iconPlus.style.display = colorSwitch.classList.contains('switch-height') ? 'none' : '';
  //       if (iconMinus) iconMinus.style.display = colorSwitch.classList.contains('switch-height') ? '' : 'none';
  //     }
  
  //     function wizzyOpenQuickAddPanel() {
  //       if (content && content.dataset.wizzySizesLoaded !== 'true') {
  //         wizzyLoadSizedProductCard(gridProduct).then(wizzyToggleQuickAddPanel);
  //         return;
  //       }
  
  //       wizzyToggleQuickAddPanel();
  //     }
  
  //     event.stopImmediatePropagation();
  
  //     if (button.classList.contains('switch-height')) {
  //       wizzyToggleQuickAddPanel();
  //       return;
  //     }
  
  //     if (activeSwatch) {
  //       jQuery(document).one('colorChangeCompleted', function () {
  //         wizzyOpenQuickAddPanel();
  //       });
  //       activeSwatch.click();
  //       return;
  //     }
  
  //     wizzyOpenQuickAddPanel();
  //   }, true);
  // }
  // function wizzyIsSlpPage() {
  //   return !!document.querySelector('.wizzy-search-wrapper');
  // }
  // function wizzySyncAppliedFilterCounts() {
  //   const selectedItems = document.querySelectorAll(
  //     '.wizzy-selected-filters .wizzy-selected-facet-list-item'
  //   );
  
  //   selectedItems.forEach(function (selectedItem) {
  //     const facetKey = selectedItem.getAttribute('data-facetKey');
  //     const itemKey = selectedItem.getAttribute('data-key');
  //     const term = selectedItem.getAttribute('data-term');
  
  //     let matchedFacetItem = null;
  
  //     document
  //       .querySelectorAll('.wizzy-search-filters-left .wizzy-filters-facet-block')
  //       .forEach(function (facetBlock) {
  //         if (matchedFacetItem) return;
  
  //         const blockKey = facetBlock.getAttribute('data-key');
  
  //         // Make sure we are checking the same filter group.
  //         if (facetKey && blockKey && facetKey !== blockKey) {
  //           return;
  //         }
  
  //         facetBlock
  //           .querySelectorAll('.wizzy-facet-list-item')
  //           .forEach(function (facetItem) {
  //             if (matchedFacetItem) return;
  
  //             const currentKey = facetItem.getAttribute('data-key');
  //             const currentTerm = facetItem.getAttribute('data-term');
  
  //             if (
  //               (itemKey && currentKey === itemKey) ||
  //               (term && currentTerm === term)
  //             ) {
  //               matchedFacetItem = facetItem;
  //             }
  //           });
  //       });
  
  //     if (!matchedFacetItem) return;
  
  //     const countElement = matchedFacetItem.querySelector(
  //       '.wizzy-facet-list-item-count'
  //     );
  
  //     const selectedLabel = selectedItem.querySelector(
  //       '.facet-item-label-value'
  //     );
  
  //     if (!countElement || !selectedLabel) return;
  
  //     const countText = countElement.textContent.trim();
  
  //     if (!countText) return;
  
  //     let appliedCount = selectedLabel.querySelector(
  //       '.wizzy-selected-facet-count'
  //     );
  
  //     if (!appliedCount) {
  //       appliedCount = document.createElement('span');
  //       appliedCount.className = 'wizzy-selected-facet-count';
  //       selectedLabel.appendChild(appliedCount);
  //     }
  
  //     appliedCount.textContent = ' ' + countText;
  //   });
  // }
  // function wizzySlpGetFacetItemId(item) {
  //   const block = item.closest('.wizzy-filters-facet-block');
  //   const facetKey = block ? block.getAttribute('data-key') || '' : '';
  //   return facetKey + '::' + (item.getAttribute('data-key') || '') + '::' + (item.getAttribute('data-term') || '');
  // }
  
  // function wizzySlpGetAppliedFilterIds() {
  //   const applied = new Set();
  //   document.querySelectorAll('.wizzy-search-wrapper .wizzy-selected-filters .wizzy-selected-facet-list-item').forEach(function (tag) {
  //     applied.add(
  //       (tag.getAttribute('data-facetKey') || '') + '::' +
  //       (tag.getAttribute('data-key') || '') + '::' +
  //       (tag.getAttribute('data-term') || '')
  //     );
  //   });
  //   return applied;
  // }
  
  // function wizzySlpGetPendingFilterIds() {
  //   const pending = new Set();
  //   document.querySelectorAll('.wizzy-search-filters-left .wizzy-filters-facet-block').forEach(function (block) {
  //     const facetKey = block.getAttribute('data-key') || '';
  //     block.querySelectorAll('.wizzy-facet-list-item').forEach(function (item) {
  //       const checkbox = item.querySelector('input[type="checkbox"]');
  //       if (checkbox && checkbox.checked) {
  //         pending.add(facetKey + '::' + (item.getAttribute('data-key') || '') + '::' + (item.getAttribute('data-term') || ''));
  //       }
  //     });
  //   });
  //   return pending;
  // }
  
  // function wizzySlpToggleFacetItemUI(item, checked) {
  //   const checkbox = item.querySelector('input[type="checkbox"]');
  //   if (checkbox) {
  //     checkbox.checked = checked;
  //   }
  //   item.classList.toggle('active', checked);
  // }
  
  // function wizzySlpSyncPendingFromApplied() {
  //   if (!wizzyIsSlpPage() || window.wizzySlpHasPendingChanges) {
  //     return;
  //   }
  
  //   const applied = wizzySlpGetAppliedFilterIds();
  //   document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
  //     wizzySlpToggleFacetItemUI(item, applied.has(wizzySlpGetFacetItemId(item)));
  //   });
  //   wizzySyncApplyFilterButtonState();
  // }
  
  // function wizzySlpResetPendingFacetUI() {
  //   document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
  //     wizzySlpToggleFacetItemUI(item, false);
  //   });
  // }
  
  // function wizzySlpGetFacetItemsToToggle(applied, pending) {
  //   const items = [];
  //   document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
  //     const id = wizzySlpGetFacetItemId(item);
  //     const isApplied = applied.has(id);
  //     const isPending = pending.has(id);
  //     if (isApplied !== isPending) {
  //       items.push(item);
  //     }
  //   });
  //   return items;
  // }
  
  // function wizzySlpCloseMobileFilterDrawer() {
  //   const closeTrigger =
  //     document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-btn') ||
  //     document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-button');
  //   if (closeTrigger) {
  //     closeTrigger.click();
  //   }
  // }
  
  // function wizzySlpApplyPendingFilters() {
  //   const applied = wizzySlpGetAppliedFilterIds();
  //   const pending = wizzySlpGetPendingFilterIds();
  
  //   document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
  //     wizzySlpToggleFacetItemUI(item, applied.has(wizzySlpGetFacetItemId(item)));
  //   });
  
  //   const itemsToToggle = wizzySlpGetFacetItemsToToggle(applied, pending);
  
  //   if (!itemsToToggle.length) {
  //     wizzySlpCloseMobileFilterDrawer();
  //     window.wizzySlpHasPendingChanges = false;
  //     wizzySyncApplyFilterButtonState();
  //     return;
  //   }
  
  //   window.wizzySlpApplyingFilters = true;
  
  //   itemsToToggle.forEach(function (item, index) {
  //     window.wizzySlpAllowFilterExecution = index === itemsToToggle.length - 1;
  //     item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  //   });
  
  //   window.wizzySlpHasPendingChanges = false;
  
  //   setTimeout(function () {
  //     window.wizzySlpApplyingFilters = false;
  //     window.wizzySlpAllowFilterExecution = false;
  //     wizzySlpSyncPendingFromApplied();
  //     wizzySyncApplyFilterButtonState();
  //     wizzySlpCloseMobileFilterDrawer();
  //   }, 300);
  // }
  
  // function wizzyInitSlpManualFilters() {
  //   if (window.wizzySlpManualFiltersBound) {
  //     return;
  //   }
  
  //   window.wizzySlpManualFiltersBound = true;
  //   window.wizzySlpHasPendingChanges = false;
  //   window.wizzySlpApplyingFilters = false;
  //   window.wizzySlpAllowFilterExecution = false;
  
  //   document.addEventListener('click', function (event) {
  //     if (!wizzyIsSlpPage() || window.wizzySlpApplyingFilters) {
  //       return;
  //     }
  
  //     if (event.target.closest('.wizzy-apply-all-button, .wizzy-riyaasat-apply-filter')) {
  //       event.preventDefault();
  //       wizzySlpApplyPendingFilters();
  //       return;
  //     }
  
  //     if (event.target.closest('.wizzy-filters-clear-all, .wizzy-riyaasat-clear-all')) {
  //       const applied = wizzySlpGetAppliedFilterIds();
  
  //       if (!applied.size) {
  //         event.preventDefault();
  //         event.stopPropagation();
  //         event.stopImmediatePropagation();
  //         wizzySlpResetPendingFacetUI();
  //         window.wizzySlpHasPendingChanges = false;
  //         wizzySyncApplyFilterButtonState();
  //         return;
  //       }
  
  //       window.wizzySlpAllowFilterExecution = true;
  //       window.wizzySlpHasPendingChanges = false;
  //       setTimeout(function () {
  //         wizzySlpResetPendingFacetUI();
  //         window.wizzySlpAllowFilterExecution = false;
  //         wizzySyncApplyFilterButtonState();
  //       }, 300);
  //       return;
  //     }
  
  //     if (event.target.closest('.wizzy-selected-facet-list-item, .wizzy-selected-facet-delete')) {
  //       window.wizzySlpAllowFilterExecution = true;
  //       window.wizzySlpHasPendingChanges = false;
  //       setTimeout(function () {
  //         wizzySlpSyncPendingFromApplied();
  //         window.wizzySlpAllowFilterExecution = false;
  //         wizzySyncApplyFilterButtonState();
  //       }, 300);
  //       return;
  //     }
  
  //     const item = event.target.closest('.wizzy-search-filters-left .wizzy-facet-list-item');
  //     if (!item) {
  //       return;
  //     }
  
  //     event.preventDefault();
  //     event.stopPropagation();
  //     event.stopImmediatePropagation();
  
  //     const checkbox = item.querySelector('input[type="checkbox"]');
  //     wizzySlpToggleFacetItemUI(item, !(checkbox && checkbox.checked));
  //     window.wizzySlpHasPendingChanges = true;
  //     wizzySyncApplyFilterButtonState();
  //   }, true);
  // }
  
  // window.onWizzyScriptLoaded = function () {
  
  //   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(products) {
  //     if (Array.isArray(products)) {
  //       products.forEach(function (product) {
  //         wizzyEnrichProduct(product);
  
  //         if (product.attributes && product.attributes.length > 0) {
  //           product.attributes.forEach(function (attr) {
  //             if (attr.id === 'product_faq_text_custom') {
  //               product.faqText = attr.values[0].value[0];
  //             }
  
  //                       if (attr.id === "product_tags") {
  //               var tags = attr?.values?.[0]?.value?.[0] || "";
  
  //               var tagList = tags.split(",").map(function (t) {
  //                 return t.trim().toLowerCase();
  //               });
  
  //               if (tagList.indexOf("new") !== -1) {
  //                 product.newTag = true;
  //               }
  
  //               if (tagList.indexOf("bestseller") !== -1 || tagList.indexOf("bestsellers") !== -1) {
  //                 product.bestsellerTag = true;
  //               }
  //             }
  
  
  
  
  //             if (attr.id === 'product_badge_judgeme') {
  //               var badgeHtml = (attr.values && attr.values[0] && attr.values[0].value && attr.values[0].value[0]) || '';
  //               var ratingMatch = String(badgeHtml).match(/data-average-rating=['"]([\d.]+)['"]/i);
  //               var countMatch = String(badgeHtml).match(/data-number-of-reviews=['"](\d+)['"]/i);
  //               var rating = ratingMatch ? parseFloat(ratingMatch[1]) : NaN;
  //               var count = countMatch ? parseInt(countMatch[1], 10) : NaN;

  //               if (!isNaN(rating) && !isNaN(count) && count > 0 && rating > 0) {
  //                 product.hasReviews = true;
  //                 product.reviewRating = rating;
  //                 product.reviewCount = count;
  //                 product.reviewRatingDisplay = rating.toFixed(1);
  //               }
  //             }

  //             if (attr.id === 'product_product_type') {
  //               product.productType = attr.values[0].value[0];
  //             }
  
  //           });
  //         }
  //       });
  //     }
  
  //     return products;
  //   });
  
  //   const wizzyEvents = window.wizzyConfig.events;
  //   const allowedEvents = wizzyEvents.allowedEvents;
  
  //   ['AFTER_PRODUCTS_TRANSFORMED', 'AFTER_PRODUCTS_TRANSFORM', 'BEFORE_PRODUCTS_RENDER'].forEach(function (eventName) {
  //     if (!allowedEvents[eventName]) {
  //       return;
  //     }
  
  //     wizzyEvents.registerEvent(
  //       allowedEvents[eventName],
  //       function (data) {
  //         return wizzyTransformProducts(data);
  //       },
  //       2
  //     );
  
  //     if (window.wizzyConfig.events.allowedEvents[eventName]) {
  //       window.wizzyConfig.events.registerEvent(
  //         window.wizzyConfig.events.allowedEvents[eventName],
  //         function (data) {
  //           return wizzyTransformProducts(data);
  //         },
  //         2
  //       );
  //     }
  //   });
  
  //   if (allowedEvents.BEFORE_PRODUCTS_RENDER) {
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_PRODUCTS_RENDER,
  //       function (data) {
  //         var products = wizzyCollectProducts(data);
  
  //         if (!products.length) {
  //           return data;
  //         }
  
  //         products.forEach(function (product) {
  //           wizzyNormalizeVariantImages(product);
  //         });
  
  //         return data;
  //       },
  //       3
  //     );
  //   }
  //   wizzyEvents.registerEvent(
  //     allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  //     function (data) {
  
  //          // Include OOS products in autocomplete so Sold Out tag can render on suggestions.
  //       data.includeOutOfStock = 'true';
  //       data.variantsGroupBy = "virtualGroupId";
  
  //       return data;
  //     });
  //   wizzyEvents.registerEvent(
  //     allowedEvents.BEFORE_SEARCH_EXECUTED,
  //     function (data) {
  //     // data.variantsGroupBy = "virtualGroupId";
  //       wizzyHideAutocomplete(); 
  //       const searchClose = document.getElementById('SearchClose');
  
  //       if (searchClose) {
  //         searchClose.click();
  //       }
  //       const collectionHeader = document.querySelector(
  //         '.shopify-section[id$="__collection-header"]'
  //       );
  
  //       if (collectionHeader) {
  //         collectionHeader.style.display = "none";
  //       }
  
  //       const faqSection = document.querySelector(
  //   '[class*="__collection_revamp_faq_"]'
  // );
  
  //         if (faqSection) {
  //           faqSection.style.display = "none";
  //         }
  
  //         data.includeOutOfStock = 'true';
  //         data.getAllVariants = 'false';
  //         data.showOOSProductsInOrder = 'false';
  
  //         data.sort.push(
  //           {"field":"product_wizzy-best-selling_sortOrder:float","order":"asc"}
  //         );
  
  //               return data;
  //             },
  //             2
  //           );
  
  //   function addWizzySortCloseButton() {
  //     document
  //       .querySelectorAll('.wizzy-search-sort-wrapper .wizzy-common-select-options')
  //       .forEach(function (sortOptions) {
  //         if (sortOptions.querySelector('.wizzy-sort-popup-close-icon')) return;
  
  //         const closeBtn = document.createElement('button');
  //         closeBtn.type = 'button';
  //         closeBtn.className = 'wizzy-sort-popup-close-icon';
  //         closeBtn.innerHTML = '&times;';
  
  //         closeBtn.addEventListener('click', function (event) {
  //           event.preventDefault();
  //           event.stopPropagation();
  
  //           const sortContainer = closeBtn.closest('.wizzy-common-select-container');
  //           const sortSelector = sortContainer ? sortContainer.querySelector('.wizzy-common-select-selector') : null;
  //           const sortOverlay = sortContainer ? sortContainer.querySelector('.wizzy-common-select-overlay') : null;
  
  //           if (sortOverlay) {
  //             sortOverlay.click();
  //           } else if (sortSelector) {
  //             sortSelector.click();
  //           }
  
  //           sortOptions.style.display = 'none';
  //           document.body.classList.remove('wizzy-common-select-body-overlay');
  //         });
  
  //         sortOptions.prepend(closeBtn);
  //       });
  //   }
  
  //   // document.addEventListener('click', function () {
  //   //   setTimeout(addWizzySortCloseButton, 50);
  //   // });
  
  //   // addWizzySortCloseButton();
  
  //   function initWizzyAutocompleteBodyClass() {
  //     const targetNode = document.querySelector('.wizzy-body-end-wrapper');
  //     if (!targetNode) return;
  
  //     function updateAutocompleteClass() {
  //       const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  //       const isOpen = autocompleteElement && window.getComputedStyle(autocompleteElement).display !== 'none';
  
  //       document.body.classList.toggle('wizzy-autocomplete-open', !!isOpen);
  //       document.documentElement.classList.toggle('wizzy-autocomplete-open', !!isOpen);
  //     }
  
  //     const observer = new MutationObserver(function () {
  //       updateAutocompleteClass();
  //     });
  
  //     observer.observe(targetNode, {
  //       childList: true,
  //       subtree: true,
  //       attributes: true,
  //       attributeFilter: ['style', 'class']
  //     });
  
  //     updateAutocompleteClass();
  //   }
  
  //   function initWizzyProductCardSliders() {
  //     wizzyInitProductImageSlidersIn(document);
  //   }
  
  //   function initWizzyColorGridSliders() {
  //     if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
  //       return;
  //     }
  
  //     jQuery('.wizzy-search-results-list .collection-product-color-grid, .wizzy-search-results .collection-product-color-grid, .wizzy-search-wrapper .collection-product-color-grid').each(function () {
  //       const slider = jQuery(this);
  
  //       if (slider.hasClass('slick-initialized')) return;
  //       if (!slider.find('.custom-product-card__color-swatches-wrapper').length) return;
  
  //       slider.slick({
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         arrows: true,
  //         infinite: false,
  //         autoplay: false,
  //         prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="11" stroke="#aaa" stroke-width="1" fill="none"/><path d="M14 8l-4 4 4 4" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  //         nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="11" stroke="#aaa" stroke-width="1" fill="none"/><path d="M10 8l4 4-4 4" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  //         responsive: [
  //           { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 1 } },
  //           { breakpoint: 769, settings: { slidesToShow: 4, slidesToScroll: 1 } },
  //           { breakpoint: 374, settings: { slidesToShow: 3, slidesToScroll: 1 } }
  //         ]
  //       });
  //     });
  //   }
  
  //   function initWizzyColorSwatches() {
  //     if (!window.jQuery) return;
  
  //     jQuery('.wizzy-search-results-list .color-swatch--with-image, .wizzy-search-results .color-swatch--with-image, .wizzy-search-wrapper .color-swatch--with-image').each(function () {
  //       const swatch = this;
  
  //       if (swatch.dataset.wizzySwatchBound === 'true') return;
  //       swatch.dataset.wizzySwatchBound = 'true';
  
  //       jQuery(swatch).on('click', function (event) {
  //         event.preventDefault();
  
  //         const target = event.currentTarget;
  //         const targetId = target.dataset.variantId;
  //         const productUrl = target.getAttribute('data-url');
  //         const colorLabel = target.getAttribute('data-value') || '';
  
  //         if (!targetId || !colorLabel || !productUrl) return;
  
  //         const productContent = target.closest('.grid-product__content');
  //         const colorsContainer = target.closest('.grid-product__colors');
  
  //         if (colorsContainer) {
  //           colorsContainer.querySelectorAll('.color-swatch').forEach(function (item) {
  //             item.classList.remove('active', 'product-color-swatch--active');
  //           });
  //         }
  
  //         target.classList.add('active', 'product-color-swatch--active');
  
  //         const gridProduct = target.closest('.grid-product');
  
  //         if (gridProduct) {
  //           gridProduct.setAttribute('data-variant-id', targetId);
  
  //           const quickAddBtn = productContent ? productContent.querySelector('.withoutSIzeVariants') : null;
  
  //           if (quickAddBtn) {
  //             quickAddBtn.setAttribute('vid-product-id', targetId);
  //           }
  
  //           wizzyUpdateProductLinks(productContent, targetId, productUrl);
  //         }
  
  //         const allImages = wizzyGetStoredProductAllImages(gridProduct);
  //         var resolvedImages = wizzyGetOrderedColorImages(allImages, colorLabel);
  
  //         if (!resolvedImages.length) {
  //           var swatchImage =
  //             target.getAttribute('data-variant-image') ||
  //             (target.querySelector('img') && target.querySelector('img').getAttribute('src')) ||
  //             '';
  
  //           if (swatchImage) {
  //             resolvedImages = [swatchImage];
  //           }
  //         }
  
  //         if (resolvedImages.length && productContent) {
  //           wizzyStoreProductGallery(
  //             [
  //               targetId,
  //               gridProduct.getAttribute('data-product-id'),
  //               gridProduct.getAttribute('data-id'),
  //               gridProduct.getAttribute('data-groupId')
  //             ],
  //             resolvedImages
  //           );
  //           gridProduct.dataset.wizzyGalleryBound = 'false';
  //           wizzyUpdateProductCardImagesFromUrls(productContent, resolvedImages, {
  //             heroOnly: true
  //           });
  //           wizzyBindProductCardGalleryOnDemand(gridProduct);
  //         }
  
  //         if (gridProduct) {
  //           if (allImages.length) {
  //             window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  //             window.wizzyProductAllImagesById[String(targetId)] = allImages.slice();
  //           }
  
  //           wizzyMarkVariantImageReady(gridProduct);
  //         }
  
  //         jQuery(document).trigger('colorChangeCompleted', [target]);
  //       });
  //     });
  //   }
  
  //   function initWizzySearchProductCards() {
  //     wizzyInitMobileFilterBar();
  //     // wizzyInitFacetSectionSearch();
  //     wizzyEnhancePriceFilterUI();
  //     wizzyRestoreTileViewLevel();
  //     wizzyInitQuickAddToggle();
  //     wizzySyncMobileFilterLabel();
  
  //     var metaPromise = wizzyInitProductCardMeta().then(function () {
  //       wizzyRevealProductRatings();
  //     });
  
  //     wizzyUpgradeDirectAddCards().then(function () {
  //       wizzyInitSizedProductCards();
  //     });
  
  //     initWizzyProductCardSliders();
  //     initWizzyColorGridSliders();
  //     initWizzyColorSwatches();
  //     wizzyInitSizedProductCards();
  //     wizzyInitInitialVariantImages();
  //     wizzyInitProductCardGalleriesOnDemand(document);
  
  //     return metaPromise;
  //   }
  
  //   function wizzyFixPaginationLikeRiyaasat() {
  //     const pagesBefore = 1;
  //     const pagesAfter = 2;
  
  //     const pagination = document.querySelector('.wizzy-search-pagination .wizzy-pagination-list');
  //     if (!pagination) return;
  
  //     const activePageEl = pagination.querySelector('li.active[data-page]');
  //     const pageEls = Array.from(pagination.querySelectorAll('li[data-page]'));
  
  //     if (!activePageEl || !pageEls.length) return;
  
  //     const activePage = parseInt(activePageEl.dataset.page, 10);
  //     const lastPage = Math.max(
  //       ...pageEls
  //         .map(function (li) {
  //           return parseInt(li.dataset.page, 10);
  //         })
  //         .filter(Boolean)
  //     );
  
  //     if (!activePage || !lastPage) return;
  
  //     const pages = new Set([1, lastPage]);
  
  //     for (let i = activePage - pagesBefore; i <= activePage + pagesAfter; i++) {
  //       if (i >= 1 && i <= lastPage) {
  //         pages.add(i);
  //       }
  //     }
  
  //     const sortedPages = Array.from(pages).sort(function (a, b) {
  //       return a - b;
  //     });
  
  //     const nextArrow = pagination.querySelector('.next-arrow');
  
  //     pagination.querySelectorAll('li:not(.pagination-arrow)').forEach(function (li) {
  //       li.remove();
  //     });
  
  //     sortedPages.forEach(function (page, index) {
  //       const previousPage = sortedPages[index - 1];
  
  //       if (index > 0 && page - previousPage > 1) {
  //         const dots = document.createElement('li');
  //         dots.className = 'wizzy-pagination-dots';
  //         dots.innerHTML = '<a><span class="text">...</span></a>';
  //         pagination.insertBefore(dots, nextArrow);
  //       }
  
  //       const li = document.createElement('li');
  //       li.setAttribute('title', String(page));
  //       li.setAttribute('data-page', String(page));
  
  //       if (page === activePage) {
  //         li.classList.add('active');
  //       }
  
  //       li.innerHTML = '<a href="#"><span class="text">' + page + '</span></a>';
  //       pagination.insertBefore(li, nextArrow);
  //     });
  //   }
  
  //   function wizzyRemovePageFromUrl() {
  //     if (!window.location.search.includes('page=')) return;
  
  //     const cleanUrl = window.location.origin + window.location.pathname;
  //     window.history.replaceState({}, '', cleanUrl);
  //   }
  
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_INIT,
  //       function (data) {
  //         if (data.search && data.search.configs && data.search.configs.pagination) {
  //           data.search.configs.pagination.appendInExistingList = window.innerWidth <= 768;
  //         }
  
  //         data.filters.configs.keepOpenedInMobileAfterApply = !0;
  //         data.filters.configs.applyOnSelect = !1;
  //         data.search.configs.pagination.appendInExistingList = !0,
  //         window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
  //         desktop: 2000, mobile: 2500
  //       }
  
  
  //         return data;
  //       },
  //       2
  //     );
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_RENDER_RESULTS,
  //       function (payload) {
  //         if (payload.api === 'search' || payload.api === 'filter') {
  //           var products =
  //             payload.response &&
  //             payload.response.payload &&
  //             payload.response.payload.products;
  
  //           if (products && products.length) {
  //             products.forEach(wizzyEnrichProduct);
  //           }
  //         }
  
  //         return payload;
  //       },
  //       1
  //     );
  
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_RENDER_RESULTS,
  //       function (payload) {
  
  //     if (payload.api === "search" || payload.api === "filter") {
  //       const facets = payload.response.payload.facets;
  
  //       facets?.forEach((facet) => {
  //         if (facet.key === "colors") {
  //           const facetData = facet.data;
  
  //           facetData?.forEach((item) => {
  //             const color = colorMap[item.label] || "#fff";
  
  //             item.isSwatch = true;
  //             item.isURLSwatch = false;
  //             item.isVisualSwatch = true;
  //             item.swatchValue = color;
  
  //             item.data = {
  //               value: item.key,
  //               swatch: {
  //                 type: "visual",
  //                 value: color,
  //               },
  //             };
  
  //             item.code = color;
  //           });
  //         }
  //       });
  //     }
  
  
  //     return payload;
  //   }
  // );
  
    
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_LAZY_INIT,
  //       function (data) {
  //         if (data.search && data.search.configs && data.search.configs.pagination) {
  //           data.search.configs.pagination.appendInExistingList = window.innerWidth <= 768;
  //         }
  //         data.filters.configs.keepOpenedInMobileAfterApply = !0;
  //         data.filters.configs.applyOnSelect = !1;
  //         return data;
  //       },
  //       2
  //     );
  
  //   if (allowedEvents.BEFORE_FILTERS_EXECUTED) {
  //     wizzyEvents.registerEvent(
  //       allowedEvents.BEFORE_FILTERS_EXECUTED,
  //       function (data) {
  //         if(window.wizzyConfig.common.isOnCategoryPage || data.group === "defaultMenu") {
  //           data.filters.variantsGroupBy = "virtualGroupId";
  //         } else  {
  //           data.filters.inStock = ['true','false'];
  //           data.filters.getAllVariants = 'false';
  //           data.filters.showOOSProductsInOrder = 'false';
  //         }
  
  //         return data;
  //       },
  //       2
  //     );
  //   }
  
  //   wizzyInitSlpManualFilters();
    
  
  //   ['VIEW_RENDERED', 'PRODUCTS_RESULTS_RENDERED', 'PRODUCTS_CACHED_RESULTS_RENDERED'].forEach(function (eventName) {
  //     if (!allowedEvents[eventName]) return;
  
  //     wizzyEvents.registerEvent(
  //       allowedEvents[eventName],
  //       function (data) {
  //         setTimeout(function () {
  //           wizzyRemovePageFromUrl();
  //           wizzyFixPaginationLikeRiyaasat();
  //           initWizzySearchProductCards();
  //           wizzySyncMobileFilterLabel();
  //           wizzySlpSyncPendingFromApplied();
  //           wizzySyncApplyFilterButtonState();
  //           initWizzyProductCardSliders();
  
  //           // Add count to Applied Filter
  //         wizzySyncAppliedFilterCounts();
  
  //         }, 100);
  
  //         return data;
  //       },
  //       2
  //     );
  //   });
  
  //   setTimeout(initWizzyAutocompleteBodyClass, 1000);
  //   setTimeout(initWizzySearchProductCards, 500);
  
  
  
  
  
  //   window.wizzyConfig.events.registerEvent(
  //     window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  //     function (data) {
  
  //         document.querySelector('.wizzy-common-select-close')?.addEventListener('click', () => {
  //             document.querySelector('.wizzy-common-select-selector')?.click();
  //         });
  
  // if (window.innerWidth > 768) {
  //   const parent = document.querySelector('.wizzy-search-filters-top');
  //   const filter = document?.querySelector('#collection-filter');
  
  //   if (parent && filter) {
  //     parent.insertBefore(filter, parent.firstChild);
  //   }
  // }
  //       setTimeout(function () {
  //         wizzyRemovePageFromUrl();
  //         wizzyFixPaginationLikeRiyaasat();
  //       }, 50);
  
  //       return data;
  //     },
  //     2
  //   );
  
  
  
  // setTimeout(initWizzyAutocompleteBodyClass, 1000);
  //   window.wizzyConfig.events.registerEvent(
  //     window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  //     function (data) {
  //       setTimeout(function () {
  //         wizzyFixPaginationLikeRiyaasat();
  //         initWizzySearchProductCards();
  //       }, 50);
  //       return data;
  //     },
  //     2
  //   );
  
  
    
  // };
  
  // function wizzyHideAutocomplete() {
  //   var autocomplete =
  //     document.querySelector('.wizzy-autocomplete-wrapper') ||
  //     document.querySelector('.wizzy-body-end-wrapper .wizzy-autocomplete-wrapper');
  
  //   if (autocomplete) {
  //     autocomplete.style.display = 'none';
  //   }
  
  //   document.body.classList.remove('wizzy-autocomplete-open');
  //   document.documentElement.classList.remove('wizzy-autocomplete-open');
  // }
  
  // function wizzyRemovePageFromUrl() {
  //   if (!window.location.search.includes('page=')) return;
  
  //   const cleanUrl = window.location.origin + window.location.pathname;
  //   window.history.replaceState({}, '', cleanUrl);
  // }
  
  
  
    const colorMap = {

    "IceLattecherry": "#C86A6A",
  "Espresso Cream": "#E7D7B8",
  "Midnight Lilac": "#5C4B6B",
    "Espresso Mint": "#7A8C72",
  "EspressoMatcha": "#8B8A5A",
  "IceLattecherry": "#C86A6A",
  "IceLatteMint": "#B8D4C2",
  "Iced Matcha Latte": "#B6C99A",
  "Latte Caramel": "#C68E52",
  "Vanilla Latte": "#F3E5C3",
  "Espresso": "#4B2E2B",
  "Espresso Shot": "#2F1B14",
  "Orange Zest": "#FF8C00",
    "Dark Roast": "#4A2C2A",
  "Nitro Cold Brew": "#5A4A42",
  "Rose White": "#F8F4F2",
  "Silver Mocha": "#B8B3AA",
  "Trippy": "#7B5FA7",
  "Lavender": "#E6E6FA",
  "Chocolate": "#7B3F00",
  "Camel": "#C19A6B",
    "Dusty Blue": "#6E8FA3",
    "Espresso Kiwi Spin": "#5C4A3D",
    "Golden": "#D4AF37",
    "Iced Brew Twist": "#8B6F5A",
    "Iced Matcha": "#B7C99A",
    "Mauve Pink": "#D8A7B1",
    "Shadow Chrome": "#7A7F87",
    "Nude": "#E3C7B5",
    "Artic Cold Brew": "#A49A8A",
    "Blue-Mustard": "#6C7A2D",
    Beige: "#F5F5DC",
    Black: "#000000",
    Blue: "#0000FF",
    Brown: "#A52A2A",
    Burgundy: "#800020",
    Coral: "#FF7F50",
    Cream: "#FDFBD4",
    Green: "#008000",
    Grey: "#808080",
    Ivory: "#FFFFF0",
    Lime: "#00FF00",
    Maroon: "#800000",
    Mauve: "#E0B0FF",
    Mint: "#98FF98",
    Navy: "#000080",
    Olive: "#808000",
    Orange: "#FFA500",
    Peach: "#FFE5B4",
    Pink: "#FFC0CB",
    Pista: "#93C572",
    Purple: "#800080",
    Red: "#FF0000",
    Rust: "#B7410E",
    Teal: "#008080",
    Violet: "#8F00FF",
    White: "#FFFFFF",
    Wine: "#722F37",
    Yellow: "#FFFF00",
    Gold:   "#d4af37",
    "White Gold":"#e4e4e4",
    "Rose Gold" :"#c48a8a",
      "Dark Pink": "#E75480",
    "Dark Green": "#006400",
    Turquoise: "#40E0D0",
    "Light Blue": "#ADD8E6",
    "Light Pink": "#FFB6C1",
    "Burnt Orange": "#CC5500",
    "Magenta Pink": "#FF00AF",
    "Royal Blue": "#4169E1",
    "Off White": "#F8F0E3",
  
    // normalized keys
    "Multi Colour": "#CCCCCC",
    "OffWhite": "#F8F0E3",
    "Amazon Red": "#c2292c",
    "Artic White": "#FFFFFF",
    "Ash Mist": "#000000",
    "Baby Pink": "#FFC0CB",
    "Beige": "#EAD8AB",
    "Burgundy": "#b72846",
    "Cappuccino Brown": "#b6a689",
    "Carbon Black": "#2e2b2b",
    "Classic Black": "#000000",
    "Coral Red": "#F61F1F",
    "Crafty Pink": "#FFC0CB",
    "Curious Green": "#05AA3D",
    "Dove Grey": "#808080",
    "Electric Blue": "#005BD3",
    "Fern Mist": "#52a19b",
    "Krypton Blue": "#005BD3",
    "Lavender Mist": "#e4d8e6",
    "Light Blue": "#64aaff",
    "Magnetic Turquoise": "#40e0d0",
    "Mighty Black": "#000000",
    "Mint Frost": "#55a572",
    "Mocha Brown": "#433c30",
    "Mocha Frost": "#604527",
    "Mocha mist": "#7a6b56",
    "Monochrome Black": "#0d0d0d",
    "Monsoon Grey": "#808080",
    "Mustard Yellow": "#eac000",
    "Mystery Blue": "#13346e",
    "Noir": "#000000",
    "Passion Red": "#F61F1F",
    "Pastel Green": "#85a48b",
    "Pastel Lavender": "#d7b1ff",
    "pastel yellow": "#edf09a",
    "Pastel Yellow": "#FFE500",
    "Peach": "#ffb07c",
    "Pearl White": "#afaca3",
    "Pink": "#ff8fa3",
    "Quirky Grey": "#808080",
    "Rose Shadow": "#f0c4b9",
    "Royal Cherry": "#971a17",
    "Sage Mist": "#077f38",
    "Silver Lining": "#636361",
    "Sky Mist": "#6f8fb6",
    "Slate Grey": "#353736",
    "Stormy White": "#FFFFFF",
    "Tangy Purple": "#A54DCF",
    "Walnut Frost": "#b5a284",
    "White": "#FFFFFF",
    "WhiteOut": "#FFFFFF",
    "Olive Green": "#808000",
    "Lemon Green": "#9ACD32",
    "Tango Red": "#E63946",
    "Brown": "#A52A2A",
    "Mango Yellow": "#FFC324",
    "Maroon": "#800000",
    "Azure Blue": "#007FFF",
    "Earthy Tan": "#D2B48C",
    "Lavender Purple": "#967BB6",
    "Sea Green": "#2E8B57",
    "Black": "#000000",
    "Chocolate Brown": "#7B3F00",
    "Dark Grey": "#A9A9A9",
    "Jade Green": "#00A86B",
    "Mint Green": "#98FF98",
    "Sand": "#C2B280",
    "Black Sand": "#3B3B3B",
    "Canvas White": "#F8F4E3",
    "Carrot": "#ED9121",
    "Orange": "#FFA500",
    "Red Mist": "#C75D5D",
    "Tan": "#D2B48C"
  };
  
  
  function wizzySlugify(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
  }
  
  function wizzyGetHandleFromAttributes(product) {
    if (product.handle) {
      return product.handle;
    }
  
    const attrs = product.attributes || [];
    const handleAttr = attrs.find(function (attr) {
      return attr.id === 'product_handle';
    });
  
    if (handleAttr && handleAttr.values && handleAttr.values[0] && handleAttr.values[0].value) {
      return handleAttr.values[0].value[0];
    }
  
    return '';
  }
  
  function wizzyGetTagsFromAttributes(product) {
    const attrs = product.attributes || [];
    const tagsAttr = attrs.find(function (attr) {
      return attr.id === 'product_tags';
    });
  
    if (!tagsAttr || !tagsAttr.values || !tagsAttr.values[0] || !tagsAttr.values[0].value) {
      return [];
    }
  
    const rawTags = tagsAttr.values[0].value[0];
    return String(rawTags)
      .split(',')
      .map(function (tag) {
        return tag.trim().toLowerCase();
      })
      .filter(Boolean);
  }
  
  function wizzyGetAttributeValue(product, attributeId) {
    const attrs = product.attributes || [];
    const match = attrs.find(function (attr) {
      return attr.id === attributeId;
    });
  
    if (!match || !match.values || !match.values[0] || !match.values[0].value) {
      return '';
    }
  
    return String(match.values[0].value[0] || '');
  }
  
  function wizzyProductHasNoSizeTag(product) {
    if (product.isNoSize === true) {
      return true;
    }
  
    const tags = wizzyGetTagsFromAttributes(product);
  
    if (tags.indexOf('nosize') !== -1) {
      return true;
    }
  
    if (tags.length) {
      return false;
    }
  
    const productType = wizzyGetAttributeValue(product, 'product_product_type').toLowerCase();
    return productType.indexOf('sock') !== -1;
  }
  
  function wizzyDeduplicateColorValues(colorValues, product) {
    if (!colorValues || !colorValues.length) {
      return [];
    }
  
    var grouped = {};
    var order = [];
    var currentColorValue = null;
  
    colorValues.forEach(function (entry) {
      var key = String(entry.value || '').trim().toLowerCase();
      if (!key) {
        return;
      }
  
      if (String(entry.variationId) === String(product.id)) {
        currentColorValue = key;
      }
  
      if (!grouped[key]) {
        grouped[key] = {
          value: entry.value,
          entries: []
        };
        order.push(key);
      }
  
      grouped[key].entries.push(entry);
    });
  
    return order.map(function (key) {
      var group = grouped[key];
      var entries = group.entries;
      var selectedEntry = null;
      var hasInStock = false;
  
      entries.forEach(function (entry) {
        if (entry.inStock !== false) {
          hasInStock = true;
          if (!selectedEntry) {
            selectedEntry = entry;
          }
        }
      });
  
      if (!selectedEntry) {
        selectedEntry = entries[0];
      }
  
      var color = {
        variationId: selectedEntry.variationId,
        inStock: hasInStock,
        value: group.value,
        image:
          selectedEntry.image ||
          selectedEntry.imageUrl ||
          selectedEntry.mainImage ||
          selectedEntry.variationImage ||
          selectedEntry.swatchImage ||
          null
      };
  
      if (currentColorValue) {
        color.isSelected = key === currentColorValue;
      } else {
        color.isSelected = String(color.variationId) === String(product.id);
      }
  
      return color;
    });
  }
  
  function wizzyPrepareSwatchesForTemplate(product) {
    product.handle = wizzyGetHandleFromAttributes(product) || product.handle || '';
  
    if (!product.swatches) {
      product.hasColorSwatches = false;
      return;
    }
  
    var swatchGroups = Array.isArray(product.swatches)
      ? product.swatches
      : Object.keys(product.swatches).map(function (key) {
          var group = product.swatches[key];
          group.key = group.key || key;
          return group;
        });
  
    product.swatches = swatchGroups.map(function (group) {
      if (group.key === 'colors' && group.values && group.values.length) {
        group.isColorGroup = true;
        group.handle = product.handle;
        group.productName = product.name || '';
        group.discountPercentage = product.discountPercentage;
        group.values = wizzyDeduplicateColorValues(group.values, product);
        group.values.forEach(function (value) {
          value.slug = wizzySlugify(value.value);
  
          if (!value.swatchValue) {
            var shopOrigin =
              window.Shopify && window.Shopify.shop
                ? 'https://' + window.Shopify.shop
                : window.location && window.location.origin
                  ? window.location.origin
                  : '';
  
            if (shopOrigin) {
              value.isVisualSwatch = true;
              value.isURLSwatch = true;
              value.swatchValue = shopOrigin + '/cdn/shop/files/' + value.slug + '_50x50.png';
            }
          }
        });
        group.showColorGrid = group.values.length > 1;
      }
  
      return group;
    });
  
    product.hasColorSwatches = product.swatches.some(function (group) {
      return group.isColorGroup && group.showColorGrid;
    });
  }
  
  var WIZZY_IMG_CACHE_STORAGE_KEY = 'wizzy-variant-image-cache-v1';
  var WIZZY_IMG_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
  var WIZZY_IMG_CACHE_MAX_ENTRIES = 300;
  var wizzyImgCacheSaveTimer = null;
  
  function wizzyGetCachedVariantImageUrls(cacheKey) {
    var entry = window.wizzyVariantImageCache[String(cacheKey)];
  
    if (!entry) {
      return null;
    }
  
    if (Array.isArray(entry)) {
      return entry.length ? entry : null;
    }
  
    if (entry.urls && entry.urls.length) {
      return entry.urls;
    }
  
    return null;
  }
  
  function wizzyLoadImageCacheFromStorage() {
    try {
      var raw = sessionStorage.getItem(WIZZY_IMG_CACHE_STORAGE_KEY);
  
      if (!raw) {
        return {};
      }
  
      var parsed = JSON.parse(raw);
      var entries = parsed && parsed.entries ? parsed.entries : parsed;
      var now = Date.now();
      var hydrated = {};
  
      if (!entries || typeof entries !== 'object') {
        return {};
      }
  
      Object.keys(entries).forEach(function (key) {
        if (key.indexOf('__pending') !== -1) {
          return;
        }
  
        var item = entries[key];
        var urls = null;
        var ts = 0;
  
        if (Array.isArray(item)) {
          urls = item;
          ts = now;
        } else if (item && Array.isArray(item.urls)) {
          urls = item.urls;
          ts = item.ts || 0;
        }
  
        if (!urls || !urls.length) {
          return;
        }
  
        if (ts && now - ts > WIZZY_IMG_CACHE_TTL_MS) {
          return;
        }
  
        hydrated[key] = {
          urls: urls,
          ts: ts || now
        };
      });
  
      return hydrated;
    } catch (error) {
      return {};
    }
  }
  
  function wizzyPruneImageCacheEntries(entries) {
    var keys = Object.keys(entries);
  
    if (keys.length <= WIZZY_IMG_CACHE_MAX_ENTRIES) {
      return entries;
    }
  
    keys.sort(function (a, b) {
      return (entries[a].ts || 0) - (entries[b].ts || 0);
    });
  
    var pruned = {};
    keys.slice(keys.length - WIZZY_IMG_CACHE_MAX_ENTRIES).forEach(function (key) {
      pruned[key] = entries[key];
    });
  
    return pruned;
  }
  
  function wizzySaveImageCacheToStorage() {
    try {
      var entries = {};
  
      Object.keys(window.wizzyVariantImageCache).forEach(function (key) {
        if (key.indexOf('__pending') !== -1) {
          return;
        }
  
        var urls = wizzyGetCachedVariantImageUrls(key);
  
        if (!urls || !urls.length) {
          return;
        }
  
        var existing = window.wizzyVariantImageCache[key];
        entries[key] = {
          urls: urls,
          ts: existing && existing.ts ? existing.ts : Date.now()
        };
      });
  
      entries = wizzyPruneImageCacheEntries(entries);
  
      sessionStorage.setItem(
        WIZZY_IMG_CACHE_STORAGE_KEY,
        JSON.stringify({
          v: 1,
          entries: entries
        })
      );
  
      Object.keys(window.wizzyVariantImageCache).forEach(function (key) {
        if (key.indexOf('__pending') !== -1) {
          return;
        }
  
        if (!entries[key]) {
          delete window.wizzyVariantImageCache[key];
        }
      });
  
      Object.keys(entries).forEach(function (key) {
        window.wizzyVariantImageCache[key] = entries[key];
      });
    } catch (error) {
      // Quota or private mode — keep in-memory cache only.
    }
  }
  
  function wizzyScheduleImageCacheSave() {
    if (wizzyImgCacheSaveTimer) {
      clearTimeout(wizzyImgCacheSaveTimer);
    }
  
    wizzyImgCacheSaveTimer = setTimeout(function () {
      wizzyImgCacheSaveTimer = null;
      wizzySaveImageCacheToStorage();
    }, 120);
  }
  
  function wizzySetVariantImageCache(cacheKey, urls) {
    if (!cacheKey || !urls || !urls.length) {
      return;
    }
  
    window.wizzyVariantImageCache[String(cacheKey)] = {
      urls: urls.slice(),
      ts: Date.now()
    };
    wizzyScheduleImageCacheSave();
  }
  
  window.wizzyVariantImageCache = Object.assign(
    {},
    wizzyLoadImageCacheFromStorage(),
    window.wizzyVariantImageCache || {}
  );
  
  function wizzyCollectProducts(data) {
    if (!data) {
      return [];
    }
  
    if (Array.isArray(data)) {
      return data;
    }
  
    if (data.id && (data.swatches || data.name)) {
      return [data];
    }
  
    if (data.products && data.products.length) {
      return data.products;
    }
  
    if (data.search && data.search.products && data.search.products.length) {
      return data.search.products;
    }
  
    if (data.response && data.response.products && data.response.products.length) {
      return data.response.products;
    }
  
    if (data.results && data.results.products && data.results.products.length) {
      return data.results.products;
    }
  
    return [];
  }
  
  function wizzyParseCardViewImageUrls(htmlText) {
    var html = new DOMParser().parseFromString(htmlText, 'text/html');
    var imgs = html.querySelectorAll('.product-images.grid-product__link img');
    var urls = [];
  
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || img.getAttribute('data-src');
  
      if (src) {
        urls.push(src);
      }
    });
  
    return urls;
  }
  
  window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
  function wizzyHandleize(label) {
    return String(label || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  
  function wizzyGetAltFromImageUrl(imageUrl) {
    if (!imageUrl || typeof imageUrl !== 'string') {
      return '';
    }
  
    try {
      var url = new URL(imageUrl, window.location.origin);
      var alt = url.searchParams.get('alt') || '';
      return decodeURIComponent(alt).toLowerCase().trim();
    } catch (error) {
      var match = imageUrl.match(/[?&]alt=([^&]*)/i);
      if (!match) {
        return '';
      }
  
      try {
        return decodeURIComponent(match[1]).toLowerCase().trim();
      } catch (decodeError) {
        return String(match[1] || '').toLowerCase().trim();
      }
    }
  }
  
  function wizzyStripAltFromImageUrl(imageUrl) {
    if (!imageUrl || typeof imageUrl !== 'string') {
      return '';
    }
  
    try {
      var url = new URL(imageUrl, window.location.origin);
      url.searchParams.delete('alt');
      return url.toString();
    } catch (error) {
      return imageUrl
        .replace(/([?&])alt=[^&]*/i, '$1')
        .replace(/\?&/, '?')
        .replace(/[?&]$/, '');
    }
  }
  
  function wizzyImageAltMatchesColor(alt, colorHandle) {
    if (!alt || !colorHandle) {
      return false;
    }
  
    var key = String(colorHandle).toLowerCase();
    var clKey = 'cl-' + key;
    var normalizedAlt = String(alt).toLowerCase();
  
    return (
      normalizedAlt === key ||
      normalizedAlt.indexOf(key) !== -1 ||
      normalizedAlt.indexOf(clKey) !== -1
    );
  }
  
  function wizzyGetColorSwatchGroups(product) {
    if (!product || !product.swatches) {
      return [];
    }
  
    return Array.isArray(product.swatches)
      ? product.swatches
      : Object.keys(product.swatches).map(function (key) {
          return product.swatches[key];
        });
  }
  
  function wizzyGetSelectedColorEntry(product) {
    var groups = wizzyGetColorSwatchGroups(product);
  
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
  
      if (group.key !== 'colors' || !group.values || !group.values.length) {
        continue;
      }
  
      for (var j = 0; j < group.values.length; j++) {
        if (group.values[j].isSelected) {
          return group.values[j];
        }
      }
    }
  
    return null;
  }
  
  function wizzyGetSelectedColorLabel(product) {
    var selected = wizzyGetSelectedColorEntry(product);
  
    if (!selected) {
      return '';
    }
  
    return selected.value || selected.label || selected.slug || '';
  }
  
  function wizzyNormalizeImageList(images) {
    if (!images) {
      return [];
    }
  
    if (!Array.isArray(images)) {
      return [String(images)];
    }
  
    return images
      .map(function (item) {
        if (!item) {
          return '';
        }
  
        if (typeof item === 'string') {
          return item;
        }
  
        return item.url || item.src || item.image || '';
      })
      .filter(Boolean);
  }
  
  function wizzyFilterImagesByColorAlt(images, colorLabel) {
    return wizzyGetOrderedColorImages(images, colorLabel);
  }
  
  function wizzyGetOrderedColorImages(images, colorLabel) {
    var colorHandle = wizzyHandleize(colorLabel);
    var sourceImages = wizzyNormalizeImageList(images);
    var entries = [];
  
    if (!colorHandle || !sourceImages.length) {
      return [];
    }
  
    sourceImages.forEach(function (imageUrl) {
      var alt = wizzyGetAltFromImageUrl(imageUrl);
  
      if (!wizzyImageAltMatchesColor(alt, colorHandle)) {
        return;
      }
  
      entries.push({
        cleaned: wizzyStripAltFromImageUrl(imageUrl),
        alt: alt
      });
    });
  
    if (!entries.length) {
      return [];
    }
  
    return wizzyOrderEntriesWithClHero(entries, colorHandle).map(function (entry) {
      return entry.cleaned;
    });
  }
  
  function wizzyOrderEntriesWithClHero(entries, colorHandle) {
    if (!entries || !entries.length) {
      return [];
    }
  
    var clKey = 'cl-' + String(colorHandle || '').toLowerCase();
    var heroIndex = -1;
  
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].alt && entries[i].alt.indexOf(clKey) !== -1) {
        heroIndex = i;
        break;
      }
    }
  
    if (heroIndex <= 0) {
      return entries.slice();
    }
  
    var ordered = entries.slice();
    var hero = ordered.splice(heroIndex, 1)[0];
    ordered.unshift(hero);
    return ordered;
  }
  
  function wizzyResolveProductImagesFromAlt(product, colorLabel) {
    var allImages = wizzyNormalizeImageList(
      product.wizzyAllImages && product.wizzyAllImages.length
        ? product.wizzyAllImages
        : product.images
    );
    var selectedColor = colorLabel || wizzyGetSelectedColorLabel(product);
    var filtered = wizzyGetOrderedColorImages(allImages, selectedColor);
  
    if (filtered.length) {
      return {
        images: filtered,
        mainImage: filtered[0],
        source: 'alt'
      };
    }
  
    var swatchImage = wizzyGetVariantImageFromSwatches(product);
  
    if (swatchImage) {
      return {
        images: [swatchImage],
        mainImage: swatchImage,
        source: 'swatch'
      };
    }
  
    if (product.mainImage) {
      var cleanedMain = wizzyStripAltFromImageUrl(product.mainImage) || product.mainImage;
      return {
        images: [cleanedMain],
        mainImage: cleanedMain,
        source: 'mainImage'
      };
    }
  
    if (allImages.length) {
      var cleaned = allImages.map(wizzyStripAltFromImageUrl).filter(Boolean);
      return {
        images: cleaned.slice(0, 1),
        mainImage: cleaned[0] || '',
        source: 'first'
      };
    }
  
    return {
      images: [],
      mainImage: '',
      source: 'empty'
    };
  }
  
  function wizzyStoreProductAllImages(product) {
    if (!product) {
      return;
    }
  
    window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
    var allImages = wizzyNormalizeImageList(product.wizzyAllImages || product.images);
  
    if (!allImages.length) {
      return;
    }
  
    if (product.id != null) {
      window.wizzyProductAllImagesById[String(product.id)] = allImages.slice();
    }
  
    if (product.groupId != null) {
      window.wizzyProductAllImagesById[String(product.groupId)] = allImages.slice();
    }
  
    if (product.singleVarientGroupId != null) {
      window.wizzyProductAllImagesById[String(product.singleVarientGroupId)] = allImages.slice();
    }
  }
  
  function wizzyGetStoredProductAllImages(gridProduct) {
    if (!gridProduct) {
      return [];
    }
  
    window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
  
    var keys = [
      gridProduct.getAttribute('data-variant-id'),
      gridProduct.getAttribute('data-id'),
      gridProduct.getAttribute('data-product-id'),
      gridProduct.getAttribute('data-groupId'),
      gridProduct.getAttribute('data-groupid')
    ];
  
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] && window.wizzyProductAllImagesById[String(keys[i])]) {
        return window.wizzyProductAllImagesById[String(keys[i])].slice();
      }
    }
  
    return [];
  }
  
  window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
  
  function wizzyStoreProductGallery(keysOrProduct, galleryUrls) {
    if (!galleryUrls || !galleryUrls.length) {
      return;
    }
  
    window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
    var urls = galleryUrls.slice();
    var keys = [];
  
    if (keysOrProduct && typeof keysOrProduct === 'object' && !Array.isArray(keysOrProduct)) {
      if (keysOrProduct.id != null) keys.push(String(keysOrProduct.id));
      if (keysOrProduct.groupId != null) keys.push(String(keysOrProduct.groupId));
      if (keysOrProduct.singleVarientGroupId != null) {
        keys.push(String(keysOrProduct.singleVarientGroupId));
      }
    } else if (Array.isArray(keysOrProduct)) {
      keys = keysOrProduct.filter(Boolean).map(String);
    } else if (keysOrProduct != null) {
      keys = [String(keysOrProduct)];
    }
  
    keys.forEach(function (key) {
      window.wizzyProductGalleryById[key] = urls;
    });
  }
  
  function wizzyGetStoredProductGallery(gridProduct) {
    if (!gridProduct) {
      return [];
    }
  
    window.wizzyProductGalleryById = window.wizzyProductGalleryById || {};
  
    var keys = [
      gridProduct.getAttribute('data-variant-id'),
      gridProduct.getAttribute('data-id'),
      gridProduct.getAttribute('data-product-id'),
      gridProduct.getAttribute('data-groupId'),
      gridProduct.getAttribute('data-groupid')
    ];
  
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] && window.wizzyProductGalleryById[String(keys[i])]) {
        return window.wizzyProductGalleryById[String(keys[i])].slice();
      }
    }
  
    return [];
  }
  
  function wizzyBuildCardImageSlide(url, isHero) {
    var imageElement = document.createElement('image-element');
    imageElement.setAttribute('data-aos', 'image-fade-in');
    imageElement.setAttribute('data-aos-offset', '150');
    imageElement.className = 'aos-init aos-animate wizzy-product-card-slide';
  
    var img = document.createElement('img');
    img.src = url;
    img.loading = isHero ? 'eager' : 'lazy';
    img.className = 'product grid__image-contain prodGrid01 image-element';
    img.setAttribute('sizes', '(max-width: 800px) 200px, 100vw');
    imageElement.appendChild(img);
    return imageElement;
  }
  
  function wizzyUpdateProductCardImagesFromUrls(productContent, urls, options) {
    if (!productContent || !urls || !urls.length) {
      return;
    }
  
    var opts = options || {};
    var heroOnly = !!opts.heroOnly;
    var renderUrls = heroOnly ? [urls[0]] : urls.slice();
  
    var sliderWrap =
      productContent.querySelector('.grid-product__image-mask .custom-image-element-wrap') ||
      productContent.querySelector('.custom-image-element-wrap');
  
    if (!sliderWrap) {
      return;
    }
  
    wizzyUnslickImageWrap(sliderWrap);
    sliderWrap.innerHTML = '';
    sliderWrap.setAttribute('data-wizzy-gallery-expanded', heroOnly ? 'false' : 'true');
  
    renderUrls.forEach(function (url, index) {
      sliderWrap.appendChild(wizzyBuildCardImageSlide(url, index === 0));
    });
  
    wizzyTagCardViewSlides(sliderWrap);
  
    if (!heroOnly && renderUrls.length > 1) {
      wizzyReinitProductImageSlider(sliderWrap);
    }
  }
  
  function wizzyExpandProductCardGallery(gridProduct, startIndex) {
    if (!gridProduct) {
      return false;
    }
  
    var productContent = gridProduct.querySelector('.grid-product__content');
    var sliderWrap =
      (productContent &&
        productContent.querySelector('.grid-product__image-mask .custom-image-element-wrap')) ||
      (productContent && productContent.querySelector('.custom-image-element-wrap'));
  
    if (!sliderWrap || sliderWrap.getAttribute('data-wizzy-gallery-expanded') === 'true') {
      return false;
    }
  
    var gallery = wizzyGetStoredProductGallery(gridProduct);
  
    if (gallery.length < 2) {
      return false;
    }
  
    wizzyUpdateProductCardImagesFromUrls(productContent, gallery, { heroOnly: false });
  
    if (window.jQuery && jQuery(sliderWrap).hasClass('slick-initialized') && startIndex > 0) {
      try {
        jQuery(sliderWrap).slick('slickGoTo', startIndex, true);
      } catch (error) {}
    }
  
    return true;
  }
  
  function wizzyBindProductCardGalleryOnDemand(gridProduct) {
    if (!gridProduct || gridProduct.dataset.wizzyGalleryBound === 'true') {
      return;
    }
  
    var gallery = wizzyGetStoredProductGallery(gridProduct);
  
    if (gallery.length < 2) {
      return;
    }
  
    gridProduct.dataset.wizzyGalleryBound = 'true';
    gridProduct.setAttribute('data-wizzy-has-gallery', 'true');
  
    var imageArea =
      gridProduct.querySelector('.grid-product__image-mask') ||
      gridProduct.querySelector('.custom-image-element-wrap');
  
    if (!imageArea) {
      return;
    }
  
    var pointerStartX = 0;
    var pointerStartY = 0;
    var swiping = false;
    var pointerActive = false;
    var suppressClick = false;
  
    function onPointerStart(clientX, clientY) {
      pointerStartX = clientX;
      pointerStartY = clientY;
      swiping = false;
      pointerActive = true;
    }
  
    function onPointerMove(clientX, clientY, event) {
      if (!pointerActive) {
        return;
      }
  
      var dx = clientX - pointerStartX;
      var dy = clientY - pointerStartY;
  
      if (Math.abs(dx) < 24 || Math.abs(dx) < Math.abs(dy)) {
        return;
      }
  
      swiping = true;
      suppressClick = true;
  
      if (wizzyExpandProductCardGallery(gridProduct, dx < 0 ? 1 : 0)) {
        if (event && event.preventDefault) {
          event.preventDefault();
        }
      }
    }
  
    imageArea.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches.length) {
          return;
        }
  
        onPointerStart(event.touches[0].clientX, event.touches[0].clientY);
      },
      { passive: true }
    );
  
    imageArea.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches || !event.touches.length) {
          return;
        }
  
        onPointerMove(event.touches[0].clientX, event.touches[0].clientY, event);
      },
      { passive: false }
    );
  
    imageArea.addEventListener('mousedown', function (event) {
      if (event.button !== 0) {
        return;
      }
  
      onPointerStart(event.clientX, event.clientY);
    });
  
    imageArea.addEventListener('mousemove', function (event) {
      if (!pointerActive) {
        return;
      }
  
      onPointerMove(event.clientX, event.clientY, event);
    });
  
    function endPointer() {
      pointerActive = false;
      swiping = false;
    }
  
    imageArea.addEventListener('mouseup', endPointer);
    imageArea.addEventListener('mouseleave', endPointer);
  
    imageArea.addEventListener('click', function (event) {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }
    });
  }
  
  function wizzyInitProductCardGalleriesOnDemand(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll(
      '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
    );
  
    Array.prototype.forEach.call(cards, function (card) {
      wizzyBindProductCardGalleryOnDemand(card);
    });
  }
  
  function wizzyPrefetchVariantImage(product) {
    return Promise.resolve();
  }
  
  function wizzyPrefetchVariantImages(products) {
    return Promise.resolve();
  }
  
  function wizzyApplyCachedVariantImages(product) {
    if (!product || product.id == null) {
      return;
    }
  
    var urls = wizzyGetCachedVariantImageUrls(String(product.id));
  
    if (!urls || !urls.length) {
      return;
    }
  
    product.mainImage = urls[0];
    product.images = urls.slice();
    product.imagesReady = true;
    product.wizzyImagesPrefetched = true;
  }
  
  function wizzyGetVariantImageFromSwatches(product) {
    if (!product.swatches) {
      return '';
    }
  
    var groups = Array.isArray(product.swatches)
      ? product.swatches
      : Object.keys(product.swatches).map(function (key) {
          return product.swatches[key];
        });
  
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
  
      if (group.key !== 'colors' || !group.values || !group.values.length) {
        continue;
      }
  
      for (var j = 0; j < group.values.length; j++) {
        var value = group.values[j];
  
        if (value.isSelected && value.image) {
          return value.image;
        }
      }
    }
  
    return '';
  }
  
  function wizzyNormalizeVariantImages(product) {
    if (!product) {
      return;
    }
  
    if (!product.wizzyAllImages || !product.wizzyAllImages.length) {
      product.wizzyAllImages = wizzyNormalizeImageList(product.images);
    }
  
    wizzyStoreProductAllImages(product);
  
    var resolved = wizzyResolveProductImagesFromAlt(
      product,
      wizzyGetSelectedColorLabel(product)
    );
  
    if (resolved.images && resolved.images.length) {
      product.wizzyGalleryImages = resolved.images.slice();
      product.mainImage = resolved.mainImage || resolved.images[0];
      // First paint: hero only — remaining images load on swipe
      product.images = [product.mainImage];
      product.hasGalleryMore = resolved.images.length > 1;
      wizzyStoreProductGallery(product, resolved.images);
    } else if (product.mainImage) {
      product.images = [product.mainImage];
      product.wizzyGalleryImages = [product.mainImage];
      product.hasGalleryMore = false;
      wizzyStoreProductGallery(product, product.images);
    } else {
      product.wizzyGalleryImages = [];
      product.hasGalleryMore = false;
    }
  
    product.imagesReady = true;
  }
  
  function wizzyEnrichProduct(product) {
    wizzyPrepareSwatchesForTemplate(product);
  
    if (!product.cardSizes || !product.cardSizes.length) {
      var sizeValues = product.sizes || [];
  
      if (!sizeValues.length) {
        var sizeSwatches =
          (product.swatches && product.swatches.sizes) ||
          (product.swatch && product.swatch.sizes);
  
        if (sizeSwatches && sizeSwatches.values && sizeSwatches.values.length) {
          sizeValues = sizeSwatches.values;
        } else if (Array.isArray(sizeSwatches) && sizeSwatches.length) {
          sizeValues = sizeSwatches;
        }
      }
  
      if (sizeValues.length) {
        product.cardSizes = sizeValues.map(function (size) {
          return {
            label: size.value,
            variantId: size.variationId,
            inStock: size.inStock
          };
        });
      } else {
        product.hasNoSize = true;
      }
    }
  
    if (product.cardSizes && product.cardSizes.length) {
      product.cardSizes = product.cardSizes.map(function (size) {
        return {
          label: size.label || size.value,
          variantId: size.variantId || size.variationId,
          inStock: size.inStock !== false
        };
      });
    }
  
    product.isNoSize = wizzyProductHasNoSizeTag(product);
    product.hasCardSizes = !product.isNoSize;
  
    if (!product.isNoSize && (!product.cardSizes || !product.cardSizes.length)) {
      product.needsCardSizeFetch = true;
    }
  
    if (!product.faqText && product.subTitle) {
      product.faqText = product.subTitle;
    }
  
    if (!product.faqText) {
      product.faqText =
        wizzyGetAttributeValue(product, 'custom_faq_text') ||
        wizzyGetAttributeValue(product, 'product_custom_faq_text') ||
        wizzyGetAttributeValue(product, 'faq_text') ||
        wizzyGetAttributeValue(product, 'product_faq_text') ||
        '';
    }
  
    if (product.faqText) {
      product.hasFaqText = true;
    }
  
    if (product.avgRatings != null && product.reviewRating == null) {
      product.reviewRating = product.avgRatings;
    }
  
    if (product.totalReviews != null && product.reviewCount == null) {
      product.reviewCount = product.totalReviews;
    }
  
    if (product.reviewRating == null) {
      product.reviewRating =
        wizzyGetAttributeValue(product, 'avgRatings') ||
        wizzyGetAttributeValue(product, 'average_rating') ||
        wizzyGetAttributeValue(product, 'product_avg_rating') ||
        wizzyGetAttributeValue(product, 'reviews_average') ||
        product.averageRating ||
        product.rating ||
        null;
    }
  
    if (product.reviewCount == null) {
      product.reviewCount =
        wizzyGetAttributeValue(product, 'totalReviews') ||
        wizzyGetAttributeValue(product, 'reviews_count') ||
        wizzyGetAttributeValue(product, 'product_reviews_count') ||
        wizzyGetAttributeValue(product, 'number_of_reviews') ||
        product.reviewsCount ||
        product.review_count ||
        null;
    }
  
    var ratingValue = parseFloat(
      product.reviewRating != null ? product.reviewRating : product.avgRatings
    );
    var reviewCountValue = parseInt(
      product.reviewCount != null ? product.reviewCount : product.totalReviews,
      10
    );
  
    if (!isNaN(ratingValue) && !isNaN(reviewCountValue) && reviewCountValue > 0 && ratingValue > 0) {
      product.hasReviews = true;
      product.reviewRating = ratingValue;
      product.reviewCount = reviewCountValue;
      product.reviewRatingDisplay = ratingValue.toFixed(1);
    } else {
      product.hasReviews = false;
    }
  
    wizzyNormalizeVariantImages(product);
  
    return product;
  }
  
  function wizzyTransformProducts(data) {
    if (!data) {
      return data;
    }
  
    if (Array.isArray(data)) {
      data.forEach(wizzyEnrichProduct);
      return data;
    }
  
    if (data.id && (data.swatches || data.name)) {
      wizzyEnrichProduct(data);
      return data;
    }
  
    if (data.products && data.products.length) {
      data.products.forEach(wizzyEnrichProduct);
    }
  
    if (data.search && data.search.products && data.search.products.length) {
      data.search.products.forEach(wizzyEnrichProduct);
    }
  
    if (data.response && data.response.products && data.response.products.length) {
      data.response.products.forEach(wizzyEnrichProduct);
    }
  
    if (data.results && data.results.products && data.results.products.length) {
      data.results.products.forEach(wizzyEnrichProduct);
    }
  
    return data;
  }
  
  function wizzyUpdateProductLinks(productContent, targetId, productUrl) {
    if (!productContent) {
      return;
    }
  
    productContent.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      const href = link.getAttribute('href') || '';
  
      if (href.indexOf('?variant=') !== -1) {
        link.setAttribute('href', href.replace(/(variant=)[^&]+/, '$1' + targetId));
      } else if (productUrl) {
        link.setAttribute('href', productUrl);
      }
    });
  }
  
  var WIZZY_PRODUCT_SLIDER_SELECTOR =
    '.wizzy-search-results-list .grid-product, .wizzy-search-results .grid-product, .wizzy-search-wrapper .grid-product';
  
  function wizzyCountImageSlides(sliderWrap) {
    if (!sliderWrap) {
      return 0;
    }
  
    var directSlides = sliderWrap.querySelectorAll('.wizzy-product-card-slide');
  
    if (directSlides.length) {
      return directSlides.length;
    }
  
    var imageElements = [];
    for (var i = 0; i < sliderWrap.children.length; i++) {
      var child = sliderWrap.children[i];
      if (
        child.tagName &&
        (child.tagName.toLowerCase() === 'image-element' || child.tagName.toLowerCase() === 'img')
      ) {
        imageElements.push(child);
      }
    }
  
    return imageElements.length;
  }
  
  function wizzyUnslickImageWrap(sliderWrap) {
    if (!sliderWrap || !window.jQuery) {
      return;
    }
  
    var $wrap = jQuery(sliderWrap);
  
    if ($wrap.hasClass('slick-initialized')) {
      $wrap.slick('unslick');
    }
  }
  
  function wizzyInitProductImageSliderWrap(sliderWrap) {
    if (!sliderWrap || !window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
      return;
    }
  
    var $wrap = jQuery(sliderWrap);
  
    if (!$wrap.hasClass('custom-image-element-wrap')) {
      $wrap = $wrap.find('.custom-image-element-wrap').first();
    }
  
    if (!$wrap.length) {
      return;
    }
  
    $wrap.addClass('wizzy-product-card-slider');
    wizzyUnslickImageWrap($wrap[0]);
  
    var slideCount = wizzyCountImageSlides($wrap[0]);
  
    if (slideCount > 1) {
      $wrap.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        draggable: true,
        swipe: true,
        touchMove: true,
        adaptiveHeight: false
      });
    }
  }
  
  function wizzyInitProductImageSlidersIn(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope === document ? scope.querySelectorAll(WIZZY_PRODUCT_SLIDER_SELECTOR) : [scope];
  
    Array.prototype.forEach.call(cards, function (card) {
      card.querySelectorAll('.custom-image-element-wrap').forEach(function (sliderWrap) {
        wizzyInitProductImageSliderWrap(sliderWrap);
      });
    });
  }
  
  function wizzyReinitProductImageSlider(imageWrapper) {
    if (!imageWrapper) {
      return;
    }
  
    if (imageWrapper.classList && imageWrapper.classList.contains('custom-image-element-wrap')) {
      wizzyInitProductImageSliderWrap(imageWrapper);
      return;
    }
  
    imageWrapper.querySelectorAll('.custom-image-element-wrap').forEach(function (sliderWrap) {
      wizzyInitProductImageSliderWrap(sliderWrap);
    });
  }
  
  function wizzyApplyColorSwatchFetchResponse(target, html, productContent, gridProduct) {
    if (!target || !html || !productContent) {
      return;
    }
  
    const targetId = target.dataset.variantId;
    const targetValue = (target.getAttribute('data-value') || '').toLowerCase();
    const soldOutTagName = target.dataset.soldoutName || 'Sold Out';
    const savedAmount = target.dataset.savedAmount;
    const tagMetafieldValue = target.dataset.variantMetafieldTagValue;
    const soldOutLabelHTML = '<div class="grid-product__tag grid-product__tag--sold-out">' + soldOutTagName + '</div>';
  
    const activeColorSwatchContainer = target.closest('.collection-product-color-grid');
  
    if (activeColorSwatchContainer && targetId) {
      const activeColorSwatch = activeColorSwatchContainer.querySelector("a[data-variant-id='" + targetId + "']");
  
      if (activeColorSwatch) {
        activeColorSwatch.classList.add('product-color-swatch--active');
      }
    }
  
    const oldProductGridImageContainer = productContent.querySelector('.grid-product__image-mask .grid__image-ratio')
      || productContent.querySelector('.grid__image-ratio');
    const oldSizeVariants = productContent.querySelector('.variant-wrapper');
    const newSizeVariants = html.querySelector('.variant-wrapper');
    const hasAvailableSize = wizzyApplySizeAvailabilityToWrapper(
      newSizeVariants,
      html,
      targetValue
    );
    let isVariantSoldOut = hasAvailableSize;
  
    productContent.querySelectorAll('.cs-tag-container').forEach(function (tagContainer) {
      tagContainer.style.display = tagMetafieldValue ? 'block' : 'none';
    });
  
    if (newSizeVariants && oldSizeVariants) {
      oldSizeVariants.innerHTML = newSizeVariants.innerHTML;
    }
  
    const addToCartBtn = productContent.querySelector('.addtocartbtn');
    const btnText = productContent.querySelector('.btn-custom.select-switchs');
    const colorSwitch = gridProduct ? gridProduct.querySelector('.color-switch') : null;
    const isPanelOpen = colorSwitch && colorSwitch.classList.contains('switch-height');
  
    if (!isVariantSoldOut) {
      let soldOutLabel = productContent.querySelector('.grid-product__tag--sold-out');
  
      if (!soldOutLabel) {
        productContent.insertAdjacentHTML('afterbegin', soldOutLabelHTML);
      }
  
      const savedAmountLabel = productContent.querySelector('#perc-c');
      if (savedAmountLabel) {
        savedAmountLabel.classList.add('d-none');
      }
  
      if (addToCartBtn) {
        addToCartBtn.classList.add('notifymebtn');
      }
  
      if (btnText) {
        btnText.classList.add('notifyme--btn');
        btnText.textContent = 'Notify Me';
      }
  
      if (oldProductGridImageContainer) {
        oldProductGridImageContainer.style.opacity = '0.5';
      }
    } else {
      const soldOutLabel = productContent.querySelector('.grid-product__tag--sold-out');
  
      if (soldOutLabel) {
        soldOutLabel.remove();
      }
  
      if (addToCartBtn) {
        addToCartBtn.classList.remove('notifymebtn');
      }
  
      if (btnText) {
        btnText.classList.remove('notifyme--btn');
        btnText.innerHTML = 'Quick Add <span class="quick-add-icon"><span class="icon-plus" style="' + (isPanelOpen ? 'display: none;' : '') + '"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="24" height="24" fill="none"></rect><path d="M12 6V18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 12H18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path></g></svg></span><span class="icon-minus" style="' + (isPanelOpen ? 'display: block;' : 'display: none;') + '"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><rect width="24" height="24" fill="none"></rect><path d="M6 12H18" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path></g></svg></span></span>';
      }
  
      const savedAmountLabel = productContent.querySelector('#perc-c');
  
      if (savedAmount && savedAmountLabel) {
        savedAmountLabel.classList.remove('d-none');
      }
  
      if (oldProductGridImageContainer) {
        oldProductGridImageContainer.style.opacity = '1';
      }
    }
  
    wizzyUpdateProductCardImages(productContent, html);
    productContent.dataset.wizzyImagesSynced = 'true';
  
    if (gridProduct) {
      var variantId = wizzyGetVariantIdFromGridProduct(gridProduct);
      var imageUrls = wizzyExtractImageUrlsFromCardHtml(html);
  
      if (variantId && imageUrls.length) {
        wizzySetVariantImageCache(variantId, imageUrls);
      }
  
      wizzyMarkVariantImageReady(gridProduct);
    }
  }
  
  function wizzyResponseHasVisibleImages(responseProductImages) {
    return Array.prototype.some.call(responseProductImages, function (anchor) {
      var wrap = anchor.querySelector('.custom-image-element-wrap');
  
      if (!wrap) {
        return false;
      }
  
      return wizzyCountImageSlides(wrap) > 0;
    });
  }
  
  function wizzyTagCardViewSlides(root) {
    if (!root) {
      return;
    }
  
    root.querySelectorAll('.custom-image-element-wrap image-element, .custom-image-element-wrap .image-element').forEach(
      function (slide) {
        slide.classList.add('wizzy-product-card-slide');
      }
    );
  }
  
  function wizzyExtractImageUrlsFromCardHtml(html) {
    if (!html) {
      return [];
    }
  
    var imgs = html.querySelectorAll('.product-images.grid-product__link img');
    var urls = [];
  
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || img.getAttribute('data-src');
  
      if (src) {
        urls.push(src);
      }
    });
  
    return urls;
  }
  
  function wizzyUpdateProductCardImages(productContent, html) {
    if (!productContent || !html) {
      return;
    }
  
    const imageWrapper =
      productContent.querySelector('.grid-product__image-mask .custom_slider-mobile-image-element') ||
      productContent.querySelector('.grid-product__image-mask .grid-product__link-wrapper .grid-product__link');
    const imageLink = productContent.querySelector('a.product-images.grid-product__link');
    const responseProductImages = html.querySelectorAll('.product-images.grid-product__link');
  
    if (!responseProductImages.length || !wizzyResponseHasVisibleImages(responseProductImages)) {
      return;
    }
  
    if (imageWrapper) {
      imageWrapper.querySelectorAll('.custom-image-element-wrap').forEach(wizzyUnslickImageWrap);
  
      imageWrapper.innerHTML = '';
  
      responseProductImages.forEach(function (img) {
        imageWrapper.appendChild(img.cloneNode(true));
      });
  
      wizzyTagCardViewSlides(imageWrapper);
      wizzyReinitProductImageSlider(imageWrapper);
      return;
    }
  
    if (imageLink) {
      imageLink.querySelectorAll('.custom-image-element-wrap').forEach(wizzyUnslickImageWrap);
      imageLink.outerHTML = responseProductImages[0].outerHTML;
  
      const updatedImageLink = productContent.querySelector('a.product-images.grid-product__link');
  
      if (updatedImageLink) {
        wizzyTagCardViewSlides(updatedImageLink);
        wizzyReinitProductImageSlider(updatedImageLink.parentElement || updatedImageLink);
      }
    }
  }
  
  function wizzyGetVariantCardFetchUrl(gridProduct, activeSwatch) {
    if (activeSwatch) {
      const productUrl = activeSwatch.getAttribute('data-url');
  
      if (productUrl) {
        return productUrl.indexOf('?') !== -1 ? productUrl + '&view=card' : productUrl + '?view=card';
      }
    }
  
    const variantId = gridProduct.getAttribute('data-variant-id');
    const handle = gridProduct.getAttribute('data-product-handle');
  
    if (variantId && handle) {
      return '/products/' + handle + '?variant=' + variantId + '&view=card';
    }
  
    return wizzyGetCardFetchUrl(gridProduct);
  }
  
  function wizzyMarkVariantImageReady(gridProduct) {
    if (gridProduct) {
      gridProduct.setAttribute('data-images-ready', 'true');
    }
  }
  
  function wizzySyncInitialVariantImages(gridProduct) {
    const content = gridProduct.querySelector('.grid-product__content');
  
    if (content) {
      content.dataset.wizzyImagesSynced = 'true';
      wizzyReinitProductImageSlider(content);
    }
  
    gridProduct.setAttribute('data-wizzy-images-prefetched', 'true');
    wizzyMarkVariantImageReady(gridProduct);
    return Promise.resolve();
  }
  
  function wizzyInitInitialVariantImages() {
    const cards = document.querySelectorAll(
      '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
    );
  
    return Promise.all(Array.from(cards).map(wizzySyncInitialVariantImages)).then(function () {
      wizzyRefreshProductCardSliders();
    });
  }
  
  function wizzyGetCardFetchUrl(gridProduct) {
    return '';
    const link = gridProduct.querySelector('a.grid-product__link[href]');
  
    if (!link) {
      return '';
    }
  
    const href = link.getAttribute('href') || '';
  
    if (!href) {
      return '';
    }
  
    return href.indexOf('?') !== -1 ? href + '&view=card' : href + '?view=card';
  }
  
  function wizzyGetVariantIdFromGridProduct(gridProduct) {
    if (!gridProduct) {
      return '';
    }
  
    const dataVariantId = gridProduct.getAttribute('data-variant-id');
  
    if (dataVariantId) {
      return String(dataVariantId);
    }
  
    const link =
      gridProduct.querySelector('a.grid-product__link[href*="variant="]') ||
      gridProduct.querySelector('a[href*="/products/"][href*="variant="]');
  
    if (!link) {
      return '';
    }
  
    const match = (link.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    return match ? match[1] : '';
  }
  
  function wizzyResolveCardColorSlug(gridProduct, htmlDoc) {
    if (gridProduct) {
      const activeSwatch = gridProduct.querySelector(
        'a.product-color-swatch--active[data-value], a.color-swatch--with-image.product-color-swatch--active[data-value]'
      );
  
      if (activeSwatch) {
        const swatchValue = (activeSwatch.getAttribute('data-value') || '').toLowerCase().trim();
  
        if (swatchValue) {
          return swatchValue;
        }
      }
    }
  
    const variantId = wizzyGetVariantIdFromGridProduct(gridProduct);
  
    if (variantId && htmlDoc) {
      const matchedOption = htmlDoc.querySelector(
        '#variant-select option[value="' + variantId + '"]'
      );
  
      if (matchedOption) {
        const colorFromVariant = (matchedOption.getAttribute('data-color-option') || '')
          .toLowerCase()
          .trim();
  
        if (colorFromVariant) {
          return colorFromVariant;
        }
      }
    }
  
    if (htmlDoc) {
      const firstColorOption = htmlDoc.querySelector('#variant-select option[data-color-option]');
  
      if (firstColorOption) {
        return (firstColorOption.getAttribute('data-color-option') || '').toLowerCase().trim();
      }
    }
  
    return '';
  }
  
  function wizzyApplySizeAvailabilityToWrapper(variantWrapper, htmlDoc, colorSlug) {
    if (!variantWrapper || !htmlDoc || !colorSlug) {
      return false;
    }
  
    const colorOptions = htmlDoc.querySelectorAll(
      '#variant-select option[data-color-option="' + colorSlug + '"]'
    );
  
    if (!colorOptions.length) {
      return false;
    }
  
    let hasAvailableSize = false;
  
    for (let i = 0; i < colorOptions.length; i++) {
      const option = colorOptions[i];
      const sizeOption = option.getAttribute('data-size-option');
      const sizeAvailable = option.getAttribute('data-size-available');
      const variantId = option.getAttribute('value') || option.getAttribute('data-variant-id');
  
      if (!sizeOption) {
        continue;
      }
  
      const input =
        variantWrapper.querySelector('input[value="' + sizeOption + '"]') ||
        variantWrapper.querySelector('input[data-input-value="' + sizeOption + '"]');
      const label = variantWrapper.querySelector('label[data-label-value="' + sizeOption + '"]');
  
      if (sizeAvailable === 'true') {
        if (input) {
          input.classList.remove('disabled');
        }
  
        if (label) {
          label.classList.remove('disabled');
        }
  
        hasAvailableSize = true;
      } else if (sizeAvailable === 'false') {
        if (input) {
          input.classList.add('disabled');
        }
  
        if (label) {
          label.classList.add('disabled');
        }
      }
  
      if (variantId) {
        if (input) {
          input.setAttribute('data-id', variantId);
        }
  
        if (label) {
          label.setAttribute('data-id', variantId);
          label.setAttribute('data-variant-id', variantId);
        }
      }
    }
  
    return hasAvailableSize;
  }
  
  function wizzyLoadSizedProductCard(gridProduct) {
    const content = gridProduct.querySelector('.grid-product__content');
  
    if (!content || content.dataset.wizzySizesLoaded === 'true') {
      return Promise.resolve();
    }
  
    const activeSwatch = gridProduct.querySelector(
      'a.product-color-swatch--active, a.color-swatch--with-image.product-color-swatch--active'
    );
    const fetchUrl =
      wizzyGetVariantCardFetchUrl(gridProduct, activeSwatch) || wizzyGetCardFetchUrl(gridProduct);
  
    if (!fetchUrl) {
      return Promise.resolve();
    }
  
    return fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (htmlText) {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const newVariantWrapper = html.querySelector('.variant-wrapper');
        const oldVariantWrapper = content.querySelector('.variant-wrapper');
  
        if (newVariantWrapper && oldVariantWrapper) {
          const colorSlug = wizzyResolveCardColorSlug(gridProduct, html);
          wizzyApplySizeAvailabilityToWrapper(newVariantWrapper, html, colorSlug);
          oldVariantWrapper.innerHTML = newVariantWrapper.innerHTML;
        }
  
        content.dataset.wizzySizesLoaded = 'true';
      })
      .catch(function () {});
  }
  
  function wizzyInitSizedProductCards() {
    const cards = document.querySelectorAll(
      '.wizzy-search-results-list .grid-product .select-switchs, .wizzy-search-wrapper .grid-product .select-switchs'
    );
  
    cards.forEach(function (button) {
      const gridProduct = button.closest('.grid-product');
  
      if (!gridProduct) {
        return;
      }
  
      wizzyLoadSizedProductCard(gridProduct);
    });
  }
  
  function wizzyFillReviewFromBadge(container) {
    if (!container) {
      return false;
    }
  
    var ratingEl = container.querySelector('.nector-review-rating');
    var countEl = container.querySelector('.nector-review-count');
  
    if (ratingEl && ratingEl.textContent.trim() && countEl && countEl.textContent.trim()) {
      container.style.display = 'block';
      container.dataset.jdgmInit = 'true';
      return true;
    }
  
    var productCard = container.closest(
      '[data-product-id], .grid-product, .product-grid-item, .grid__item, .card-wrapper'
    );
  
    if (!productCard) {
      return false;
    }
  
    var badge = productCard.querySelector('.jdgm-prev-badge');
  
    if (!badge) {
      return false;
    }
  
    var rating = parseFloat(
      badge.getAttribute('data-average-rating') || badge.dataset.averageRating || 0
    );
    var count = parseInt(
      badge.getAttribute('data-number-of-reviews') || badge.dataset.numberOfReviews || 0,
      10
    );
  
    if (!(count > 0) || isNaN(rating) || rating <= 0) {
      container.style.display = 'none';
      container.dataset.jdgmInit = 'true';
      return false;
    }
  
    if (ratingEl) {
      ratingEl.textContent = rating.toFixed(1);
    }
  
    if (countEl) {
      countEl.textContent = String(count);
    }
  
    container.style.display = 'block';
    container.dataset.jdgmInit = 'true';
    return true;
  }
  
  function wizzyInjectJudgeMeBadge(titleEl, htmlDoc) {
    if (!titleEl || !htmlDoc || titleEl.querySelector('.jdgm-prev-badge')) {
      return !!titleEl.querySelector('.jdgm-prev-badge');
    }
  
    var cardBadgeWrap = htmlDoc.querySelector('.jdgm-badge-source');
    var cardBadge = htmlDoc.querySelector('.jdgm-prev-badge');
  
    if (!cardBadgeWrap && !cardBadge) {
      return false;
    }
  
    var badgeTarget = titleEl.querySelector('.jdgm-badge-source');
  
    if (cardBadgeWrap) {
      if (badgeTarget) {
        badgeTarget.innerHTML = cardBadgeWrap.innerHTML;
      } else {
        titleEl.insertAdjacentHTML('beforeend', cardBadgeWrap.outerHTML);
      }
    } else if (cardBadge) {
      if (badgeTarget) {
        badgeTarget.innerHTML = cardBadge.outerHTML;
      } else {
        titleEl.insertAdjacentHTML(
          'beforeend',
          '<div class="jdgm-badge-source" style="display:none;">' + cardBadge.outerHTML + '</div>'
        );
      }
    }
  
    return !!titleEl.querySelector('.jdgm-prev-badge');
  }
  
  function wizzyEnrichProductCardMeta(gridProduct) {
    const content = gridProduct.querySelector('.grid-product__content');
    const meta = content ? content.querySelector('.grid-product__meta') : null;
  
    if (!content || !meta || content.dataset.wizzyMetaLoaded === 'true') {
      return Promise.resolve();
    }
  
    window.wizzyMetaPromises = window.wizzyMetaPromises || new WeakMap();
  
    if (content.dataset.wizzyMetaLoading === 'true') {
      return window.wizzyMetaPromises.get(content) || Promise.resolve();
    }
  
    const faqEl = meta.querySelector('.wizzy-faq-text');
    const reviewsEl = meta.querySelector('.judgeme-custom-reviews');
    const ratingEl = reviewsEl ? reviewsEl.querySelector('.nector-review-rating') : null;
    const needsFaq = !faqEl || !faqEl.textContent.trim();
    const needsReviews = !ratingEl || !ratingEl.textContent.trim();
  
    if (!needsFaq && !needsReviews) {
      if (reviewsEl) {
        wizzyFillReviewFromBadge(reviewsEl);
      }
      content.dataset.wizzyMetaLoaded = 'true';
      return Promise.resolve();
    }
  
    if (needsReviews && reviewsEl && wizzyFillReviewFromBadge(reviewsEl)) {
      if (!needsFaq) {
        content.dataset.wizzyMetaLoaded = 'true';
        return Promise.resolve();
      }
    }
  
    const fetchUrl = wizzyGetCardFetchUrl(gridProduct);
  
    if (!fetchUrl) {
      if (reviewsEl) {
        wizzyFillReviewFromBadge(reviewsEl);
      }
      content.dataset.wizzyMetaLoaded = 'true';
      return Promise.resolve();
    }
  
    content.dataset.wizzyMetaLoading = 'true';
  
    const request = fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (htmlText) {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const titleEl = meta.querySelector('.grid-product__title');
        const liveReviewsEl = meta.querySelector('.judgeme-custom-reviews');
  
        if (needsFaq && faqEl) {
          const cardFaq = html.querySelector('.faq-text');
  
          if (cardFaq && cardFaq.textContent.trim()) {
            faqEl.textContent = cardFaq.textContent.trim();
          }
        }
  
        // Only inject Judge.me badge data. Never replace the Wizzy review
        // container with the empty product-card widget (that shows icons without numbers).
        if (needsReviews && titleEl) {
          wizzyInjectJudgeMeBadge(titleEl, html);
  
          if (liveReviewsEl) {
            wizzyFillReviewFromBadge(liveReviewsEl);
          }
        }
  
        content.dataset.wizzyMetaLoaded = 'true';
        delete content.dataset.wizzyMetaLoading;
        window.wizzyMetaPromises.delete(content);
      })
      .catch(function () {
        if (reviewsEl) {
          wizzyFillReviewFromBadge(reviewsEl);
        }
        content.dataset.wizzyMetaLoaded = 'true';
        delete content.dataset.wizzyMetaLoading;
        window.wizzyMetaPromises.delete(content);
      });
  
    window.wizzyMetaPromises.set(content, request);
    return request;
  }
  
  function wizzyInitProductCardMeta() {
    const cards = document.querySelectorAll(
      '.wizzy-search-results-list .grid-product, .wizzy-search-wrapper .grid-product'
    );
    const requests = Array.from(cards).map(wizzyEnrichProductCardMeta);
  
    return Promise.all(requests).then(function () {
      const scope =
        document.querySelector('.wizzy-search-results-list') ||
        document.querySelector('.wizzy-search-wrapper');
  
      if (!scope) {
        return;
      }
  
      scope.querySelectorAll('.judgeme-custom-reviews').forEach(function (container) {
        wizzyFillReviewFromBadge(container);
      });
  
      if (typeof initJudgeMeRatings === 'function') {
        initJudgeMeRatings(scope);
      }
    });
  }
  
  function wizzyRevealProductRatings(scope) {
    var root =
      scope ||
      document.querySelector('.wizzy-search-results-list') ||
      document.querySelector('.wizzy-search-wrapper') ||
      document;
  
    root.querySelectorAll('.judgeme-custom-reviews').forEach(function (container) {
      wizzyFillReviewFromBadge(container);
    });
  
    if (typeof initJudgeMeRatings === 'function') {
      initJudgeMeRatings(root);
    }
  }
  
  function wizzyUpgradeDirectAddCards() {
    const cards = document.querySelectorAll(
      '.wizzy-search-results-list .grid-product .withoutSIzeVariants, .wizzy-search-wrapper .grid-product .withoutSIzeVariants'
    );
    const requests = [];
  
    cards.forEach(function (button) {
      const gridProduct = button.closest('.grid-product');
      const content = gridProduct ? gridProduct.querySelector('.grid-product__content') : null;
  
      if (!gridProduct || !content || gridProduct.dataset.wizzyAtcChecked === 'true') {
        return;
      }
  
      gridProduct.dataset.wizzyAtcChecked = 'true';
  
      const fetchUrl = wizzyGetCardFetchUrl(gridProduct);
  
      if (!fetchUrl) {
        return;
      }
  
      requests.push(
        fetch(fetchUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (htmlText) {
            const html = new DOMParser().parseFromString(htmlText, 'text/html');
            const hasSizeLabels = html.querySelector('.cstm_collection_add');
  
            if (!hasSizeLabels) {
              return;
            }
  
            const newAddBtn = html.querySelector('.addtocartbtn');
            const newColorSwitch = html.querySelector('.color-switch');
            const oldAddBtn = content.querySelector('.addtocartbtn');
            const oldColorSwitch = content.querySelector('.color-switch');
  
            if (newAddBtn && oldAddBtn) {
              oldAddBtn.replaceWith(newAddBtn.cloneNode(true));
            }
  
            if (newColorSwitch) {
              if (oldColorSwitch) {
                oldColorSwitch.replaceWith(newColorSwitch.cloneNode(true));
              } else {
                content.appendChild(newColorSwitch.cloneNode(true));
              }
            }
  
            content.dataset.wizzySizesLoaded = 'true';
          })
          .catch(function () {})
      );
    });
  
    return Promise.all(requests);
  }
  
  var WIZZY_TILE_VIEW_STORAGE_KEY = 'wizzy-custom-tile-view-level';
  
  function wizzyRefreshProductCardSliders() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
      return;
    }
  
    setTimeout(function () {
      wizzyInitProductImageSlidersIn(document);
  
      jQuery(
        '.wizzy-search-results-list .wizzy-product-card-slider, .wizzy-search-results .wizzy-product-card-slider, .wizzy-search-wrapper .wizzy-product-card-slider'
      ).each(function () {
        if (jQuery(this).hasClass('slick-initialized')) {
          jQuery(this).slick('setPosition');
        }
      });
    }, 50);
  }
  
  function wizzySetTileViewLevel(level, options) {
    options = options || {};
    const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  
    if (!wrapper || level == null) {
      return;
    }
  
    const levelStr = String(level);
    wrapper.setAttribute('wizzy-tile-view-level', levelStr);
  
    try {
      localStorage.setItem(WIZZY_TILE_VIEW_STORAGE_KEY, levelStr);
    } catch (error) {}
  
    if (options.updateActiveIcon !== false) {
      const activeIcon =
        options.activeIcon ||
        document.querySelector('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
      wizzySetActiveGridView(activeIcon);
    }
  
    wizzyRefreshProductCardSliders();
  }
  
  function wizzyRestoreTileViewLevel() {
    const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
  
    if (!wrapper) {
      return;
    }
  
    let level = null;
  
    try {
      level = localStorage.getItem(WIZZY_TILE_VIEW_STORAGE_KEY);
    } catch (error) {}
  
    if (!level) {
      level = wrapper.getAttribute('wizzy-tile-view-level') || '1';
    }
  
    wizzySetTileViewLevel(level, { updateActiveIcon: true });
  }
  
  function wizzySyncMobileFilterLabel() {
    document.querySelectorAll('.wizzy-search-wrapper .wz-active-filters-mobile-count').forEach(function (countEl) {
      var raw = countEl.textContent.trim().replace(/[()]/g, '').trim();
  
      if (raw && raw !== '0') {
        countEl.textContent = ' (' + raw + ')';
      } else {
        countEl.textContent = '';
      }
    });
  }
  
  function wizzySyncApplyFilterButtonState() {
    var applyButtons = document.querySelectorAll(
      '.wizzy-search-wrapper .wizzy-apply-all-button, .wizzy-search-wrapper .wizzy-riyaasat-apply-filter'
    );
  
    if (!applyButtons.length) {
      return;
    }
  
    var hasSelection = false;
  
    if (wizzyIsSlpPage()) {
      var applied = wizzySlpGetAppliedFilterIds();
      var pending = wizzySlpGetPendingFilterIds();
      hasSelection =
        pending.size > 0 ||
        wizzySlpGetFacetItemsToToggle(applied, pending).length > 0 ||
        !!window.wizzySlpHasPendingChanges;
    } else {
      hasSelection = !!document.querySelector(
        '.wizzy-search-filters-left .wizzy-facet-list-item input[type="checkbox"]:checked'
      );
    }
  
    applyButtons.forEach(function (btn) {
      btn.classList.toggle('wizzy-apply-filter--active', hasSelection);
    });
  }
  
  function wizzySetActiveGridView(activeIcon) {
    const toggleIcon =
      activeIcon || document.querySelector('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
  
    if (toggleIcon) {
      toggleIcon.classList.add('active');
    }
  }
  
  function wizzyFormatPriceValue(value) {
    if (value == null || value === '') {
      return '';
    }
  
    var str = String(value).trim();
  
    if (str.indexOf('₹') !== -1) {
      return str;
    }
  
    var num = parseFloat(str.replace(/,/g, ''));
  
    if (isNaN(num)) {
      return str;
    }
  
    return (
      '₹' +
      num.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    );
  }
  
  function wizzyGetPriceSliderValues(slider) {
    if (!slider) {
      return { min: '', max: '' };
    }
  
    if (slider.noUiSlider) {
      var values = slider.noUiSlider.get();
  
      return {
        min: wizzyFormatPriceValue(values[0]),
        max: wizzyFormatPriceValue(values[1]),
      };
    }
  
    var tooltips = slider.querySelectorAll('.noUi-tooltip');
  
    if (tooltips.length >= 2) {
      return {
        min: wizzyFormatPriceValue(tooltips[0].textContent),
        max: wizzyFormatPriceValue(tooltips[1].textContent),
      };
    }
  
    var handles = slider.querySelectorAll('.noUi-handle');
  
    if (handles.length >= 2) {
      return {
        min: wizzyFormatPriceValue(handles[0].getAttribute('aria-valuenow')),
        max: wizzyFormatPriceValue(handles[1].getAttribute('aria-valuenow')),
      };
    }
  
    return { min: '', max: '' };
  }
  
  function wizzySyncPriceRangeFields(body) {
    var slider = body.querySelector('.noUi-target');
  
    if (!slider) {
      return;
    }
  
    var values = wizzyGetPriceSliderValues(slider);
    var minInput = body.querySelector('.wizzy-price-range-input-min');
    var maxInput = body.querySelector('.wizzy-price-range-input-max');
    var bottomMin = body.querySelector('.wizzy-price-range-bottom-min');
    var bottomMax = body.querySelector('.wizzy-price-range-bottom-max');
  
    if (minInput) {
      minInput.value = values.min;
    }
  
    if (maxInput) {
      maxInput.value = values.max;
    }
  
    if (bottomMin) {
      bottomMin.textContent = values.min;
    }
  
    if (bottomMax) {
      bottomMax.textContent = values.max;
    }
  }
  
  function wizzyEnhancePriceFilterUI() {
    if (window.innerWidth > 768) {
      return;
    }
  
    document
      .querySelectorAll('.wizzy-search-filters-left.wizzy-v2 .facet-body-sellingPrice')
      .forEach(function (body) {
        var rangeItem = body.querySelector('.facet-range-item');
        var slider = body.querySelector('.noUi-target');
  
        if (!rangeItem || !slider) {
          return;
        }
  
        if (!body.querySelector('.wizzy-price-range-ui')) {
          var ui = document.createElement('div');
          ui.className = 'wizzy-price-range-ui';
  
          ui.innerHTML =
            '<div class="wizzy-price-range-header">Select Price Range</div>' +
            '<div class="wizzy-price-range-fields">' +
            '<label class="wizzy-price-range-field wizzy-price-range-field--min">' +
            '<span class="wizzy-price-range-field__label">Min</span>' +
            '<input type="text" class="wizzy-price-range-field__input wizzy-price-range-input-min" readonly />' +
            '</label>' +
            '<label class="wizzy-price-range-field wizzy-price-range-field--max">' +
            '<span class="wizzy-price-range-field__label">Max</span>' +
            '<input type="text" class="wizzy-price-range-field__input wizzy-price-range-input-max" readonly />' +
            '</label>' +
            '</div>' +
            '<div class="wizzy-price-range-slider-wrap"></div>' +
            '<div class="wizzy-price-range-bottom-values">' +
            '<span class="wizzy-price-range-bottom-min"></span>' +
            '<span class="wizzy-price-range-bottom-max"></span>' +
            '</div>';
  
          var sliderWrap = ui.querySelector('.wizzy-price-range-slider-wrap');
          var sliderParent = slider.parentNode;
  
          rangeItem.insertBefore(ui, rangeItem.firstChild);
  
          if (sliderParent === rangeItem) {
            sliderWrap.appendChild(slider);
          } else {
            sliderWrap.appendChild(sliderParent);
          }
        }
  
        wizzySyncPriceRangeFields(body);
  
        if (slider.noUiSlider && !slider.dataset.wizzyPriceBound) {
          slider.dataset.wizzyPriceBound = 'true';
          slider.noUiSlider.on('update', function () {
            wizzySyncPriceRangeFields(body);
          });
        } else if (!body.dataset.wizzyPriceObserverBound) {
          body.dataset.wizzyPriceObserverBound = 'true';
          var observer = new MutationObserver(function () {
            wizzySyncPriceRangeFields(body);
          });
          observer.observe(slider, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['aria-valuenow'],
          });
        }
      });
  }
  
  function wizzyInitFacetSectionSearch(scopeEl) {
    var root = scopeEl || document;
    root.querySelectorAll('.wizzy-filters-facet-block').forEach(function (block) {
      var input = block.querySelector('input.facet-head-search-input');
      var list = block.querySelector('ul.wizzy-facet-list');
      if (!input || !list) return;
  
      if (input.__wzBound) return;
      input.__wzBound = true;
  
      var iconLink = block.querySelector('.facet-search-wrapper .facet-head-search a.facet-head-search-icon');
      if (iconLink && !iconLink.__wzBound) {
        iconLink.__wzBound = true;
        iconLink.addEventListener('click', function (e) {
          try {
            e.preventDefault();
            e.stopPropagation();
          } catch (e0) {}
          try {
            input.focus();
          } catch (e1) {}
        });
      }
  
      var onInput = function () {
        var q = (input.value || '').trim().toLowerCase();
        var items = list.querySelectorAll('.wizzy-facet-list-item');
        items.forEach(function (li) {
          var term = (li.getAttribute('data-term') || li.textContent || '').toLowerCase();
          var match = !q || term.indexOf(q) !== -1;
          li.style.display = match ? '' : 'none';
        });
      };
  
      input.addEventListener('input', onInput);
    });
  }
  
  function wizzyInitMobileFilterBar() {
    if (window.wizzyMobileFilterBarBound) {
      return;
    }
  
    window.wizzyMobileFilterBarBound = true;
  
    document.addEventListener('click', function (event) {
      const drawerCloseBtn = event.target.closest('.wizzy-search-wrapper .wizzy-mobile-filter-drawer-close');
  
      if (drawerCloseBtn) {
        event.preventDefault();
        const wrapper = drawerCloseBtn.closest('.wizzy-search-filters-left');
        const closeTrigger =
          (wrapper && wrapper.querySelector('.wizzy-filters-close-btn')) ||
          (wrapper && wrapper.querySelector('.wizzy-filters-close-button')) ||
          document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-btn');
  
        if (closeTrigger) {
          closeTrigger.click();
        }
  
        return;
      }
  
      const filterOpenBtn = event.target.closest('.wizzy-search-wrapper .wizzy-filters-mobile-entry');
  
      if (filterOpenBtn) {
        setTimeout(function () {
          // wizzyInitFacetSectionSearch();
          wizzyEnhancePriceFilterUI();
          wizzySlpSyncPendingFromApplied();
          wizzySyncApplyFilterButtonState();
        }, 150);
      }
  
      const facetHead = event.target.closest('.wizzy-search-filters-left.wizzy-v2 .wizzy-facet-head');
  
      // if (facetHead) {
      //   setTimeout(wizzyInitFacetSectionSearch, 80);
      // }
  
      const tileViewToggle = event.target.closest('.wizzy-search-wrapper [data-wizzy-tile-view-toggle]');
  
      if (tileViewToggle) {
        event.preventDefault();
        const wrapper = document.querySelector('.wizzy-search-wrapper.display-tile-view');
        const currentLevel = wrapper ? wrapper.getAttribute('wizzy-tile-view-level') : '2';
        const newLevel = currentLevel === '1' ? '2' : '1';
  
        wizzySetTileViewLevel(newLevel, { activeIcon: tileViewToggle });
        return;
      }
    });
  }
  
  function wizzyInitQuickAddToggle() {
    if (window.wizzyQuickAddToggleBound) return;
    window.wizzyQuickAddToggleBound = true;
  
    document.addEventListener('click', function (event) {
      const button = event.target.closest(
        '.wizzy-search-results-list .btn-custom.select-switchs, .wizzy-search-wrapper .btn-custom.select-switchs'
      );
      if (!button) return;
  
      const gridProduct = button.closest('.grid-product');
      const colorSwitch = gridProduct ? gridProduct.querySelector('.color-switch') : null;
      if (!gridProduct) return;
  
      // ── NEW: check if this product has any size options ──────────────────
      const hasSizes = colorSwitch &&
        colorSwitch.querySelectorAll('.cstm_collection_add').length > 0;
  
      if (!hasSizes) {
        // No sizes — add to cart directly using the variant on the card
        event.stopImmediatePropagation();
        const variantId = gridProduct.getAttribute('data-variant-id');
        if (!variantId) return;
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            // Trigger whatever cart-open / mini-cart event your theme uses, e.g.:
            document.dispatchEvent(new CustomEvent('cart:updated'));
            // Or if your theme uses jQuery:
            // jQuery(document.body).trigger('added.wb.product', [variantId]);
          })
          .catch(function (err) { console.error('Wizzy direct ATC error:', err); });
  
        return; // ← don't open the drawer
      }
      // ── END NEW ──────────────────────────────────────────────────────────
  
      const activeSwatch = gridProduct.querySelector('a.product-color-swatch--active');
      const content = gridProduct.querySelector('.grid-product__content');
  
      function wizzyToggleQuickAddPanel() {
        colorSwitch.classList.toggle('switch-height');
        button.classList.toggle('switch-height');
        const iconPlus = button.querySelector('.icon-plus');
        const iconMinus = button.querySelector('.icon-minus');
        if (iconPlus) iconPlus.style.display = colorSwitch.classList.contains('switch-height') ? 'none' : '';
        if (iconMinus) iconMinus.style.display = colorSwitch.classList.contains('switch-height') ? '' : 'none';
      }
  
      function wizzyOpenQuickAddPanel() {
        if (content && content.dataset.wizzySizesLoaded !== 'true') {
          wizzyLoadSizedProductCard(gridProduct).then(wizzyToggleQuickAddPanel);
          return;
        }
  
        wizzyToggleQuickAddPanel();
      }
  
      event.stopImmediatePropagation();
  
      if (button.classList.contains('switch-height')) {
        wizzyToggleQuickAddPanel();
        return;
      }
  
      if (activeSwatch) {
        jQuery(document).one('colorChangeCompleted', function () {
          wizzyOpenQuickAddPanel();
        });
        activeSwatch.click();
        return;
      }
  
      wizzyOpenQuickAddPanel();
    }, true);
  }
  function wizzyIsSlpPage() {
    return !!document.querySelector('.wizzy-search-wrapper');
  }
  function wizzySyncAppliedFilterCounts() {
    const selectedItems = document.querySelectorAll(
      '.wizzy-selected-filters .wizzy-selected-facet-list-item'
    );
  
    selectedItems.forEach(function (selectedItem) {
      const facetKey = selectedItem.getAttribute('data-facetKey');
      const itemKey = selectedItem.getAttribute('data-key');
      const term = selectedItem.getAttribute('data-term');
  
      let matchedFacetItem = null;
  
      document
        .querySelectorAll('.wizzy-search-filters-left .wizzy-filters-facet-block')
        .forEach(function (facetBlock) {
          if (matchedFacetItem) return;
  
          const blockKey = facetBlock.getAttribute('data-key');
  
          // Make sure we are checking the same filter group.
          if (facetKey && blockKey && facetKey !== blockKey) {
            return;
          }
  
          facetBlock
            .querySelectorAll('.wizzy-facet-list-item')
            .forEach(function (facetItem) {
              if (matchedFacetItem) return;
  
              const currentKey = facetItem.getAttribute('data-key');
              const currentTerm = facetItem.getAttribute('data-term');
  
              if (
                (itemKey && currentKey === itemKey) ||
                (term && currentTerm === term)
              ) {
                matchedFacetItem = facetItem;
              }
            });
        });
  
      if (!matchedFacetItem) return;
  
      const countElement = matchedFacetItem.querySelector(
        '.wizzy-facet-list-item-count'
      );
  
      const selectedLabel = selectedItem.querySelector(
        '.facet-item-label-value'
      );
  
      if (!countElement || !selectedLabel) return;
  
      const countText = countElement.textContent.trim();
  
      if (!countText) return;
  
      let appliedCount = selectedLabel.querySelector(
        '.wizzy-selected-facet-count'
      );
  
      if (!appliedCount) {
        appliedCount = document.createElement('span');
        appliedCount.className = 'wizzy-selected-facet-count';
        selectedLabel.appendChild(appliedCount);
      }
  
      appliedCount.textContent = ' ' + countText;
    });
  }
  function wizzySlpGetFacetItemId(item) {
    const block = item.closest('.wizzy-filters-facet-block');
    const facetKey = block ? block.getAttribute('data-key') || '' : '';
    return facetKey + '::' + (item.getAttribute('data-key') || '') + '::' + (item.getAttribute('data-term') || '');
  }
  
  function wizzySlpGetAppliedFilterIds() {
    const applied = new Set();
    document.querySelectorAll('.wizzy-search-wrapper .wizzy-selected-filters .wizzy-selected-facet-list-item').forEach(function (tag) {
      applied.add(
        (tag.getAttribute('data-facetKey') || '') + '::' +
        (tag.getAttribute('data-key') || '') + '::' +
        (tag.getAttribute('data-term') || '')
      );
    });
    return applied;
  }
  
  function wizzySlpGetPendingFilterIds() {
    const pending = new Set();
    document.querySelectorAll('.wizzy-search-filters-left .wizzy-filters-facet-block').forEach(function (block) {
      const facetKey = block.getAttribute('data-key') || '';
      block.querySelectorAll('.wizzy-facet-list-item').forEach(function (item) {
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          pending.add(facetKey + '::' + (item.getAttribute('data-key') || '') + '::' + (item.getAttribute('data-term') || ''));
        }
      });
    });
    return pending;
  }
  
  function wizzySlpToggleFacetItemUI(item, checked) {
    const checkbox = item.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.checked = checked;
    }
    item.classList.toggle('active', checked);
  }
  
  function wizzySlpSyncPendingFromApplied() {
    if (!wizzyIsSlpPage() || window.wizzySlpHasPendingChanges) {
      return;
    }
  
    const applied = wizzySlpGetAppliedFilterIds();
    document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
      wizzySlpToggleFacetItemUI(item, applied.has(wizzySlpGetFacetItemId(item)));
    });
    wizzySyncApplyFilterButtonState();
  }
  
  function wizzySlpResetPendingFacetUI() {
    document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
      wizzySlpToggleFacetItemUI(item, false);
    });
  }
  
  function wizzySlpGetFacetItemsToToggle(applied, pending) {
    const items = [];
    document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
      const id = wizzySlpGetFacetItemId(item);
      const isApplied = applied.has(id);
      const isPending = pending.has(id);
      if (isApplied !== isPending) {
        items.push(item);
      }
    });
    return items;
  }
  
  function wizzySlpCloseMobileFilterDrawer() {
    const closeTrigger =
      document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-btn') ||
      document.querySelector('.wizzy-search-wrapper .wizzy-filters-close-button');
    if (closeTrigger) {
      closeTrigger.click();
    }
  }
  
  function wizzySlpApplyPendingFilters() {
    const applied = wizzySlpGetAppliedFilterIds();
    const pending = wizzySlpGetPendingFilterIds();
  
    document.querySelectorAll('.wizzy-search-filters-left .wizzy-facet-list-item').forEach(function (item) {
      wizzySlpToggleFacetItemUI(item, applied.has(wizzySlpGetFacetItemId(item)));
    });
  
    const itemsToToggle = wizzySlpGetFacetItemsToToggle(applied, pending);
  
    if (!itemsToToggle.length) {
      wizzySlpCloseMobileFilterDrawer();
      window.wizzySlpHasPendingChanges = false;
      wizzySyncApplyFilterButtonState();
      return;
    }
  
    window.wizzySlpApplyingFilters = true;
  
    itemsToToggle.forEach(function (item, index) {
      window.wizzySlpAllowFilterExecution = index === itemsToToggle.length - 1;
      item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  
    window.wizzySlpHasPendingChanges = false;
  
    setTimeout(function () {
      window.wizzySlpApplyingFilters = false;
      window.wizzySlpAllowFilterExecution = false;
      wizzySlpSyncPendingFromApplied();
      wizzySyncApplyFilterButtonState();
      wizzySlpCloseMobileFilterDrawer();
    }, 300);
  }
  
  function wizzyInitSlpManualFilters() {
    if (window.wizzySlpManualFiltersBound) {
      return;
    }
  
    window.wizzySlpManualFiltersBound = true;
    window.wizzySlpHasPendingChanges = false;
    window.wizzySlpApplyingFilters = false;
    window.wizzySlpAllowFilterExecution = false;
  
    document.addEventListener('click', function (event) {
      if (!wizzyIsSlpPage() || window.wizzySlpApplyingFilters) {
        return;
      }
  
      if (event.target.closest('.wizzy-apply-all-button, .wizzy-riyaasat-apply-filter')) {
        event.preventDefault();
        wizzySlpApplyPendingFilters();
        return;
      }
  
      if (event.target.closest('.wizzy-filters-clear-all, .wizzy-riyaasat-clear-all')) {
        const applied = wizzySlpGetAppliedFilterIds();
  
        if (!applied.size) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          wizzySlpResetPendingFacetUI();
          window.wizzySlpHasPendingChanges = false;
          wizzySyncApplyFilterButtonState();
          return;
        }
  
        window.wizzySlpAllowFilterExecution = true;
        window.wizzySlpHasPendingChanges = false;
        setTimeout(function () {
          wizzySlpResetPendingFacetUI();
          window.wizzySlpAllowFilterExecution = false;
          wizzySyncApplyFilterButtonState();
        }, 300);
        return;
      }
  
      if (event.target.closest('.wizzy-selected-facet-list-item, .wizzy-selected-facet-delete')) {
        window.wizzySlpAllowFilterExecution = true;
        window.wizzySlpHasPendingChanges = false;
        setTimeout(function () {
          wizzySlpSyncPendingFromApplied();
          window.wizzySlpAllowFilterExecution = false;
          wizzySyncApplyFilterButtonState();
        }, 300);
        return;
      }
  
      const item = event.target.closest('.wizzy-search-filters-left .wizzy-facet-list-item');
      if (!item) {
        return;
      }
  
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
  
      const checkbox = item.querySelector('input[type="checkbox"]');
      wizzySlpToggleFacetItemUI(item, !(checkbox && checkbox.checked));
      window.wizzySlpHasPendingChanges = true;
      wizzySyncApplyFilterButtonState();
    }, true);
  }
  
  window.onWizzyScriptLoaded = function () {
  
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(products) {
      if (Array.isArray(products)) {
        products.forEach(function (product) {
          wizzyEnrichProduct(product);
  
          if (product.attributes && product.attributes.length > 0) {
            product.attributes.forEach(function (attr) {
              if (attr.id === 'product_faq_text_custom') {
                product.faqText = attr.values[0].value[0];
              }
  
                        if (attr.id === "product_tags") {
                var tags = attr?.values?.[0]?.value?.[0] || "";
  
                var tagList = tags.split(",").map(function (t) {
                  return t.trim().toLowerCase();
                });
  
                if (tagList.indexOf("new") !== -1) {
                  product.newTag = true;
                }
  
                if (tagList.indexOf("bestseller") !== -1 || tagList.indexOf("bestsellers") !== -1) {
                  product.bestsellerTag = true;
                }
              }
  
  
  
  
              if (attr.id === 'product_badge_judgeme') {
                var badgeHtml = (attr.values && attr.values[0] && attr.values[0].value && attr.values[0].value[0]) || '';
                var ratingMatch = String(badgeHtml).match(/data-average-rating=['"]([\d.]+)['"]/i);
                var countMatch = String(badgeHtml).match(/data-number-of-reviews=['"](\d+)['"]/i);
                var rating = ratingMatch ? parseFloat(ratingMatch[1]) : NaN;
                var count = countMatch ? parseInt(countMatch[1], 10) : NaN;

                if (!isNaN(rating) && !isNaN(count) && count > 0 && rating > 0) {
                  product.hasReviews = true;
                  product.reviewRating = rating;
                  product.reviewCount = count;
                  product.reviewRatingDisplay = rating.toFixed(1);
                }
              }

              if (attr.id === 'product_product_type') {
                product.productType = attr.values[0].value[0];
              }
  
            });
          }
        });
      }
  
      return products;
    });
  
    const wizzyEvents = window.wizzyConfig.events;
    const allowedEvents = wizzyEvents.allowedEvents;
  
    ['AFTER_PRODUCTS_TRANSFORMED', 'AFTER_PRODUCTS_TRANSFORM', 'BEFORE_PRODUCTS_RENDER'].forEach(function (eventName) {
      if (!allowedEvents[eventName]) {
        return;
      }
  
      wizzyEvents.registerEvent(
        allowedEvents[eventName],
        function (data) {
          return wizzyTransformProducts(data);
        },
        2
      );
  
      if (window.wizzyConfig.events.allowedEvents[eventName]) {
        window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents[eventName],
          function (data) {
            return wizzyTransformProducts(data);
          },
          2
        );
      }
    });
  
    if (allowedEvents.BEFORE_PRODUCTS_RENDER) {
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_PRODUCTS_RENDER,
        function (data) {
          var products = wizzyCollectProducts(data);
  
          if (!products.length) {
            return data;
          }
  
          products.forEach(function (product) {
            wizzyNormalizeVariantImages(product);
          });
  
          return data;
        },
        3
      );
    }
    wizzyEvents.registerEvent(
      allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (data) {
  
           // Include OOS products in autocomplete so Sold Out tag can render on suggestions.
        data.includeOutOfStock = 'true';
        data.variantsGroupBy = "virtualGroupId";
  
        return data;
      });
    wizzyEvents.registerEvent(
      allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
      // data.variantsGroupBy = "virtualGroupId";
        wizzyHideAutocomplete(); 
        const searchClose = document.getElementById('SearchClose');
  
        if (searchClose) {
          searchClose.click();
        }
        const collectionHeader = document.querySelector(
          '.shopify-section[id$="__collection-header"]'
        );
  
        if (collectionHeader) {
          collectionHeader.style.display = "none";
        }
  
        const faqSection = document.querySelector(
    '[class*="__collection_revamp_faq_"]'
  );
  
          if (faqSection) {
            faqSection.style.display = "none";
          }
  
          data.includeOutOfStock = 'true';
          data.getAllVariants = 'false';
          data.showOOSProductsInOrder = 'false';
  
          data.sort.push(
            {"field":"product_wizzy-best-selling_sortOrder:float","order":"asc"}
          );
  
                return data;
              },
              2
            );
  
    function addWizzySortCloseButton() {
      document
        .querySelectorAll('.wizzy-search-sort-wrapper .wizzy-common-select-options')
        .forEach(function (sortOptions) {
          if (sortOptions.querySelector('.wizzy-sort-popup-close-icon')) return;
  
          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'wizzy-sort-popup-close-icon';
          closeBtn.innerHTML = '&times;';
  
          closeBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
  
            const sortContainer = closeBtn.closest('.wizzy-common-select-container');
            const sortSelector = sortContainer ? sortContainer.querySelector('.wizzy-common-select-selector') : null;
            const sortOverlay = sortContainer ? sortContainer.querySelector('.wizzy-common-select-overlay') : null;
  
            if (sortOverlay) {
              sortOverlay.click();
            } else if (sortSelector) {
              sortSelector.click();
            }
  
            sortOptions.style.display = 'none';
            document.body.classList.remove('wizzy-common-select-body-overlay');
          });
  
          sortOptions.prepend(closeBtn);
        });
    }
  
    // document.addEventListener('click', function () {
    //   setTimeout(addWizzySortCloseButton, 50);
    // });
  
    // addWizzySortCloseButton();
  
    function initWizzyAutocompleteBodyClass() {
      const targetNode = document.querySelector('.wizzy-body-end-wrapper');
      if (!targetNode) return;
  
      function updateAutocompleteClass() {
        const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
        const isOpen = autocompleteElement && window.getComputedStyle(autocompleteElement).display !== 'none';
  
        document.body.classList.toggle('wizzy-autocomplete-open', !!isOpen);
        document.documentElement.classList.toggle('wizzy-autocomplete-open', !!isOpen);
      }
  
      const observer = new MutationObserver(function () {
        updateAutocompleteClass();
      });
  
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
  
      updateAutocompleteClass();
    }
  
    function initWizzyProductCardSliders() {
      wizzyInitProductImageSlidersIn(document);
    }
  
    function initWizzyColorGridSliders() {
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
        return;
      }
  
      jQuery('.wizzy-search-results-list .collection-product-color-grid, .wizzy-search-results .collection-product-color-grid, .wizzy-search-wrapper .collection-product-color-grid').each(function () {
        const slider = jQuery(this);
  
        if (slider.hasClass('slick-initialized')) return;
        if (!slider.find('.custom-product-card__color-swatches-wrapper').length) return;
  
        slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          infinite: false,
          autoplay: false,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="11" stroke="#aaa" stroke-width="1" fill="none"/><path d="M14 8l-4 4 4 4" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="11" stroke="#aaa" stroke-width="1" fill="none"/><path d="M10 8l4 4-4 4" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 769, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 374, settings: { slidesToShow: 3, slidesToScroll: 1 } }
          ]
        });
      });
    }
  
    function initWizzyColorSwatches() {
      if (!window.jQuery) return;
  
      jQuery('.wizzy-search-results-list .color-swatch--with-image, .wizzy-search-results .color-swatch--with-image, .wizzy-search-wrapper .color-swatch--with-image').each(function () {
        const swatch = this;
  
        if (swatch.dataset.wizzySwatchBound === 'true') return;
        swatch.dataset.wizzySwatchBound = 'true';
  
        jQuery(swatch).on('click', function (event) {
          event.preventDefault();
  
          const target = event.currentTarget;
          const targetId = target.dataset.variantId;
          const productUrl = target.getAttribute('data-url');
          const colorLabel = target.getAttribute('data-value') || '';
  
          if (!targetId || !colorLabel || !productUrl) return;
  
          const productContent = target.closest('.grid-product__content');
          const colorsContainer = target.closest('.grid-product__colors');
  
          if (colorsContainer) {
            colorsContainer.querySelectorAll('.color-swatch').forEach(function (item) {
              item.classList.remove('active', 'product-color-swatch--active');
            });
          }
  
          target.classList.add('active', 'product-color-swatch--active');
  
          const gridProduct = target.closest('.grid-product');
  
          if (gridProduct) {
            gridProduct.setAttribute('data-variant-id', targetId);
  
            const quickAddBtn = productContent ? productContent.querySelector('.withoutSIzeVariants') : null;
  
            if (quickAddBtn) {
              quickAddBtn.setAttribute('vid-product-id', targetId);
            }
  
            wizzyUpdateProductLinks(productContent, targetId, productUrl);
          }
  
          const allImages = wizzyGetStoredProductAllImages(gridProduct);
          var resolvedImages = wizzyGetOrderedColorImages(allImages, colorLabel);
  
          if (!resolvedImages.length) {
            var swatchImage =
              target.getAttribute('data-variant-image') ||
              (target.querySelector('img') && target.querySelector('img').getAttribute('src')) ||
              '';
  
            if (swatchImage) {
              resolvedImages = [swatchImage];
            }
          }
  
          if (resolvedImages.length && productContent) {
            wizzyStoreProductGallery(
              [
                targetId,
                gridProduct.getAttribute('data-product-id'),
                gridProduct.getAttribute('data-id'),
                gridProduct.getAttribute('data-groupId')
              ],
              resolvedImages
            );
            gridProduct.dataset.wizzyGalleryBound = 'false';
            wizzyUpdateProductCardImagesFromUrls(productContent, resolvedImages, {
              heroOnly: true
            });
            wizzyBindProductCardGalleryOnDemand(gridProduct);
          }
  
          if (gridProduct) {
            if (allImages.length) {
              window.wizzyProductAllImagesById = window.wizzyProductAllImagesById || {};
              window.wizzyProductAllImagesById[String(targetId)] = allImages.slice();
            }
  
            wizzyMarkVariantImageReady(gridProduct);
          }
  
          jQuery(document).trigger('colorChangeCompleted', [target]);
        });
      });
    }
  
    function initWizzySearchProductCards() {
      wizzyInitMobileFilterBar();
      // wizzyInitFacetSectionSearch();
      wizzyEnhancePriceFilterUI();
      wizzyRestoreTileViewLevel();
      wizzyInitQuickAddToggle();
      wizzySyncMobileFilterLabel();
  
      var metaPromise = wizzyInitProductCardMeta().then(function () {
        wizzyRevealProductRatings();
      });
  
      // Sizes already render from Wizzy cardSizes. Do not fetch view=card for every
      // card on load. wizzyOpenQuickAddPanel still calls wizzyLoadSizedProductCard
      // for the one product the user opens.
      wizzyUpgradeDirectAddCards();
  
      initWizzyProductCardSliders();
      initWizzyColorGridSliders();
      initWizzyColorSwatches();
      wizzyInitInitialVariantImages();
      wizzyInitProductCardGalleriesOnDemand(document);
  
      return metaPromise;
    }
  
    function wizzyFixPaginationLikeRiyaasat() {
      const pagesBefore = 1;
      const pagesAfter = 2;
  
      const pagination = document.querySelector('.wizzy-search-pagination .wizzy-pagination-list');
      if (!pagination) return;
  
      const activePageEl = pagination.querySelector('li.active[data-page]');
      const pageEls = Array.from(pagination.querySelectorAll('li[data-page]'));
  
      if (!activePageEl || !pageEls.length) return;
  
      const activePage = parseInt(activePageEl.dataset.page, 10);
      const lastPage = Math.max(
        ...pageEls
          .map(function (li) {
            return parseInt(li.dataset.page, 10);
          })
          .filter(Boolean)
      );
  
      if (!activePage || !lastPage) return;
  
      const pages = new Set([1, lastPage]);
  
      for (let i = activePage - pagesBefore; i <= activePage + pagesAfter; i++) {
        if (i >= 1 && i <= lastPage) {
          pages.add(i);
        }
      }
  
      const sortedPages = Array.from(pages).sort(function (a, b) {
        return a - b;
      });
  
      const nextArrow = pagination.querySelector('.next-arrow');
  
      pagination.querySelectorAll('li:not(.pagination-arrow)').forEach(function (li) {
        li.remove();
      });
  
      sortedPages.forEach(function (page, index) {
        const previousPage = sortedPages[index - 1];
  
        if (index > 0 && page - previousPage > 1) {
          const dots = document.createElement('li');
          dots.className = 'wizzy-pagination-dots';
          dots.innerHTML = '<a><span class="text">...</span></a>';
          pagination.insertBefore(dots, nextArrow);
        }
  
        const li = document.createElement('li');
        li.setAttribute('title', String(page));
        li.setAttribute('data-page', String(page));
  
        if (page === activePage) {
          li.classList.add('active');
        }
  
        li.innerHTML = '<a href="#"><span class="text">' + page + '</span></a>';
        pagination.insertBefore(li, nextArrow);
      });
    }
  
    function wizzyRemovePageFromUrl() {
      if (!window.location.search.includes('page=')) return;
  
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_INIT,
        function (data) {
          if (data.search && data.search.configs && data.search.configs.pagination) {
            data.search.configs.pagination.appendInExistingList = window.innerWidth <= 768;
          }
  
          data.filters.configs.keepOpenedInMobileAfterApply = !0;
          data.filters.configs.applyOnSelect = !1;
          data.search.configs.pagination.appendInExistingList = !0,
          window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 2000, mobile: 2500
        }
  
  
          return data;
        },
        2
      );
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_RENDER_RESULTS,
        function (payload) {
          if (payload.api === 'search' || payload.api === 'filter') {
            var products =
              payload.response &&
              payload.response.payload &&
              payload.response.payload.products;
  
            if (products && products.length) {
              products.forEach(wizzyEnrichProduct);
            }
          }
  
          return payload;
        },
        1
      );
  
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_RENDER_RESULTS,
        function (payload) {
  
      if (payload.api === "search" || payload.api === "filter") {
        const facets = payload.response.payload.facets;
  
        facets?.forEach((facet) => {
          if (facet.key === "colors") {
            const facetData = facet.data;
  
            facetData?.forEach((item) => {
              const color = colorMap[item.label] || "#fff";
  
              item.isSwatch = true;
              item.isURLSwatch = false;
              item.isVisualSwatch = true;
              item.swatchValue = color;
  
              item.data = {
                value: item.key,
                swatch: {
                  type: "visual",
                  value: color,
                },
              };
  
              item.code = color;
            });
          }
        });
      }
  
  
      return payload;
    }
  );
  
    
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_LAZY_INIT,
        function (data) {
          if (data.search && data.search.configs && data.search.configs.pagination) {
            data.search.configs.pagination.appendInExistingList = window.innerWidth <= 768;
          }
          data.filters.configs.keepOpenedInMobileAfterApply = !0;
          data.filters.configs.applyOnSelect = !1;
          return data;
        },
        2
      );
  
    if (allowedEvents.BEFORE_FILTERS_EXECUTED) {
      wizzyEvents.registerEvent(
        allowedEvents.BEFORE_FILTERS_EXECUTED,
        function (data) {
          // if (!wizzyIsSlpPage()) {
          //   return data;
          // }
  
          // if (!window.wizzySlpAllowFilterExecution) {
          //   return false;
          // }
          if(window.wizzyConfig.common.isOnCategoryPage || data.group === "defaultMenu") {
            data.filters.variantsGroupBy = "virtualGroupId";
          } else  {
            data.filters.inStock = ['true','false'];
            data.filters.getAllVariants = 'false';
            data.filters.showOOSProductsInOrder = 'false';
          }
  
          return data;
        },
        2
      );
    }
  
    wizzyInitSlpManualFilters();
    
  
    ['VIEW_RENDERED', 'PRODUCTS_RESULTS_RENDERED', 'PRODUCTS_CACHED_RESULTS_RENDERED'].forEach(function (eventName) {
      if (!allowedEvents[eventName]) return;
  
      wizzyEvents.registerEvent(
        allowedEvents[eventName],
        function (data) {
          setTimeout(function () {
            wizzyRemovePageFromUrl();
            wizzyFixPaginationLikeRiyaasat();
            initWizzySearchProductCards();
            wizzySyncMobileFilterLabel();
            wizzySlpSyncPendingFromApplied();
            wizzySyncApplyFilterButtonState();
            initWizzyProductCardSliders();
  
            // Add count to Applied Filter
          wizzySyncAppliedFilterCounts();
  
          }, 100);
  
          return data;
        },
        2
      );
    });
  
    setTimeout(initWizzyAutocompleteBodyClass, 1000);
    setTimeout(initWizzySearchProductCards, 500);
  
  
  
  
  
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
  
  //       if (window.innerWidth <= 767) {
  //   const gridLayout = document.querySelector(
  //     '.grid-layout.wizzy-mobile-grid-layout'
  //   );
  
  //   const sectionTitle = document.querySelector(
  //     '.section-header.section-header--flush .section-header__title'
  //   );
  
  //   if (gridLayout && sectionTitle) {
  //     sectionTitle.appendChild(gridLayout);
  //   }
  // }
  
  
  // function moveGridLayoutToBottomBar() {
  //   if (window.innerWidth > 767) return;
  
  //   const gridLayout = document.querySelector(
  //     '.grid-layout.wizzy-mobile-grid-layout'
  //   );
  
  //   const bottomBar = document.querySelector(
  //     '.wizzy-mobile-bottom-bar.collection-filter'
  //   );
  
  //   if (!gridLayout || !bottomBar) return;
  
  //   // Already moved
  //   if (gridLayout.parentElement === bottomBar) return;
  
  //   // Add Grid before Sort By and Filter
  //   bottomBar.prepend(gridLayout);
  // }
  
  // moveGridLayoutToBottomBar();
  
          document.querySelector('.wizzy-common-select-close')?.addEventListener('click', () => {
              document.querySelector('.wizzy-common-select-selector')?.click();
          });
  
  if (window.innerWidth > 768) {
    const parent = document.querySelector('.wizzy-search-filters-top');
    const filter = document?.querySelector('#collection-filter');
  
    if (parent && filter) {
      parent.insertBefore(filter, parent.firstChild);
    }
  }
        setTimeout(function () {
          wizzyRemovePageFromUrl();
          wizzyFixPaginationLikeRiyaasat();
        }, 50);
  
        return data;
      },
      2
    );
  
  
  
  setTimeout(initWizzyAutocompleteBodyClass, 1000);
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
      function (data) {
        setTimeout(function () {
          wizzyFixPaginationLikeRiyaasat();
          initWizzySearchProductCards();
        }, 50);
        return data;
      },
      2
    );
  
  
    
  };
  
  function wizzyHideAutocomplete() {
    var autocomplete =
      document.querySelector('.wizzy-autocomplete-wrapper') ||
      document.querySelector('.wizzy-body-end-wrapper .wizzy-autocomplete-wrapper');
  
    if (autocomplete) {
      autocomplete.style.display = 'none';
    }
  
    document.body.classList.remove('wizzy-autocomplete-open');
    document.documentElement.classList.remove('wizzy-autocomplete-open');
  }
  
  function wizzyRemovePageFromUrl() {
    if (!window.location.search.includes('page=')) return;
  
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
  }
  
  
  